'use strict';

runBlock.$inject = ["$rootScope", "AppSettings", "UsersTable", "ProjectsTable", "$interval", "$mdSidenav"];
materialTheme.$inject = ["$mdThemingProvider"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_hgyvc2s3y = function () {
    var path = '/home/lobo/repos/taskatone-app/src/index.js',
        hash = 'a4601ae0356963468f05812f372c892ac2234d5d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 19
                }
            },
            '1': {
                start: {
                    line: 38,
                    column: 4
                },
                end: {
                    line: 38,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 40,
                    column: 4
                },
                end: {
                    line: 44,
                    column: 6
                }
            },
            '3': {
                start: {
                    line: 41,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 99
                }
            },
            '4': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 75
                }
            },
            '5': {
                start: {
                    line: 43,
                    column: 1
                },
                end: {
                    line: 43,
                    column: 89
                }
            },
            '6': {
                start: {
                    line: 46,
                    column: 4
                },
                end: {
                    line: 62,
                    column: 6
                }
            },
            '7': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 61,
                    column: 11
                }
            },
            '8': {
                start: {
                    line: 48,
                    column: 12
                },
                end: {
                    line: 60,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 54,
                    column: 17
                }
            },
            '10': {
                start: {
                    line: 51,
                    column: 20
                },
                end: {
                    line: 51,
                    column: 80
                }
            },
            '11': {
                start: {
                    line: 52,
                    column: 23
                },
                end: {
                    line: 54,
                    column: 17
                }
            },
            '12': {
                start: {
                    line: 53,
                    column: 20
                },
                end: {
                    line: 53,
                    column: 56
                }
            },
            '13': {
                start: {
                    line: 55,
                    column: 16
                },
                end: {
                    line: 59,
                    column: 17
                }
            },
            '14': {
                start: {
                    line: 56,
                    column: 20
                },
                end: {
                    line: 58,
                    column: 23
                }
            },
            '15': {
                start: {
                    line: 57,
                    column: 24
                },
                end: {
                    line: 57,
                    column: 93
                }
            },
            '16': {
                start: {
                    line: 64,
                    column: 4
                },
                end: {
                    line: 66,
                    column: 6
                }
            },
            '17': {
                start: {
                    line: 65,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 41
                }
            },
            '18': {
                start: {
                    line: 68,
                    column: 4
                },
                end: {
                    line: 70,
                    column: 6
                }
            },
            '19': {
                start: {
                    line: 69,
                    column: 8
                },
                end: {
                    line: 69,
                    column: 42
                }
            },
            '20': {
                start: {
                    line: 72,
                    column: 4
                },
                end: {
                    line: 72,
                    column: 32
                }
            },
            '21': {
                start: {
                    line: 73,
                    column: 4
                },
                end: {
                    line: 76,
                    column: 7
                }
            },
            '22': {
                start: {
                    line: 74,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 68
                }
            },
            '23': {
                start: {
                    line: 74,
                    column: 24
                },
                end: {
                    line: 74,
                    column: 55
                }
            },
            '24': {
                start: {
                    line: 75,
                    column: 8
                },
                end: {
                    line: 75,
                    column: 40
                }
            },
            '25': {
                start: {
                    line: 82,
                    column: 24
                },
                end: {
                    line: 98,
                    column: 5
                }
            },
            '26': {
                start: {
                    line: 99,
                    column: 4
                },
                end: {
                    line: 101,
                    column: 27
                }
            },
            '27': {
                start: {
                    line: 103,
                    column: 23
                },
                end: {
                    line: 119,
                    column: 5
                }
            },
            '28': {
                start: {
                    line: 120,
                    column: 4
                },
                end: {
                    line: 122,
                    column: 26
                }
            },
            '29': {
                start: {
                    line: 124,
                    column: 21
                },
                end: {
                    line: 139,
                    column: 5
                }
            },
            '30': {
                start: {
                    line: 140,
                    column: 4
                },
                end: {
                    line: 142,
                    column: 24
                }
            },
            '31': {
                start: {
                    line: 145,
                    column: 4
                },
                end: {
                    line: 148,
                    column: 34
                }
            }
        },
        fnMap: {
            '0': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 37,
                        column: 9
                    },
                    end: {
                        line: 37,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 93
                    },
                    end: {
                        line: 77,
                        column: 1
                    }
                },
                line: 37
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 40,
                        column: 32
                    },
                    end: {
                        line: 40,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 44
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 40
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 46,
                        column: 36
                    },
                    end: {
                        line: 46,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 48
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                line: 46
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 47,
                        column: 33
                    },
                    end: {
                        line: 47,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 43
                    },
                    end: {
                        line: 61,
                        column: 9
                    }
                },
                line: 47
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 48,
                        column: 34
                    },
                    end: {
                        line: 48,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 44
                    },
                    end: {
                        line: 60,
                        column: 13
                    }
                },
                line: 48
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 56,
                        column: 34
                    },
                    end: {
                        line: 56,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 44
                    },
                    end: {
                        line: 58,
                        column: 21
                    }
                },
                line: 56
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 41
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                line: 64
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 68,
                        column: 30
                    },
                    end: {
                        line: 68,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 68,
                        column: 42
                    },
                    end: {
                        line: 70,
                        column: 5
                    }
                },
                line: 68
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 73,
                        column: 27
                    },
                    end: {
                        line: 73,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 73,
                        column: 33
                    },
                    end: {
                        line: 76,
                        column: 5
                    }
                },
                line: 73
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 74,
                        column: 18
                    },
                    end: {
                        line: 74,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 24
                    },
                    end: {
                        line: 74,
                        column: 55
                    }
                },
                line: 74
            },
            '10': {
                name: 'materialTheme',
                decl: {
                    start: {
                        line: 81,
                        column: 9
                    },
                    end: {
                        line: 81,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 43
                    },
                    end: {
                        line: 149,
                        column: 1
                    }
                },
                line: 81
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 50,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 50,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }, {
                    start: {
                        line: 50,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }],
                line: 50
            },
            '1': {
                loc: {
                    start: {
                        line: 50,
                        column: 20
                    },
                    end: {
                        line: 50,
                        column: 73
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 50,
                        column: 20
                    },
                    end: {
                        line: 50,
                        column: 35
                    }
                }, {
                    start: {
                        line: 50,
                        column: 39
                    },
                    end: {
                        line: 50,
                        column: 73
                    }
                }],
                line: 50
            },
            '2': {
                loc: {
                    start: {
                        line: 52,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 52,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }, {
                    start: {
                        line: 52,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }],
                line: 52
            },
            '3': {
                loc: {
                    start: {
                        line: 55,
                        column: 16
                    },
                    end: {
                        line: 59,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 55,
                        column: 16
                    },
                    end: {
                        line: 59,
                        column: 17
                    }
                }, {
                    start: {
                        line: 55,
                        column: 16
                    },
                    end: {
                        line: 59,
                        column: 17
                    }
                }],
                line: 55
            },
            '4': {
                loc: {
                    start: {
                        line: 55,
                        column: 20
                    },
                    end: {
                        line: 55,
                        column: 59
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 55,
                        column: 20
                    },
                    end: {
                        line: 55,
                        column: 27
                    }
                }, {
                    start: {
                        line: 55,
                        column: 31
                    },
                    end: {
                        line: 55,
                        column: 59
                    }
                }],
                line: 55
            },
            '5': {
                loc: {
                    start: {
                        line: 57,
                        column: 50
                    },
                    end: {
                        line: 57,
                        column: 92
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 57,
                        column: 80
                    },
                    end: {
                        line: 57,
                        column: 84
                    }
                }, {
                    start: {
                        line: 57,
                        column: 87
                    },
                    end: {
                        line: 57,
                        column: 92
                    }
                }],
                line: 57
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_hgyvc2s3y.s[0]++;
angular.module('app', ['ui.router', 'restmod', 'restmod.styles.drfPaged', 'ngMaterial', 'satellizer', 'ngFileUpload', 'cgBusy', 'angularMoment', 'angular-loading-bar', 'timer', 'ui.mask', 'angular.filter', 'mdPickers', 'angular-click-outside']).constant('moment', moment).constant('AppSettings', {
    appInProduction: false,
    appUrl: 'https://taskatone.soloweb.pt',
    apiUrl: 'https://api.taskatone.soloweb.pt',
    mediaUrl: 'https://api.taskatone.soloweb.pt/static/media'
}).value('cgBusyDefaults', {
    message: '',
    templateUrl: 'app/shared/html/cgbusy/cgbusy.template.html'
}).config(materialTheme)
/*.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
 cfpLoadingBarProvider.latencyThreshold = 10;
 }])*/
.run(runBlock);

/** @ngInject */
function runBlock($rootScope, AppSettings, UsersTable, ProjectsTable, $interval, $mdSidenav) {
    cov_hgyvc2s3y.f[0]++;
    cov_hgyvc2s3y.s[1]++;

    $rootScope.AppSettings = AppSettings;

    cov_hgyvc2s3y.s[2]++;
    $rootScope.loadStaticData = function () {
        cov_hgyvc2s3y.f[1]++;
        cov_hgyvc2s3y.s[3]++;

        $rootScope.users = UsersTable.$all = UsersTable.$search({ type: 'EMPLOYEE', on_leave: "0" });
        cov_hgyvc2s3y.s[4]++;
        $rootScope.projects = ProjectsTable.$all = ProjectsTable.$search();
        cov_hgyvc2s3y.s[5]++;
        $rootScope.activeProjects = ProjectsTable.$search({ ordering: 'name', state: 'CREATED' });
    };

    cov_hgyvc2s3y.s[6]++;
    $rootScope.refreshDynamicData = function () {
        cov_hgyvc2s3y.f[2]++;
        cov_hgyvc2s3y.s[7]++;

        $rootScope.users.forEach(function (user) {
            cov_hgyvc2s3y.f[3]++;
            cov_hgyvc2s3y.s[8]++;

            user.$refresh().$then(function (user) {
                cov_hgyvc2s3y.f[4]++;

                var request;
                cov_hgyvc2s3y.s[9]++;
                if ((cov_hgyvc2s3y.b[1][0]++, !user.$lastTask) || (cov_hgyvc2s3y.b[1][1]++, user.lastTask != user.$lastTask.id)) {
                    cov_hgyvc2s3y.b[0][0]++;
                    cov_hgyvc2s3y.s[10]++;

                    request = user.$load('lastTask').$lastTask.$load('project');
                } else {
                        cov_hgyvc2s3y.b[0][1]++;
                        cov_hgyvc2s3y.s[11]++;
                        if (user.$lastTask.$pk) {
                            cov_hgyvc2s3y.b[2][0]++;
                            cov_hgyvc2s3y.s[12]++;

                            request = user.$lastTask.$refresh();
                        } else {
                            cov_hgyvc2s3y.b[2][1]++;
                        }
                    }cov_hgyvc2s3y.s[13]++;
                if ((cov_hgyvc2s3y.b[4][0]++, request) && (cov_hgyvc2s3y.b[4][1]++, $rootScope.me.id === user.id)) {
                    cov_hgyvc2s3y.b[3][0]++;
                    cov_hgyvc2s3y.s[14]++;

                    request.$then(function (task) {
                        cov_hgyvc2s3y.f[5]++;
                        cov_hgyvc2s3y.s[15]++;

                        $rootScope.me.isWorking = task.state == 'EXECUTING' ? (cov_hgyvc2s3y.b[5][0]++, task) : (cov_hgyvc2s3y.b[5][1]++, false);
                    });
                } else {
                    cov_hgyvc2s3y.b[3][1]++;
                }
            });
        });
    };

    cov_hgyvc2s3y.s[16]++;
    $rootScope.openSidebar = function () {
        cov_hgyvc2s3y.f[6]++;
        cov_hgyvc2s3y.s[17]++;

        return $mdSidenav('menu').open();
    };

    cov_hgyvc2s3y.s[18]++;
    $rootScope.closeSidebar = function () {
        cov_hgyvc2s3y.f[7]++;
        cov_hgyvc2s3y.s[19]++;

        return $mdSidenav('menu').close();
    };

    cov_hgyvc2s3y.s[20]++;
    $rootScope.loadStaticData();
    cov_hgyvc2s3y.s[21]++;
    $rootScope.users.$then(function () {
        cov_hgyvc2s3y.f[8]++;
        cov_hgyvc2s3y.s[22]++;

        $interval(function () {
            cov_hgyvc2s3y.f[9]++;
            cov_hgyvc2s3y.s[23]++;
            return $rootScope.refreshDynamicData();
        }, 1000 * 10);
        cov_hgyvc2s3y.s[24]++;
        $rootScope.refreshDynamicData();
    });
}

/** @ngInject */
function materialTheme($mdThemingProvider) {
    cov_hgyvc2s3y.f[10]++;

    var customPrimary = (cov_hgyvc2s3y.s[25]++, {
        '50': '#626262',
        '100': '#555555',
        '200': '#484848',
        '300': '#3b3b3b',
        '400': '#2f2f2f',
        '500': '#222222',
        '600': '#151515',
        '700': '#080808',
        '800': '#000000',
        '900': '#000000',
        'A100': '#6e6e6e',
        'A200': '#7b7b7b',
        'A400': '#888888',
        'A700': '#000000',
        'contrastDefaultColor': 'light'
    });
    cov_hgyvc2s3y.s[26]++;
    $mdThemingProvider.definePalette('customPrimary', customPrimary);

    var customAccent = (cov_hgyvc2s3y.s[27]++, {
        '50': '#171c03',
        '100': '#2a3306',
        '200': '#3d4a08',
        '300': '#4f610b',
        '400': '#62780d',
        '500': '#758f10',
        '600': '#9bbd14',
        '700': '#aed417',
        '800': '#bee71e',
        '900': '#c5e935',
        'A100': '#9bbd14',
        'A200': '#88A612',
        'A400': '#758f10',
        'A700': '#cbec4c',
        'contrastDefaultColor': 'light'
    });
    cov_hgyvc2s3y.s[28]++;
    $mdThemingProvider.definePalette('customAccent', customAccent);

    var customWarn = (cov_hgyvc2s3y.s[29]++, {
        '50': '#ffb280',
        '100': '#ffa266',
        '200': '#ff934d',
        '300': '#ff8333',
        '400': '#ff741a',
        '500': '#ff6400',
        '600': '#e65a00',
        '700': '#cc5000',
        '800': '#b34600',
        '900': '#993c00',
        'A100': '#ffc199',
        'A200': '#ffd1b3',
        'A400': '#ffe0cc',
        'A700': '#803200'
    });
    cov_hgyvc2s3y.s[30]++;
    $mdThemingProvider.definePalette('customWarn', customWarn);

    cov_hgyvc2s3y.s[31]++;
    $mdThemingProvider.theme('default').primaryPalette('customPrimary').accentPalette('customAccent').warnPalette('customWarn');
}
'use strict';

var cov_vltpuh6bu = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/users/usersList/usersList.js',
        hash = '2ae75e322a06ce527ad9605f6910bf5007fdb604',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/users/usersList/usersList.js',
        statementMap: {
            '0': {
                start: {
                    line: 7,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersListController = function UsersListController() {
    _classCallCheck(this, UsersListController);

    cov_vltpuh6bu.f[0]++;
};

cov_vltpuh6bu.s[0]++;


angular.module('app').component('usersList', {
    templateUrl: 'app/components/users/usersList/usersList.html',
    controller: UsersListController,
    bindings: {
        members: '<',
        accountants: '<'
    }
});
'use strict';

var cov_1daujr5ona = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/users/editProfile/editProfile.js',
        hash = '380595607b955daab02c8f5d2207416e619c4aaf',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/users/editProfile/editProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 99
                }
            },
            '8': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 59
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 18,
                    column: 98
                }
            },
            '10': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 11
                }
            },
            '11': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 94
                }
            },
            '13': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 41
                }
            },
            '14': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 11
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 89
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 67
                }
            },
            '17': {
                start: {
                    line: 43,
                    column: 0
                },
                end: {
                    line: 51,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 68
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 43
                    },
                    end: {
                        line: 8,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 14,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 56
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 19
                    },
                    end: {
                        line: 17,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 25
                    },
                    end: {
                        line: 19,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 18
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 65
                    },
                    end: {
                        line: 26,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 71
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 26
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 27,
                        column: 62
                    },
                    end: {
                        line: 27,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 68
                    },
                    end: {
                        line: 29,
                        column: 13
                    }
                },
                line: 27
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 29,
                        column: 15
                    },
                    end: {
                        line: 29,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 21
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 18
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 35
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 36,
                        column: 64
                    },
                    end: {
                        line: 36,
                        column: 65
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 70
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                line: 36
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 94
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 50
                    }
                }, {
                    start: {
                        line: 13,
                        column: 54
                    },
                    end: {
                        line: 13,
                        column: 94
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProfileController = function () {
    EditProfileController.$inject = ["$mdToast", "AuthService", "$state", "$rootScope", "$scope"];
    function EditProfileController($mdToast, AuthService, $state, $rootScope, $scope) {
        var _this = this;

        _classCallCheck(this, EditProfileController);

        cov_1daujr5ona.f[0]++;
        cov_1daujr5ona.s[0]++;

        this.$mdToast = $mdToast;
        cov_1daujr5ona.s[1]++;
        this.AuthService = AuthService;
        cov_1daujr5ona.s[2]++;
        this.$state = $state;

        cov_1daujr5ona.s[3]++;
        $scope.$watch('$ctrl.user.avatar', function () {
            cov_1daujr5ona.f[1]++;
            cov_1daujr5ona.s[4]++;

            console.log({
                'this': _this.user.avatar,
                'root': $rootScope.me.avatar
            });
            cov_1daujr5ona.s[5]++;
            if ((cov_1daujr5ona.b[1][0]++, angular.isString(_this.user.avatar)) && (cov_1daujr5ona.b[1][1]++, _this.user.avatar != $rootScope.me.avatar)) {
                cov_1daujr5ona.b[0][0]++;
                cov_1daujr5ona.s[6]++;

                _this.user.$save(['avatar']).$then(function () {
                    cov_1daujr5ona.f[2]++;
                    cov_1daujr5ona.s[7]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('Profile image updated')));
                    cov_1daujr5ona.s[8]++;
                    AuthService.refreshAuthenticatedInfo();
                }, function () {
                    cov_1daujr5ona.f[3]++;
                    cov_1daujr5ona.s[9]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('An error has ocurred')));
                });
            } else {
                cov_1daujr5ona.b[0][1]++;
            }
        });
    }

    _createClass(EditProfileController, [{
        key: 'changeInfo',
        value: function changeInfo() {
            var _this2 = this;

            cov_1daujr5ona.f[4]++;
            cov_1daujr5ona.s[10]++;

            this.user.$save(['name', 'email', 'nif', 'phone']).$then(function () {
                cov_1daujr5ona.f[5]++;
                cov_1daujr5ona.s[11]++;

                _this2.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_1daujr5ona.f[6]++;
                    cov_1daujr5ona.s[12]++;

                    _this2.$mdToast.show(_this2.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_1daujr5ona.f[7]++;
                    cov_1daujr5ona.s[13]++;

                    _this2.$state.go('logout');
                });
            });
        }
    }, {
        key: 'changePass',
        value: function changePass() {
            var _this3 = this;

            cov_1daujr5ona.f[8]++;
            cov_1daujr5ona.s[14]++;

            this.user.$save(['password', 'confirm_password']).$then(function () {
                cov_1daujr5ona.f[9]++;
                cov_1daujr5ona.s[15]++;

                _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Password alterada!'));
                cov_1daujr5ona.s[16]++;
                _this3.user.password = _this3.user.confirm_password = null;
            });
        }
    }]);

    return EditProfileController;
}();

cov_1daujr5ona.s[17]++;


angular.module('app').component('editProfile', {
    templateUrl: 'app/components/users/editProfile/editProfile.html',
    controller: EditProfileController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_23m409d55e = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.table.factory.js',
        hash = '75dcddae2aae363a4eead656ecdb0ea6e74f37bd',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.table.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 67
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 13,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23m409d55e.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_23m409d55e.f[0]++;
    cov_23m409d55e.s[1]++;
    angular.module('app').factory('MediaTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_23m409d55e.f[1]++;
        cov_23m409d55e.s[2]++;


        return restmod.model('/media').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_sll6mrjic = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.service.js',
        hash = 'b99fda0926414665a48763b4416bfbef7942afbe',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 74
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 71
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 45
                },
                end: {
                    line: 27,
                    column: 85
                }
            },
            '10': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 90
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 60
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'upload',
                decl: {
                    start: {
                        line: 12,
                        column: 17
                    },
                    end: {
                        line: 12,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 30
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 40
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 23,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                },
                line: 23
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 34
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 26
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_sll6mrjic.s[0]++;
(function () {
    'use strict';

    Service.$inject = ["Upload", "AppSettings", "$mdToast"];
    cov_sll6mrjic.f[0]++;
    cov_sll6mrjic.s[1]++;
    angular.module('app').service('MediaService', Service);

    /* @ngInject */
    function Service(Upload, AppSettings, $mdToast) {
        cov_sll6mrjic.f[1]++;
        cov_sll6mrjic.s[2]++;

        this.upload = upload;

        function upload(file) {
            cov_sll6mrjic.f[2]++;
            cov_sll6mrjic.s[3]++;

            $mdToast.show($mdToast.simple().textContent('Uploading ...'));

            cov_sll6mrjic.s[4]++;
            if (file) {
                cov_sll6mrjic.b[0][0]++;
                cov_sll6mrjic.s[5]++;

                return Upload.upload({
                    url: AppSettings.apiUrl + '/media/',
                    data: {
                        'file': file
                    }
                }).then(function (data) {
                    cov_sll6mrjic.f[3]++;
                    cov_sll6mrjic.s[6]++;

                    return data.data.file;
                }, function () {
                    cov_sll6mrjic.f[4]++;
                    cov_sll6mrjic.s[7]++;

                    $mdToast.updateTextContent('An error has ocurred');
                    cov_sll6mrjic.s[8]++;
                    return undefined;
                }, function (evt) {
                    cov_sll6mrjic.f[5]++;

                    var progressPercentage = (cov_sll6mrjic.s[9]++, parseInt(100.0 * evt.loaded / evt.total));
                    cov_sll6mrjic.s[10]++;
                    $mdToast.updateTextContent('Uploading (' + progressPercentage + '%)');
                });
            } else {
                cov_sll6mrjic.b[0][1]++;
                cov_sll6mrjic.s[11]++;

                $mdToast.updateTextContent('Invalid file!');
                cov_sll6mrjic.s[12]++;
                return undefined;
            }
        }
    }
})();
'use strict';

var cov_1p807t2cly = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.run.js',
        hash = '902a2d73abace9883142a5887d5cccd04ea22438',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 5,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 8,
                        column: 13
                    },
                    end: {
                        line: 8,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1p807t2cly.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "MediaService"];
    cov_1p807t2cly.f[0]++;
    cov_1p807t2cly.s[1]++;
    angular.module('app').run(runBlock);

    /* @ngInject */
    function runBlock($rootScope, MediaService) {
        cov_1p807t2cly.f[1]++;
        cov_1p807t2cly.s[2]++;

        $rootScope.$Media = MediaService;
    }
})();
'use strict';

var cov_7qferyph6 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.filter.js',
        hash = 'f37714106c0cae91192de41cff5595a6417287f0',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 28
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaUrl',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_7qferyph6.s[0]++;
(function () {
    'use strict';

    MediaUrl.$inject = ["AppSettings"];
    cov_7qferyph6.f[0]++;
    cov_7qferyph6.s[1]++;
    angular.module('app').filter('mediaUrl', MediaUrl);

    /* @ngInject */
    function MediaUrl(AppSettings) {
        cov_7qferyph6.f[1]++;
        cov_7qferyph6.s[2]++;

        return function (input) {
            cov_7qferyph6.f[2]++;
            cov_7qferyph6.s[3]++;

            if (input) {
                cov_7qferyph6.b[0][0]++;
                cov_7qferyph6.s[4]++;

                return AppSettings.mediaUrl + '/' + input;
            } else {
                cov_7qferyph6.b[0][1]++;
                cov_7qferyph6.s[5]++;

                return null;
            }
        };
    }
})();
'use strict';

var cov_1kdao34i9o = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.directive.js',
        hash = 'bd2dc2f897796d5d5fb3b72cd240c7fd7ab6b402',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/media/media.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 29
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 29
                },
                end: {
                    line: 14,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 29
                },
                end: {
                    line: 15,
                    column: 34
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 31
                },
                end: {
                    line: 18,
                    column: 45
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 38
                },
                end: {
                    line: 24,
                    column: 70
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 48
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 27
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 28
                },
                end: {
                    line: 27,
                    column: 49
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 28
                },
                end: {
                    line: 29,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaDirective',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 18
                    },
                    end: {
                        line: 12,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 56
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 62
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 53
                    },
                    end: {
                        line: 28,
                        column: 25
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 28,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 43
                    },
                    end: {
                        line: 30,
                        column: 25
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 70
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 28
                    }
                }, {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 47
                    }
                }, {
                    start: {
                        line: 22,
                        column: 25
                    },
                    end: {
                        line: 22,
                        column: 45
                    }
                }, {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 69
                    }
                }],
                line: 20
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_1kdao34i9o.s[0]++;
(function () {
    'use strict';

    MediaDirective.$inject = ["$parse"];
    cov_1kdao34i9o.f[0]++;
    cov_1kdao34i9o.s[1]++;
    angular.module('app').directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        cov_1kdao34i9o.f[1]++;
        cov_1kdao34i9o.s[2]++;

        return {
            require: '?ngModel',
            link: function link(scope, element, attributes) {
                cov_1kdao34i9o.f[2]++;

                var getter = (cov_1kdao34i9o.s[3]++, $parse(attributes.ngModel));
                var setter = (cov_1kdao34i9o.s[4]++, getter.assign);
                var $scope = (cov_1kdao34i9o.s[5]++, scope);

                cov_1kdao34i9o.s[6]++;
                $scope.$watch(attributes.ngModel, function () {
                    cov_1kdao34i9o.f[3]++;

                    var file = (cov_1kdao34i9o.s[7]++, getter($scope));
                    cov_1kdao34i9o.s[8]++;
                    if ((cov_1kdao34i9o.b[1][0]++, file) && (cov_1kdao34i9o.b[1][1]++, (typeof file === 'undefined' ? 'undefined' : _typeof(file)) == 'object') && ((cov_1kdao34i9o.b[1][2]++, file instanceof File) || (cov_1kdao34i9o.b[1][3]++, file instanceof Blob))) {
                        cov_1kdao34i9o.b[0][0]++;

                        var promise = (cov_1kdao34i9o.s[9]++, $scope.$root.$Media.upload(file));
                        cov_1kdao34i9o.s[10]++;
                        setter($scope, promise);
                        cov_1kdao34i9o.s[11]++;
                        promise.then(function (data) {
                            cov_1kdao34i9o.f[4]++;
                            cov_1kdao34i9o.s[12]++;

                            setter($scope, data);
                        }, function (data) {
                            cov_1kdao34i9o.f[5]++;
                            cov_1kdao34i9o.s[13]++;

                            setter($scope, data);
                        });
                    } else {
                        cov_1kdao34i9o.b[0][1]++;
                    }
                });
            }
        };
    }
})();
'use strict';

var cov_1qitvulpgu = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.watchers.factory.js',
        hash = '110e906978244a625fe733ad5de5e0bbd87944ff',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.watchers.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1qitvulpgu.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1qitvulpgu.f[0]++;
    cov_1qitvulpgu.s[1]++;
    angular.module('app').factory('WatchersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1qitvulpgu.f[1]++;
        cov_1qitvulpgu.s[2]++;


        return restmod.model('/watchers').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    },
                    task: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'task'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_13ppzeyjbr = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.users.factory.js',
        hash = 'bd55419a03f049743ebc736a468277941605b774',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.users.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 68,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 58,
                    column: 16
                },
                end: {
                    line: 64,
                    column: 17
                }
            },
            '4': {
                start: {
                    line: 59,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 21
                }
            },
            '5': {
                start: {
                    line: 60,
                    column: 24
                },
                end: {
                    line: 60,
                    column: 86
                }
            },
            '6': {
                start: {
                    line: 60,
                    column: 63
                },
                end: {
                    line: 60,
                    column: 84
                }
            },
            '7': {
                start: {
                    line: 63,
                    column: 20
                },
                end: {
                    line: 63,
                    column: 82
                }
            },
            '8': {
                start: {
                    line: 63,
                    column: 59
                },
                end: {
                    line: 63,
                    column: 80
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 68,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 57,
                        column: 27
                    },
                    end: {
                        line: 57,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 39
                    },
                    end: {
                        line: 65,
                        column: 13
                    }
                },
                line: 57
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 60,
                        column: 53
                    },
                    end: {
                        line: 60,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 63
                    },
                    end: {
                        line: 60,
                        column: 84
                    }
                },
                line: 60
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 63,
                        column: 49
                    },
                    end: {
                        line: 63,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 59
                    },
                    end: {
                        line: 63,
                        column: 80
                    }
                },
                line: 63
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 58,
                        column: 16
                    },
                    end: {
                        line: 64,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 58,
                        column: 16
                    },
                    end: {
                        line: 64,
                        column: 17
                    }
                }, {
                    start: {
                        line: 58,
                        column: 16
                    },
                    end: {
                        line: 64,
                        column: 17
                    }
                }],
                line: 58
            },
            '1': {
                loc: {
                    start: {
                        line: 59,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 59,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                }, {
                    start: {
                        line: 59,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                }],
                line: 59
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_13ppzeyjbr.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_13ppzeyjbr.f[0]++;
    cov_13ppzeyjbr.s[1]++;
    angular.module('app').factory('UsersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_13ppzeyjbr.f[1]++;
        cov_13ppzeyjbr.s[2]++;


        return restmod.model('/users').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    tasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'user'
                    },
                    openTasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'user',
                        filters: {
                            'state__not_in': 'CLOSED'
                        }
                    },
                    lastTask: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'lastTask'
                    },
                    executions: {
                        type: 'hasMany',
                        table: 'ExecutionsTable',
                        foreignKey: 'task__user',
                        filters: {
                            'ordering': '-start'
                        }
                    },
                    watchers: {
                        type: 'hasMany',
                        table: 'WatchersTable',
                        foreignKey: 'user'
                    },
                    comments: {
                        type: 'hasMany',
                        table: 'ExecutionsTable',
                        foreignKey: 'user'
                    }
                }
            },
            $loadLastTask: function $loadLastTask() {
                cov_13ppzeyjbr.f[2]++;
                cov_13ppzeyjbr.s[3]++;

                if (this.hasOwnProperty('$lastTask')) {
                    cov_13ppzeyjbr.b[0][0]++;
                    cov_13ppzeyjbr.s[4]++;

                    if (this.lastTask != this.$lastTask.id) {
                        cov_13ppzeyjbr.b[1][0]++;
                        cov_13ppzeyjbr.s[5]++;

                        this.$load('lastTask').$then(function (task) {
                            cov_13ppzeyjbr.f[3]++;
                            cov_13ppzeyjbr.s[6]++;
                            return task.$load('project');
                        });
                    } else {
                        cov_13ppzeyjbr.b[1][1]++;
                    }
                } else {
                    cov_13ppzeyjbr.b[0][1]++;
                    cov_13ppzeyjbr.s[7]++;

                    this.$load('lastTask').$then(function (task) {
                        cov_13ppzeyjbr.f[4]++;
                        cov_13ppzeyjbr.s[8]++;
                        return task.$load('project');
                    });
                }
            }
        });
    }
})();
'use strict';

var cov_d8312igoc = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.tasks.factory.js',
        hash = 'b2bbb7d55fe0d2810da4dfe71421be3f72dc423f',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.tasks.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 88,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 86,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 20,
                    column: 24
                },
                end: {
                    line: 20,
                    column: 47
                }
            },
            '5': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 52
                }
            },
            '6': {
                start: {
                    line: 61,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 43
                }
            },
            '7': {
                start: {
                    line: 66,
                    column: 20
                },
                end: {
                    line: 66,
                    column: 43
                }
            },
            '8': {
                start: {
                    line: 71,
                    column: 20
                },
                end: {
                    line: 71,
                    column: 43
                }
            },
            '9': {
                start: {
                    line: 76,
                    column: 30
                },
                end: {
                    line: 76,
                    column: 40
                }
            },
            '10': {
                start: {
                    line: 77,
                    column: 20
                },
                end: {
                    line: 77,
                    column: 31
                }
            },
            '11': {
                start: {
                    line: 82,
                    column: 30
                },
                end: {
                    line: 82,
                    column: 40
                }
            },
            '12': {
                start: {
                    line: 83,
                    column: 20
                },
                end: {
                    line: 83,
                    column: 31
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 88,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 87,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 18,
                        column: 24
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 41
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 18
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 60,
                        column: 24
                    },
                    end: {
                        line: 60,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 41
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                },
                line: 60
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 65,
                        column: 24
                    },
                    end: {
                        line: 65,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 65,
                        column: 41
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                },
                line: 65
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 70,
                        column: 24
                    },
                    end: {
                        line: 70,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 41
                    },
                    end: {
                        line: 72,
                        column: 17
                    }
                },
                line: 70
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 75,
                        column: 24
                    },
                    end: {
                        line: 75,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 75,
                        column: 41
                    },
                    end: {
                        line: 78,
                        column: 17
                    }
                },
                line: 75
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 81,
                        column: 24
                    },
                    end: {
                        line: 81,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 41
                    },
                    end: {
                        line: 84,
                        column: 17
                    }
                },
                line: 81
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 22,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 22,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 22,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 76,
                        column: 30
                    },
                    end: {
                        line: 76,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 76,
                        column: 30
                    },
                    end: {
                        line: 76,
                        column: 35
                    }
                }, {
                    start: {
                        line: 76,
                        column: 39
                    },
                    end: {
                        line: 76,
                        column: 40
                    }
                }],
                line: 76
            },
            '2': {
                loc: {
                    start: {
                        line: 82,
                        column: 30
                    },
                    end: {
                        line: 82,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 82,
                        column: 30
                    },
                    end: {
                        line: 82,
                        column: 35
                    }
                }, {
                    start: {
                        line: 82,
                        column: 39
                    },
                    end: {
                        line: 82,
                        column: 40
                    }
                }],
                line: 82
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_d8312igoc.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_d8312igoc.f[0]++;
    cov_d8312igoc.s[1]++;
    angular.module('app').factory('TasksTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_d8312igoc.f[1]++;
        cov_d8312igoc.s[2]++;


        return restmod.model('/tasks').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            dueDate: {
                decode: function decode(value) {
                    cov_d8312igoc.f[2]++;
                    cov_d8312igoc.s[3]++;

                    if (value !== null) {
                        cov_d8312igoc.b[0][0]++;
                        cov_d8312igoc.s[4]++;

                        return new Date(value);
                        cov_d8312igoc.s[5]++;
                        return newDate(value).getDate();
                    } else {
                        cov_d8312igoc.b[0][1]++;
                    }
                }
            },
            $config: {
                contains: {
                    executions: {
                        type: 'hasMany',
                        table: 'ExecutionsTable',
                        foreignKey: 'task'
                    },
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    },
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    deliverables: {
                        type: 'hasMany',
                        table: 'DeliverablesTable',
                        foreignKey: 'task'
                    },
                    watchers: {
                        type: 'hasMany',
                        table: 'WatchersTable',
                        foreignKey: 'task'
                    },
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'objectId'
                    }
                }
            },
            updated: {
                decode: function decode(value) {
                    cov_d8312igoc.f[3]++;
                    cov_d8312igoc.s[6]++;

                    return new Date(value);
                }
            },
            workingSince: {
                decode: function decode(value) {
                    cov_d8312igoc.f[4]++;
                    cov_d8312igoc.s[7]++;

                    return new Date(value);
                }
            },
            stoppedSince: {
                decode: function decode(value) {
                    cov_d8312igoc.f[5]++;
                    cov_d8312igoc.s[8]++;

                    return new Date(value);
                }
            },
            totalDuration: {
                decode: function decode(value) {
                    cov_d8312igoc.f[6]++;

                    var num = (cov_d8312igoc.s[9]++, (cov_d8312igoc.b[1][0]++, value) || (cov_d8312igoc.b[1][1]++, 0));
                    cov_d8312igoc.s[10]++;
                    return num;
                }
            },
            eta: {
                decode: function decode(value) {
                    cov_d8312igoc.f[7]++;

                    var num = (cov_d8312igoc.s[11]++, (cov_d8312igoc.b[2][0]++, value) || (cov_d8312igoc.b[2][1]++, 0));
                    cov_d8312igoc.s[12]++;
                    return num;
                }
            }
        });
    }
})();
'use strict';

var cov_1k1f2albsh = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stories.factory.js',
        hash = 'ea6a06ce2996a5a0d814a4b8690f1b6c3ada066e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stories.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 43,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 38,
                    column: 20
                },
                end: {
                    line: 38,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 43,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 37,
                        column: 24
                    },
                    end: {
                        line: 37,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 41
                    },
                    end: {
                        line: 39,
                        column: 17
                    }
                },
                line: 37
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1k1f2albsh.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1k1f2albsh.f[0]++;
    cov_1k1f2albsh.s[1]++;
    angular.module('app').factory('StoriesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1k1f2albsh.f[1]++;
        cov_1k1f2albsh.s[2]++;


        return restmod.model('/stories').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    tasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'story'
                    },
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    proposal: {
                        type: 'belongsTo',
                        table: 'ProposalsTable',
                        foreignKey: 'proposal'
                    }
                }
            },
            updated: {
                decode: function decode(value) {
                    cov_1k1f2albsh.f[2]++;
                    cov_1k1f2albsh.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();
'use strict';

var cov_oayx9v1e9 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stopworking.factory.js',
        hash = '945aa199e40a567159ec99aa890c3dc3ceffd38d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stopworking.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 15,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 15,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_oayx9v1e9.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_oayx9v1e9.f[0]++;
    cov_oayx9v1e9.s[1]++;
    angular.module('app').factory('StopWorkingService', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_oayx9v1e9.f[1]++;
        cov_oayx9v1e9.s[2]++;


        return restmod.model('/stop-working').mix('MixinContainable', {
            $config: {}
        });
    }
})();
'use strict';

var cov_212tfeb9v2 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.statistics.factory.js',
        hash = 'deae0b8dc66771d84559403f3cb553de2385beb6',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.statistics.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 14,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_212tfeb9v2.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_212tfeb9v2.f[0]++;
    cov_212tfeb9v2.s[1]++;
    angular.module('app').factory('StatisticsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_212tfeb9v2.f[1]++;
        cov_212tfeb9v2.s[2]++;


        return restmod.model('/statistics').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_2vxrab29d = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.startworking.factory.js',
        hash = '7ccb33bac0b8da01bcb65fa8074a40a91c2b2b85',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.startworking.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 15,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 15,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2vxrab29d.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2vxrab29d.f[0]++;
    cov_2vxrab29d.s[1]++;
    angular.module('app').factory('StartWorkingTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2vxrab29d.f[1]++;
        cov_2vxrab29d.s[2]++;


        return restmod.model('/start-working').mix('MixinContainable', {
            $config: {}
        });
    }
})();
'use strict';

var cov_2mat5c2ryu = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.reports.factory.js',
        hash = '1319ed0c7b7fa95b2b772df017bc93ce72dd2984',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.reports.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 45
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2mat5c2ryu.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2mat5c2ryu.f[0]++;
    cov_2mat5c2ryu.s[1]++;
    angular.module('app').factory('ReportsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2mat5c2ryu.f[1]++;
        cov_2mat5c2ryu.s[2]++;


        return restmod.model('/reports').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1524uaghn7 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.recurrent.factory.js',
        hash = '3864c50890eb461a2faa096f8fbc555b8f3cc1df',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.recurrent.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 29,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1524uaghn7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1524uaghn7.f[0]++;
    cov_1524uaghn7.s[1]++;
    angular.module('app').factory('RecurrentTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1524uaghn7.f[1]++;
        cov_1524uaghn7.s[2]++;


        return restmod.model('/task-recurrences').mix('MixinContainable', {
            $config: {
                contains: {
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }

                }
            }
        });
    }
})();
'use strict';

var cov_pb7oh44k5 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.proposals.factory.js',
        hash = 'd95f835ce7e3de4ffa2d334d09a3ca90059a8b04',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.proposals.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_pb7oh44k5.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_pb7oh44k5.f[0]++;
    cov_pb7oh44k5.s[1]++;
    angular.module('app').factory('ProposalsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_pb7oh44k5.f[1]++;
        cov_pb7oh44k5.s[2]++;


        return restmod.model('/proposals').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    stories: {
                        type: 'hasMany',
                        table: 'StoriesTable',
                        foreignKey: 'proposal'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_uzk6x96ju = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projects.factory.js',
        hash = 'c5c5955388ee00c896d3e58e4dd11c07350578f3',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projects.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 60,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 48,
                    column: 30
                },
                end: {
                    line: 48,
                    column: 40
                }
            },
            '4': {
                start: {
                    line: 49,
                    column: 20
                },
                end: {
                    line: 49,
                    column: 31
                }
            },
            '5': {
                start: {
                    line: 54,
                    column: 30
                },
                end: {
                    line: 54,
                    column: 40
                }
            },
            '6': {
                start: {
                    line: 55,
                    column: 20
                },
                end: {
                    line: 55,
                    column: 31
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 60,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 59,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 47,
                        column: 24
                    },
                    end: {
                        line: 47,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 41
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                },
                line: 47
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 53,
                        column: 24
                    },
                    end: {
                        line: 53,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 41
                    },
                    end: {
                        line: 56,
                        column: 17
                    }
                },
                line: 53
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 48,
                        column: 30
                    },
                    end: {
                        line: 48,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 48,
                        column: 30
                    },
                    end: {
                        line: 48,
                        column: 35
                    }
                }, {
                    start: {
                        line: 48,
                        column: 39
                    },
                    end: {
                        line: 48,
                        column: 40
                    }
                }],
                line: 48
            },
            '1': {
                loc: {
                    start: {
                        line: 54,
                        column: 30
                    },
                    end: {
                        line: 54,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 30
                    },
                    end: {
                        line: 54,
                        column: 35
                    }
                }, {
                    start: {
                        line: 54,
                        column: 39
                    },
                    end: {
                        line: 54,
                        column: 40
                    }
                }],
                line: 54
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_uzk6x96ju.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_uzk6x96ju.f[0]++;
    cov_uzk6x96ju.s[1]++;
    angular.module('app').factory('ProjectsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_uzk6x96ju.f[1]++;
        cov_uzk6x96ju.s[2]++;


        return restmod.model('/projects').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    tasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'project'
                    },
                    statistics: {
                        type: 'hasMany',
                        table: 'StatisticsTable',
                        foreignKey: 'project'
                    },
                    stories: {
                        type: 'hasMany',
                        table: 'StoriesTable',
                        foreignKey: 'project'
                    },
                    proposals: {
                        type: 'hasMany',
                        table: 'ProposalsTable',
                        foreignKey: 'project'
                    },
                    reports: {
                        type: 'hasMany',
                        table: 'ProjectReportsTable',
                        foreignKey: 'project'
                    }
                }
            },
            totalDuration: {
                decode: function decode(value) {
                    cov_uzk6x96ju.f[2]++;

                    var num = (cov_uzk6x96ju.s[3]++, (cov_uzk6x96ju.b[0][0]++, value) || (cov_uzk6x96ju.b[0][1]++, 0));
                    cov_uzk6x96ju.s[4]++;
                    return num;
                }
            },
            totalEta: {
                decode: function decode(value) {
                    cov_uzk6x96ju.f[3]++;

                    var num = (cov_uzk6x96ju.s[5]++, (cov_uzk6x96ju.b[1][0]++, value) || (cov_uzk6x96ju.b[1][1]++, 0));
                    cov_uzk6x96ju.s[6]++;
                    return num;
                }
            }
        });
    }
})();
'use strict';

var cov_59vs4yjqa = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projectreports.factory.js',
        hash = 'd2b2943d673b3fdc923bab27ac850f04bb8bcc03',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projectreports.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 33,
                    column: 20
                },
                end: {
                    line: 33,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 27,
                        column: 24
                    },
                    end: {
                        line: 27,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 41
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 32,
                        column: 24
                    },
                    end: {
                        line: 32,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 41
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_59vs4yjqa.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_59vs4yjqa.f[0]++;
    cov_59vs4yjqa.s[1]++;
    angular.module('app').factory('ProjectReportsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_59vs4yjqa.f[1]++;
        cov_59vs4yjqa.s[2]++;


        return restmod.model('/project-reports').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    }
                }
            },
            start: {
                decode: function decode(value) {
                    cov_59vs4yjqa.f[2]++;
                    cov_59vs4yjqa.s[3]++;

                    return new Date(value);
                }
            },
            end: {
                decode: function decode(value) {
                    cov_59vs4yjqa.f[3]++;
                    cov_59vs4yjqa.s[4]++;

                    return new Date(value);
                }
            }
        });
    }
})();
'use strict';

var cov_2i6cb7s4x7 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        hash = '7a72da017719074818bc2e8d05e65dbd3dc24eed',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 147,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 56
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 21,
                    column: 19
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 70
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 20,
                    column: 21
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 24
                },
                end: {
                    line: 19,
                    column: 51
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 73
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 20
                },
                end: {
                    line: 30,
                    column: 21
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 82
                }
            },
            '12': {
                start: {
                    line: 29,
                    column: 24
                },
                end: {
                    line: 29,
                    column: 51
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 25
                },
                end: {
                    line: 34,
                    column: 30
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 13
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 20
                },
                end: {
                    line: 37,
                    column: 49
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 20
                },
                end: {
                    line: 38,
                    column: 26
                }
            },
            '17': {
                start: {
                    line: 40,
                    column: 20
                },
                end: {
                    line: 40,
                    column: 47
                }
            },
            '18': {
                start: {
                    line: 41,
                    column: 20
                },
                end: {
                    line: 41,
                    column: 26
                }
            },
            '19': {
                start: {
                    line: 43,
                    column: 20
                },
                end: {
                    line: 43,
                    column: 103
                }
            },
            '20': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 44
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 37
                }
            },
            '22': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 49,
                    column: 26
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 53,
                    column: 56
                }
            },
            '24': {
                start: {
                    line: 57,
                    column: 16
                },
                end: {
                    line: 78,
                    column: 19
                }
            },
            '25': {
                start: {
                    line: 58,
                    column: 31
                },
                end: {
                    line: 60,
                    column: 22
                }
            },
            '26': {
                start: {
                    line: 59,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 54
                }
            },
            '27': {
                start: {
                    line: 62,
                    column: 34
                },
                end: {
                    line: 73,
                    column: 22
                }
            },
            '28': {
                start: {
                    line: 65,
                    column: 39
                },
                end: {
                    line: 65,
                    column: 41
                }
            },
            '29': {
                start: {
                    line: 66,
                    column: 24
                },
                end: {
                    line: 68,
                    column: 27
                }
            },
            '30': {
                start: {
                    line: 67,
                    column: 28
                },
                end: {
                    line: 67,
                    column: 60
                }
            },
            '31': {
                start: {
                    line: 70,
                    column: 24
                },
                end: {
                    line: 72,
                    column: 27
                }
            },
            '32': {
                start: {
                    line: 71,
                    column: 28
                },
                end: {
                    line: 71,
                    column: 80
                }
            },
            '33': {
                start: {
                    line: 74,
                    column: 20
                },
                end: {
                    line: 76,
                    column: 23
                }
            },
            '34': {
                start: {
                    line: 75,
                    column: 24
                },
                end: {
                    line: 75,
                    column: 50
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 20
                },
                end: {
                    line: 77,
                    column: 52
                }
            },
            '36': {
                start: {
                    line: 82,
                    column: 16
                },
                end: {
                    line: 82,
                    column: 80
                }
            },
            '37': {
                start: {
                    line: 85,
                    column: 25
                },
                end: {
                    line: 85,
                    column: 30
                }
            },
            '38': {
                start: {
                    line: 86,
                    column: 12
                },
                end: {
                    line: 95,
                    column: 13
                }
            },
            '39': {
                start: {
                    line: 88,
                    column: 20
                },
                end: {
                    line: 88,
                    column: 53
                }
            },
            '40': {
                start: {
                    line: 89,
                    column: 20
                },
                end: {
                    line: 89,
                    column: 26
                }
            },
            '41': {
                start: {
                    line: 91,
                    column: 20
                },
                end: {
                    line: 91,
                    column: 51
                }
            },
            '42': {
                start: {
                    line: 92,
                    column: 20
                },
                end: {
                    line: 92,
                    column: 26
                }
            },
            '43': {
                start: {
                    line: 94,
                    column: 20
                },
                end: {
                    line: 94,
                    column: 103
                }
            },
            '44': {
                start: {
                    line: 97,
                    column: 12
                },
                end: {
                    line: 97,
                    column: 44
                }
            },
            '45': {
                start: {
                    line: 98,
                    column: 12
                },
                end: {
                    line: 98,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 100,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 30
                }
            },
            '47': {
                start: {
                    line: 104,
                    column: 27
                },
                end: {
                    line: 104,
                    column: 62
                }
            },
            '48': {
                start: {
                    line: 105,
                    column: 12
                },
                end: {
                    line: 116,
                    column: 13
                }
            },
            '49': {
                start: {
                    line: 106,
                    column: 29
                },
                end: {
                    line: 106,
                    column: 65
                }
            },
            '50': {
                start: {
                    line: 107,
                    column: 16
                },
                end: {
                    line: 107,
                    column: 60
                }
            },
            '51': {
                start: {
                    line: 108,
                    column: 16
                },
                end: {
                    line: 112,
                    column: 19
                }
            },
            '52': {
                start: {
                    line: 109,
                    column: 20
                },
                end: {
                    line: 111,
                    column: 21
                }
            },
            '53': {
                start: {
                    line: 110,
                    column: 24
                },
                end: {
                    line: 110,
                    column: 54
                }
            },
            '54': {
                start: {
                    line: 113,
                    column: 16
                },
                end: {
                    line: 113,
                    column: 30
                }
            },
            '55': {
                start: {
                    line: 115,
                    column: 16
                },
                end: {
                    line: 115,
                    column: 92
                }
            },
            '56': {
                start: {
                    line: 119,
                    column: 8
                },
                end: {
                    line: 145,
                    column: 11
                }
            },
            '57': {
                start: {
                    line: 124,
                    column: 38
                },
                end: {
                    line: 124,
                    column: 73
                }
            },
            '58': {
                start: {
                    line: 125,
                    column: 24
                },
                end: {
                    line: 125,
                    column: 95
                }
            },
            '59': {
                start: {
                    line: 126,
                    column: 24
                },
                end: {
                    line: 126,
                    column: 94
                }
            },
            '60': {
                start: {
                    line: 131,
                    column: 38
                },
                end: {
                    line: 131,
                    column: 73
                }
            },
            '61': {
                start: {
                    line: 132,
                    column: 24
                },
                end: {
                    line: 132,
                    column: 95
                }
            },
            '62': {
                start: {
                    line: 133,
                    column: 24
                },
                end: {
                    line: 133,
                    column: 90
                }
            },
            '63': {
                start: {
                    line: 139,
                    column: 20
                },
                end: {
                    line: 141,
                    column: 21
                }
            },
            '64': {
                start: {
                    line: 140,
                    column: 24
                },
                end: {
                    line: 140,
                    column: 41
                }
            },
            '65': {
                start: {
                    line: 142,
                    column: 20
                },
                end: {
                    line: 142,
                    column: 65
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 147,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 146,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'recordLoad',
                decl: {
                    start: {
                        line: 11,
                        column: 17
                    },
                    end: {
                        line: 11,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 69
                    },
                    end: {
                        line: 50,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'recordLoadBelongsTo',
                decl: {
                    start: {
                        line: 14,
                        column: 21
                    },
                    end: {
                        line: 14,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 29
                    },
                    end: {
                        line: 16,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 41
                    },
                    end: {
                        line: 21,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: 'recordLoadHasMany',
                decl: {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 24,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 47
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 24
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 31,
                        column: 17
                    }
                },
                line: 26
            },
            '7': {
                name: 'collectionLoad',
                decl: {
                    start: {
                        line: 52,
                        column: 17
                    },
                    end: {
                        line: 52,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 77
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                },
                line: 52
            },
            '8': {
                name: 'collectionLoadBelongsTo',
                decl: {
                    start: {
                        line: 56,
                        column: 21
                    },
                    end: {
                        line: 56,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 53
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                },
                line: 56
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 57,
                        column: 33
                    },
                    end: {
                        line: 57,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 45
                    },
                    end: {
                        line: 78,
                        column: 17
                    }
                },
                line: 57
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 58,
                        column: 46
                    },
                    end: {
                        line: 58,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 61
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                },
                line: 58
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 45
                    },
                    end: {
                        line: 73,
                        column: 21
                    }
                },
                line: 64
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 66,
                        column: 46
                    },
                    end: {
                        line: 66,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 65
                    },
                    end: {
                        line: 68,
                        column: 25
                    }
                },
                line: 66
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 70,
                        column: 52
                    },
                    end: {
                        line: 70,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 68
                    },
                    end: {
                        line: 72,
                        column: 25
                    }
                },
                line: 70
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 74,
                        column: 48
                    },
                    end: {
                        line: 74,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 64
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                },
                line: 74
            },
            '15': {
                name: 'collectionLoadHasMany',
                decl: {
                    start: {
                        line: 81,
                        column: 21
                    },
                    end: {
                        line: 81,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 51
                    },
                    end: {
                        line: 83,
                        column: 13
                    }
                },
                line: 81
            },
            '16': {
                name: 'getModelConfigs',
                decl: {
                    start: {
                        line: 103,
                        column: 17
                    },
                    end: {
                        line: 103,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 103,
                        column: 55
                    },
                    end: {
                        line: 117,
                        column: 9
                    }
                },
                line: 103
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 108,
                        column: 48
                    },
                    end: {
                        line: 108,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 70
                    },
                    end: {
                        line: 112,
                        column: 17
                    }
                },
                line: 108
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 123,
                        column: 27
                    },
                    end: {
                        line: 123,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 123,
                        column: 70
                    },
                    end: {
                        line: 127,
                        column: 21
                    }
                },
                line: 123
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 130,
                        column: 27
                    },
                    end: {
                        line: 130,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 70
                    },
                    end: {
                        line: 134,
                        column: 21
                    }
                },
                line: 130
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 138,
                        column: 37
                    },
                    end: {
                        line: 138,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 53
                    },
                    end: {
                        line: 143,
                        column: 17
                    }
                },
                line: 138
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 49
                    }
                }, {
                    start: {
                        line: 12,
                        column: 53
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }, {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }],
                line: 18
            },
            '2': {
                loc: {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }, {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }],
                line: 27
            },
            '3': {
                loc: {
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 36,
                        column: 16
                    },
                    end: {
                        line: 38,
                        column: 26
                    }
                }, {
                    start: {
                        line: 39,
                        column: 16
                    },
                    end: {
                        line: 41,
                        column: 26
                    }
                }, {
                    start: {
                        line: 42,
                        column: 16
                    },
                    end: {
                        line: 43,
                        column: 103
                    }
                }],
                line: 35
            },
            '4': {
                loc: {
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 49
                    }
                }, {
                    start: {
                        line: 53,
                        column: 53
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                }],
                line: 53
            },
            '5': {
                loc: {
                    start: {
                        line: 86,
                        column: 12
                    },
                    end: {
                        line: 95,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 87,
                        column: 16
                    },
                    end: {
                        line: 89,
                        column: 26
                    }
                }, {
                    start: {
                        line: 90,
                        column: 16
                    },
                    end: {
                        line: 92,
                        column: 26
                    }
                }, {
                    start: {
                        line: 93,
                        column: 16
                    },
                    end: {
                        line: 94,
                        column: 103
                    }
                }],
                line: 86
            },
            '6': {
                loc: {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }, {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }],
                line: 105
            },
            '7': {
                loc: {
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 24
                    }
                }, {
                    start: {
                        line: 105,
                        column: 28
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                }],
                line: 105
            },
            '8': {
                loc: {
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 53
                    }
                }, {
                    start: {
                        line: 107,
                        column: 57
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                }],
                line: 107
            },
            '9': {
                loc: {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }, {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }],
                line: 109
            },
            '10': {
                loc: {
                    start: {
                        line: 139,
                        column: 20
                    },
                    end: {
                        line: 141,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 139,
                        column: 20
                    },
                    end: {
                        line: 141,
                        column: 21
                    }
                }, {
                    start: {
                        line: 139,
                        column: 20
                    },
                    end: {
                        line: 141,
                        column: 21
                    }
                }],
                line: 139
            },
            '11': {
                loc: {
                    start: {
                        line: 142,
                        column: 47
                    },
                    end: {
                        line: 142,
                        column: 64
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 142,
                        column: 47
                    },
                    end: {
                        line: 142,
                        column: 58
                    }
                }, {
                    start: {
                        line: 142,
                        column: 62
                    },
                    end: {
                        line: 142,
                        column: 64
                    }
                }],
                line: 142
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0, 0],
            '4': [0, 0],
            '5': [0, 0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0],
            '11': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2i6cb7s4x7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod", "$injector"];
    cov_2i6cb7s4x7.f[0]++;
    cov_2i6cb7s4x7.s[1]++;
    angular.module('app').factory('MixinContainable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod, $injector) {
        cov_2i6cb7s4x7.f[1]++;


        function recordLoad(record, key, config, additionalFilters) {
            cov_2i6cb7s4x7.f[2]++;
            cov_2i6cb7s4x7.s[2]++;

            additionalFilters = (cov_2i6cb7s4x7.b[0][0]++, additionalFilters) || (cov_2i6cb7s4x7.b[0][1]++, {});

            function recordLoadBelongsTo(table) {
                cov_2i6cb7s4x7.f[3]++;
                cov_2i6cb7s4x7.s[3]++;

                record['$' + key] = table.$new();
                cov_2i6cb7s4x7.s[4]++;
                record.$then(function () {
                    cov_2i6cb7s4x7.f[4]++;
                    cov_2i6cb7s4x7.s[5]++;

                    record['$' + key].$pk = record[config.foreignKey];
                    cov_2i6cb7s4x7.s[6]++;
                    if (record[config.foreignKey]) {
                        cov_2i6cb7s4x7.b[1][0]++;
                        cov_2i6cb7s4x7.s[7]++;

                        record['$' + key].$fetch();
                    } else {
                        cov_2i6cb7s4x7.b[1][1]++;
                    }
                });
            }

            function recordLoadHasMany(table) {
                cov_2i6cb7s4x7.f[5]++;
                cov_2i6cb7s4x7.s[8]++;

                record['$' + key] = table.$collection(additionalFilters);
                cov_2i6cb7s4x7.s[9]++;
                record.$then(function () {
                    cov_2i6cb7s4x7.f[6]++;
                    cov_2i6cb7s4x7.s[10]++;

                    if (record.$pk) {
                        cov_2i6cb7s4x7.b[2][0]++;
                        cov_2i6cb7s4x7.s[11]++;

                        record['$' + key].$params[config.foreignKey] = record.$pk;
                        cov_2i6cb7s4x7.s[12]++;
                        record['$' + key].$fetch();
                    } else {
                        cov_2i6cb7s4x7.b[2][1]++;
                    }
                });
            }

            var loader = (cov_2i6cb7s4x7.s[13]++, false);
            cov_2i6cb7s4x7.s[14]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_2i6cb7s4x7.b[3][0]++;
                    cov_2i6cb7s4x7.s[15]++;

                    loader = recordLoadBelongsTo;
                    cov_2i6cb7s4x7.s[16]++;
                    break;
                case 'hasMany':
                    cov_2i6cb7s4x7.b[3][1]++;
                    cov_2i6cb7s4x7.s[17]++;

                    loader = recordLoadHasMany;
                    cov_2i6cb7s4x7.s[18]++;
                    break;
                default:
                    cov_2i6cb7s4x7.b[3][2]++;
                    cov_2i6cb7s4x7.s[19]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_2i6cb7s4x7.s[20]++;
            loader.$inject = [config.table];
            cov_2i6cb7s4x7.s[21]++;
            $injector.invoke(loader);

            cov_2i6cb7s4x7.s[22]++;
            return record;
        }

        function collectionLoad(collection, key, config, additionalFilters) {
            cov_2i6cb7s4x7.f[7]++;
            cov_2i6cb7s4x7.s[23]++;

            additionalFilters = (cov_2i6cb7s4x7.b[4][0]++, additionalFilters) || (cov_2i6cb7s4x7.b[4][1]++, {});

            function collectionLoadBelongsTo(table) {
                cov_2i6cb7s4x7.f[8]++;
                cov_2i6cb7s4x7.s[24]++;

                collection.$then(function () {
                    cov_2i6cb7s4x7.f[9]++;

                    var keys = (cov_2i6cb7s4x7.s[25]++, collection.map(function (obj) {
                        cov_2i6cb7s4x7.f[10]++;
                        cov_2i6cb7s4x7.s[26]++;

                        return obj[config.foreignKey];
                    }));

                    var request = (cov_2i6cb7s4x7.s[27]++, table.$search({
                        'id__in': keys.join(',')
                    }).$then(function (data) {
                        cov_2i6cb7s4x7.f[11]++;

                        var objsById = (cov_2i6cb7s4x7.s[28]++, {});
                        cov_2i6cb7s4x7.s[29]++;
                        angular.forEach(data, function (respObj) {
                            cov_2i6cb7s4x7.f[12]++;
                            cov_2i6cb7s4x7.s[30]++;

                            objsById[respObj.$pk] = respObj;
                        });

                        cov_2i6cb7s4x7.s[31]++;
                        angular.forEach(collection, function (item) {
                            cov_2i6cb7s4x7.f[13]++;
                            cov_2i6cb7s4x7.s[32]++;

                            item['$' + key] = objsById[item[config.foreignKey]];
                        });
                    }));
                    cov_2i6cb7s4x7.s[33]++;
                    angular.forEach(collection, function (item) {
                        cov_2i6cb7s4x7.f[14]++;
                        cov_2i6cb7s4x7.s[34]++;

                        item['$' + key] = request;
                    });
                    cov_2i6cb7s4x7.s[35]++;
                    collection['$' + key] = request;
                });
            }

            function collectionLoadHasMany(table) {
                cov_2i6cb7s4x7.f[15]++;
                cov_2i6cb7s4x7.s[36]++;

                throw new Error('Collection load has many Not implemented yet');
            }

            var loader = (cov_2i6cb7s4x7.s[37]++, false);
            cov_2i6cb7s4x7.s[38]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_2i6cb7s4x7.b[5][0]++;
                    cov_2i6cb7s4x7.s[39]++;

                    loader = collectionLoadBelongsTo;
                    cov_2i6cb7s4x7.s[40]++;
                    break;
                case 'hasMany':
                    cov_2i6cb7s4x7.b[5][1]++;
                    cov_2i6cb7s4x7.s[41]++;

                    loader = collectionLoadHasMany;
                    cov_2i6cb7s4x7.s[42]++;
                    break;
                default:
                    cov_2i6cb7s4x7.b[5][2]++;
                    cov_2i6cb7s4x7.s[43]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_2i6cb7s4x7.s[44]++;
            loader.$inject = [config.table];
            cov_2i6cb7s4x7.s[45]++;
            $injector.invoke(loader);

            cov_2i6cb7s4x7.s[46]++;
            return collection;
        }

        function getModelConfigs(model, relatedModel) {
            cov_2i6cb7s4x7.f[16]++;

            var contains = (cov_2i6cb7s4x7.s[47]++, model.$type.getProperty('contains'));
            cov_2i6cb7s4x7.s[48]++;
            if ((cov_2i6cb7s4x7.b[7][0]++, contains) && (cov_2i6cb7s4x7.b[7][1]++, contains[relatedModel])) {
                cov_2i6cb7s4x7.b[6][0]++;

                var config = (cov_2i6cb7s4x7.s[49]++, angular.copy(contains[relatedModel]));
                cov_2i6cb7s4x7.s[50]++;
                config['filters'] = (cov_2i6cb7s4x7.b[8][0]++, config['filters']) || (cov_2i6cb7s4x7.b[8][1]++, {});
                cov_2i6cb7s4x7.s[51]++;
                angular.forEach(config.filters, function (value, key) {
                    cov_2i6cb7s4x7.f[17]++;
                    cov_2i6cb7s4x7.s[52]++;

                    if (angular.isFunction(config.filters[key])) {
                        cov_2i6cb7s4x7.b[9][0]++;
                        cov_2i6cb7s4x7.s[53]++;

                        config.filters[key] = value();
                    } else {
                        cov_2i6cb7s4x7.b[9][1]++;
                    }
                });
                cov_2i6cb7s4x7.s[54]++;
                return config;
            } else {
                cov_2i6cb7s4x7.b[6][1]++;
                cov_2i6cb7s4x7.s[55]++;

                throw new Error('Cannot find MixinContainable configs for ' + relatedModel);
            }
        }

        cov_2i6cb7s4x7.s[56]++;
        return restmod.mixin({
            $extend: {
                Collection: {
                    $limit: 25,
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_2i6cb7s4x7.f[18]++;

                        var configs = (cov_2i6cb7s4x7.s[57]++, getModelConfigs(this, relatedModel));
                        cov_2i6cb7s4x7.s[58]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_2i6cb7s4x7.s[59]++;
                        return collectionLoad(this, relatedModel, configs, additionalFilters);
                    }
                },
                Record: {
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_2i6cb7s4x7.f[19]++;

                        var configs = (cov_2i6cb7s4x7.s[60]++, getModelConfigs(this, relatedModel));
                        cov_2i6cb7s4x7.s[61]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_2i6cb7s4x7.s[62]++;
                        return recordLoad(this, relatedModel, configs, additionalFilters);
                    }
                }
            },
            $hooks: {
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_2i6cb7s4x7.f[20]++;
                    cov_2i6cb7s4x7.s[63]++;

                    if (_.isUndefined(_req.params)) {
                        cov_2i6cb7s4x7.b[10][0]++;
                        cov_2i6cb7s4x7.s[64]++;

                        _req.params = {};
                    } else {
                        cov_2i6cb7s4x7.b[10][1]++;
                    }
                    cov_2i6cb7s4x7.s[65]++;
                    _req.params['page_size'] = (cov_2i6cb7s4x7.b[11][0]++, this.$limit) || (cov_2i6cb7s4x7.b[11][1]++, 25);
                }
            }
        });
    }
})();
'use strict';

var cov_1r8nc80a83 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.executions.factory.js',
        hash = '5577fdd87a124b6a01a92f64d756e310621ca75d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.executions.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 33,
                    column: 20
                },
                end: {
                    line: 33,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 27,
                        column: 24
                    },
                    end: {
                        line: 27,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 41
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 32,
                        column: 24
                    },
                    end: {
                        line: 32,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 41
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1r8nc80a83.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1r8nc80a83.f[0]++;
    cov_1r8nc80a83.s[1]++;
    angular.module('app').factory('ExecutionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1r8nc80a83.f[1]++;
        cov_1r8nc80a83.s[2]++;


        return restmod.model('/executions').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 10
                }
            },
            $config: {
                contains: {
                    task: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'task'
                    }
                }
            },
            start: {
                decode: function decode(value) {
                    cov_1r8nc80a83.f[2]++;
                    cov_1r8nc80a83.s[3]++;

                    return new Date(value);
                }
            },
            end: {
                decode: function decode(value) {
                    cov_1r8nc80a83.f[3]++;
                    cov_1r8nc80a83.s[4]++;

                    return new Date(value);
                }
            }
        });
    }
})();
'use strict';

var cov_1pt266ji14 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.deliverables.factory.js',
        hash = '2989929ddc6cba3d0883b526103d763e2e1e9758',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.deliverables.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1pt266ji14.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1pt266ji14.f[0]++;
    cov_1pt266ji14.s[1]++;
    angular.module('app').factory('DeliverablesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1pt266ji14.f[1]++;
        cov_1pt266ji14.s[2]++;


        return restmod.model('/deliverables').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    task: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'task'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_12py344ctj = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.config.js',
        hash = '4067c629227933e6eace76327e9b4f0b28bf898a',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_12py344ctj.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["restmodProvider", "AppSettings"];
    cov_12py344ctj.f[0]++;
    cov_12py344ctj.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        cov_12py344ctj.f[1]++;
        cov_12py344ctj.s[2]++;

        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        cov_12py344ctj.s[3]++;
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();
'use strict';

var cov_1gapwlbphg = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.comments.factory.js',
        hash = '71dd5116550bd7020372e3f8489ea54ca9bfea89',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.comments.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1gapwlbphg.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1gapwlbphg.f[0]++;
    cov_1gapwlbphg.s[1]++;
    angular.module('app').factory('CommentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1gapwlbphg.f[1]++;
        cov_1gapwlbphg.s[2]++;


        return restmod.model('/comments').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    task: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'objectId'
                    },
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_yin92i6ad = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/html/menuBtn/menuBtn.js',
        hash = '9f75b90278f12d1d11a712ed078302c8a681fa52',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/html/menuBtn/menuBtn.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 42
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 33
                    },
                    end: {
                        line: 6,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 15
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuBtnController = function () {
    MenuBtnController.$inject = ["$mdSidenav", "$transitions"];
    function MenuBtnController($mdSidenav, $transitions) {
        var _this = this;

        _classCallCheck(this, MenuBtnController);

        cov_yin92i6ad.f[0]++;
        cov_yin92i6ad.s[0]++;

        this.$mdSidenav = $mdSidenav;

        cov_yin92i6ad.s[1]++;
        $transitions.onStart({}, function () {
            cov_yin92i6ad.f[1]++;
            cov_yin92i6ad.s[2]++;

            _this.closeMenu();
        });
    }

    _createClass(MenuBtnController, [{
        key: 'openMenu',
        value: function openMenu() {
            cov_yin92i6ad.f[2]++;
            cov_yin92i6ad.s[3]++;

            this.$mdSidenav('menu').open();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            cov_yin92i6ad.f[3]++;
            cov_yin92i6ad.s[4]++;

            this.$mdSidenav('menu').close();
        }
    }]);

    return MenuBtnController;
}();

cov_yin92i6ad.s[5]++;


angular.module('app').component('menuBtn', {
    templateUrl: 'app/shared/html/menuBtn/menuBtn.html',
    controller: MenuBtnController
});
'use strict';

var cov_2p061xr9q4 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/html/deliveryInput/deliveryInput.js',
        hash = '4f6a49148378d64526500ad819a4b40045a0b896',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/html/deliveryInput/deliveryInput.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 32
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 56
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 26
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 15
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 10
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryInputController = function () {
    DeliveryInputController.$inject = ["$element"];
    function DeliveryInputController($element) {
        _classCallCheck(this, DeliveryInputController);

        cov_2p061xr9q4.f[0]++;
        cov_2p061xr9q4.s[0]++;

        this.element = $element;
    }

    _createClass(DeliveryInputController, [{
        key: 'changed',
        value: function changed() {
            cov_2p061xr9q4.f[1]++;
            cov_2p061xr9q4.s[1]++;

            this.ngChange({ $delivery: this.ngModel });
        }
    }, {
        key: 'setFocus',
        value: function setFocus() {
            cov_2p061xr9q4.f[2]++;
            cov_2p061xr9q4.s[2]++;

            this.element[0].children[0].children[1].focus();
        }
    }]);

    return DeliveryInputController;
}();

cov_2p061xr9q4.s[3]++;


angular.module('app').component('deliveryInput', {
    templateUrl: 'app/shared/html/deliveryInput/deliveryInput.html',
    controller: DeliveryInputController,
    bindings: {
        ngChange: '&',
        ngModel: '='
    }
});
'use strict';

var cov_bcmo87qn7 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userStatistic/userStatistic.js',
        hash = 'a1e7950807238b7500c6cd5909bbd3dc7a015de9',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userStatistic/userStatistic.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_bcmo87qn7.s[0]++;
angular.module('app').component('userStatistic', {
    templateUrl: 'app/components/userStatistic/userStatistic.html',
    bindings: {
        statistic: '<',
        searchContent: '='
    }
});
'use strict';

var cov_23gvvg89gs = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userProfile/userProfile.js',
        hash = 'cc0ec3f0d0f8c3aa61eb183430b2d193bf305842',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userProfile/userProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 10
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 16
                },
                end: {
                    line: 5,
                    column: 27
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 29
                },
                end: {
                    line: 10,
                    column: 49
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 27
                },
                end: {
                    line: 11,
                    column: 54
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 36
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 93
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 69
                },
                end: {
                    line: 15,
                    column: 91
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 34
                }
            },
            '11': {
                start: {
                    line: 30,
                    column: 18
                },
                end: {
                    line: 33,
                    column: 9
                }
            },
            '12': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 9
                }
            },
            '13': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 41
                }
            },
            '14': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 96
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 73
                },
                end: {
                    line: 37,
                    column: 94
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 30
                }
            },
            '17': {
                start: {
                    line: 42,
                    column: 0
                },
                end: {
                    line: 67,
                    column: 7
                }
            },
            '18': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 10
                }
            },
            '19': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 55,
                    column: 13
                }
            },
            '20': {
                start: {
                    line: 54,
                    column: 16
                },
                end: {
                    line: 54,
                    column: 29
                }
            },
            '21': {
                start: {
                    line: 57,
                    column: 27
                },
                end: {
                    line: 57,
                    column: 29
                }
            },
            '22': {
                start: {
                    line: 59,
                    column: 12
                },
                end: {
                    line: 63,
                    column: 15
                }
            },
            '23': {
                start: {
                    line: 60,
                    column: 16
                },
                end: {
                    line: 62,
                    column: 17
                }
            },
            '24': {
                start: {
                    line: 61,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 39
                }
            },
            '25': {
                start: {
                    line: 65,
                    column: 12
                },
                end: {
                    line: 65,
                    column: 28
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 4,
                        column: 20
                    },
                    end: {
                        line: 4,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 4,
                        column: 66
                    },
                    end: {
                        line: 6,
                        column: 13
                    }
                },
                line: 4
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 23
                    },
                    end: {
                        line: 7,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 34
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 26
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                line: 9
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 14,
                        column: 44
                    },
                    end: {
                        line: 14,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 17
                    }
                },
                line: 14
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 15,
                        column: 58
                    },
                    end: {
                        line: 15,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 69
                    },
                    end: {
                        line: 15,
                        column: 91
                    }
                },
                line: 15
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 14
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 22
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 24,
                        column: 35
                    },
                    end: {
                        line: 24,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 46
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 29,
                        column: 4
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 38
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 29
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 37,
                        column: 63
                    },
                    end: {
                        line: 37,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 73
                    },
                    end: {
                        line: 37,
                        column: 94
                    }
                },
                line: 37
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 51,
                        column: 23
                    },
                    end: {
                        line: 51,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 35
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                line: 51
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 52,
                        column: 15
                    },
                    end: {
                        line: 52,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 36
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                },
                line: 52
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 59,
                        column: 35
                    },
                    end: {
                        line: 59,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 51
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                },
                line: 59
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }, {
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }],
                line: 34
            },
            '1': {
                loc: {
                    start: {
                        line: 34,
                        column: 12
                    },
                    end: {
                        line: 34,
                        column: 49
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 34,
                        column: 12
                    },
                    end: {
                        line: 34,
                        column: 23
                    }
                }, {
                    start: {
                        line: 34,
                        column: 27
                    },
                    end: {
                        line: 34,
                        column: 49
                    }
                }],
                line: 34
            },
            '2': {
                loc: {
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                }, {
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                }],
                line: 53
            },
            '3': {
                loc: {
                    start: {
                        line: 53,
                        column: 16
                    },
                    end: {
                        line: 53,
                        column: 32
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 53,
                        column: 16
                    },
                    end: {
                        line: 53,
                        column: 19
                    }
                }, {
                    start: {
                        line: 53,
                        column: 23
                    },
                    end: {
                        line: 53,
                        column: 32
                    }
                }],
                line: 53
            },
            '4': {
                loc: {
                    start: {
                        line: 60,
                        column: 16
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 60,
                        column: 16
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                }, {
                    start: {
                        line: 60,
                        column: 16
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                }],
                line: 60
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProfileController = function () {
    function UserProfileController() {
        var _this = this;

        _classCallCheck(this, UserProfileController);

        cov_23gvvg89gs.f[0]++;
        cov_23gvvg89gs.s[0]++;

        this.sortableListeners = {
            accept: function accept(sourceItemHandleScope, destSortableScope) {
                cov_23gvvg89gs.f[1]++;
                cov_23gvvg89gs.s[1]++;

                return true;
            },
            itemMoved: function itemMoved(event) {
                cov_23gvvg89gs.f[2]++;
            },
            orderChanged: function orderChanged(event) {
                cov_23gvvg89gs.f[3]++;

                var newPos = (cov_23gvvg89gs.s[2]++, event.dest.index + 1);
                var task = (cov_23gvvg89gs.s[3]++, event.source.itemScope.task);
                cov_23gvvg89gs.s[4]++;
                task.order = newPos;

                cov_23gvvg89gs.s[5]++;
                task.$save(['order']).$then(function () {
                    cov_23gvvg89gs.f[4]++;
                    cov_23gvvg89gs.s[6]++;

                    _this.user.$openTasks.$refresh().$then(function (tasks) {
                        cov_23gvvg89gs.f[5]++;
                        cov_23gvvg89gs.s[7]++;
                        return tasks.$load('project');
                    });
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
    }

    _createClass(UserProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_23gvvg89gs.f[6]++;
            cov_23gvvg89gs.s[8]++;

            this.user.$load('openTasks');
            cov_23gvvg89gs.s[9]++;
            this.user.$openTasks.$then(function (tasks) {
                cov_23gvvg89gs.f[7]++;
                cov_23gvvg89gs.s[10]++;

                tasks.$load('project');
            });
        }
    }, {
        key: 'createTask',
        value: function createTask(taskName, taskProject) {
            cov_23gvvg89gs.f[8]++;

            var obj = (cov_23gvvg89gs.s[11]++, {
                name: taskName,
                user: this.user.id
            });
            cov_23gvvg89gs.s[12]++;
            if ((cov_23gvvg89gs.b[1][0]++, taskProject) && (cov_23gvvg89gs.b[1][1]++, taskProject !== 'None')) {
                cov_23gvvg89gs.b[0][0]++;
                cov_23gvvg89gs.s[13]++;

                obj['project'] = taskProject;
            } else {
                cov_23gvvg89gs.b[0][1]++;
            }
            cov_23gvvg89gs.s[14]++;
            this.newTask = this.user.$openTasks.$create(obj).$then(function (task) {
                cov_23gvvg89gs.f[9]++;
                cov_23gvvg89gs.s[15]++;
                return task.$load('project');
            });
            cov_23gvvg89gs.s[16]++;
            this.newTaskName = '';
        }
    }]);

    return UserProfileController;
}();

cov_23gvvg89gs.s[17]++;


angular.module('app').component('userProfile', {
    templateUrl: 'app/components/userProfile/userProfile.html',
    controller: UserProfileController,
    bindings: {
        user: '<'
    }
}).filter('project', function () {
    cov_23gvvg89gs.f[10]++;
    cov_23gvvg89gs.s[18]++;

    return function (items, id) {
        cov_23gvvg89gs.f[11]++;
        cov_23gvvg89gs.s[19]++;

        if ((cov_23gvvg89gs.b[3][0]++, !id) || (cov_23gvvg89gs.b[3][1]++, id == '*')) {
            cov_23gvvg89gs.b[2][0]++;
            cov_23gvvg89gs.s[20]++;

            return items;
        } else {
            cov_23gvvg89gs.b[2][1]++;
        }

        var filtered = (cov_23gvvg89gs.s[21]++, []);

        cov_23gvvg89gs.s[22]++;
        angular.forEach(items, function (item) {
            cov_23gvvg89gs.f[12]++;
            cov_23gvvg89gs.s[23]++;

            if (item.project == id) {
                cov_23gvvg89gs.b[4][0]++;
                cov_23gvvg89gs.s[24]++;

                filtered.push(item);
            } else {
                cov_23gvvg89gs.b[4][1]++;
            }
        });

        cov_23gvvg89gs.s[25]++;
        return filtered;
    };
});
;
'use strict';

var cov_7jxaxze69 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userHistory/userHistory.js',
        hash = 'f2921ed009727fb6f5dd1ca9711832491fb9b489',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userHistory/userHistory.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 52
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 39
                }
            },
            '6': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 15
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 8,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 69
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 8
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 14
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserHistoryController = function () {
    function UserHistoryController() {
        _classCallCheck(this, UserHistoryController);

        cov_7jxaxze69.f[0]++;
    }

    _createClass(UserHistoryController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_7jxaxze69.f[1]++;
            cov_7jxaxze69.s[0]++;

            this.user.$load('executions');

            cov_7jxaxze69.s[1]++;
            this.user.$executions.$on('after-feed', function (execution) {
                cov_7jxaxze69.f[2]++;
                cov_7jxaxze69.s[2]++;

                this.day = execution.start.slice(0, 10);
                cov_7jxaxze69.s[3]++;
                this.$load('task');
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            cov_7jxaxze69.f[3]++;
            cov_7jxaxze69.s[4]++;

            this.user.$executions.$page++;
            cov_7jxaxze69.s[5]++;
            this.user.$executions.$fetch();
        }
    }]);

    return UserHistoryController;
}();

cov_7jxaxze69.s[6]++;


angular.module('app').component('userHistory', {
    templateUrl: 'app/components/userHistory/userHistory.html',
    controller: UserHistoryController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_1atc947l3d = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userBadge/userBadge.js',
        hash = '924761c6bc5afb07a7f3378d1393c696c076d964',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userBadge/userBadge.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1atc947l3d.s[0]++;
angular.module('app').component('userBadge', {
    templateUrl: 'app/components/userBadge/userBadge.html',
    bindings: {
        user: '<',
        imgSize: '<'
    }
});
'use strict';

var cov_bf9pjdcbk = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/teamWorkingStatus/teamWorkingStatus.js',
        hash = '4ef29bb76cf25b613caf0228401b69418bb00427',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/teamWorkingStatus/teamWorkingStatus.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 36
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 37
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 52
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 15
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeamWorkingStatusController = function () {
    TeamWorkingStatusController.$inject = ["UsersTable", "$interval", "$rootScope"];
    function TeamWorkingStatusController(UsersTable, $interval, $rootScope) {
        _classCallCheck(this, TeamWorkingStatusController);

        cov_bf9pjdcbk.f[0]++;
        cov_bf9pjdcbk.s[0]++;

        this.team = UsersTable.$all;
        cov_bf9pjdcbk.s[1]++;
        this.me = $rootScope.me;
        cov_bf9pjdcbk.s[2]++;
        this.$rootScope = $rootScope;
    }

    _createClass(TeamWorkingStatusController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_bf9pjdcbk.f[1]++;
        }
    }]);

    return TeamWorkingStatusController;
}();

cov_bf9pjdcbk.s[3]++;


angular.module('app').component('teamWorkingStatus', {
    templateUrl: 'app/components/teamWorkingStatus/teamWorkingStatus.html',
    controller: TeamWorkingStatusController
});
'use strict';

var cov_iq0pcmyni = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/taskView/taskView.js',
        hash = 'a43499378096b02713aeafa647dd260df3a226d3',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/taskView/taskView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 44
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 15
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskViewController = function () {
    TaskViewController.$inject = ["UsersTable", "ProjectsTable"];
    function TaskViewController(UsersTable, ProjectsTable) {
        _classCallCheck(this, TaskViewController);

        cov_iq0pcmyni.f[0]++;
        cov_iq0pcmyni.s[0]++;

        this.users = UsersTable.$all;
        cov_iq0pcmyni.s[1]++;
        this.projects = ProjectsTable.$all;
    }

    _createClass(TaskViewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_iq0pcmyni.f[1]++;
            cov_iq0pcmyni.s[2]++;

            this.task.$load('project').$load('user');
        }
    }]);

    return TaskViewController;
}();

cov_iq0pcmyni.s[3]++;


angular.module('app').component('taskView', {
    templateUrl: 'app/components/taskView/taskView.html',
    controller: TaskViewController,
    bindings: {
        task: '<'
    }
});
'use strict';

var cov_1vruesktun = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/taskPreview/taskPreview.js',
        hash = '2cd1f53215f174edf062cfbb5c9e3447bc7b91b3',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/taskPreview/taskPreview.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 62
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 74
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 37
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 65
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 10,
                    column: 37
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 11
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 37
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 84
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 26,
                    column: 126
                },
                end: {
                    line: 26,
                    column: 148
                }
            },
            '13': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 32
                }
            },
            '14': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 31
                }
            },
            '15': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 74
                }
            },
            '17': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 32
                }
            },
            '18': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 9
                }
            },
            '19': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 48
                }
            },
            '20': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 74
                }
            },
            '22': {
                start: {
                    line: 48,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 32
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 29
                }
            },
            '24': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 45
                }
            },
            '25': {
                start: {
                    line: 58,
                    column: 19
                },
                end: {
                    line: 58,
                    column: 24
                }
            },
            '26': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 63,
                    column: 9
                }
            },
            '27': {
                start: {
                    line: 60,
                    column: 12
                },
                end: {
                    line: 62,
                    column: 13
                }
            },
            '28': {
                start: {
                    line: 61,
                    column: 16
                },
                end: {
                    line: 61,
                    column: 28
                }
            },
            '29': {
                start: {
                    line: 64,
                    column: 8
                },
                end: {
                    line: 64,
                    column: 20
                }
            },
            '30': {
                start: {
                    line: 68,
                    column: 8
                },
                end: {
                    line: 68,
                    column: 28
                }
            },
            '31': {
                start: {
                    line: 69,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 11
                }
            },
            '32': {
                start: {
                    line: 70,
                    column: 12
                },
                end: {
                    line: 70,
                    column: 32
                }
            },
            '33': {
                start: {
                    line: 75,
                    column: 8
                },
                end: {
                    line: 75,
                    column: 26
                }
            },
            '34': {
                start: {
                    line: 76,
                    column: 8
                },
                end: {
                    line: 78,
                    column: 11
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 12
                },
                end: {
                    line: 77,
                    column: 32
                }
            },
            '36': {
                start: {
                    line: 82,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 58
                }
            },
            '37': {
                start: {
                    line: 83,
                    column: 8
                },
                end: {
                    line: 85,
                    column: 11
                }
            },
            '38': {
                start: {
                    line: 84,
                    column: 11
                },
                end: {
                    line: 84,
                    column: 49
                }
            },
            '39': {
                start: {
                    line: 89,
                    column: 0
                },
                end: {
                    line: 118,
                    column: 3
                }
            },
            '40': {
                start: {
                    line: 101,
                    column: 4
                },
                end: {
                    line: 117,
                    column: 5
                }
            },
            '41': {
                start: {
                    line: 105,
                    column: 12
                },
                end: {
                    line: 115,
                    column: 14
                }
            },
            '42': {
                start: {
                    line: 106,
                    column: 35
                },
                end: {
                    line: 106,
                    column: 42
                }
            },
            '43': {
                start: {
                    line: 107,
                    column: 16
                },
                end: {
                    line: 109,
                    column: 17
                }
            },
            '44': {
                start: {
                    line: 108,
                    column: 20
                },
                end: {
                    line: 108,
                    column: 57
                }
            },
            '45': {
                start: {
                    line: 110,
                    column: 16
                },
                end: {
                    line: 110,
                    column: 58
                }
            },
            '46': {
                start: {
                    line: 112,
                    column: 16
                },
                end: {
                    line: 114,
                    column: 17
                }
            },
            '47': {
                start: {
                    line: 113,
                    column: 20
                },
                end: {
                    line: 113,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 101
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 35
                    },
                    end: {
                        line: 8,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 52
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 35
                    },
                    end: {
                        line: 14,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 52
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 4
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 14
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 23
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 112
                    },
                    end: {
                        line: 26,
                        column: 113
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 126
                    },
                    end: {
                        line: 26,
                        column: 148
                    }
                },
                line: 26
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 156
                    },
                    end: {
                        line: 26,
                        column: 157
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 162
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 16
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 31
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 19
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 35
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 36,
                        column: 47
                    },
                    end: {
                        line: 36,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 53
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                line: 36
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 31
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 42
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 46,
                        column: 46
                    },
                    end: {
                        line: 46,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 52
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 46
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 52,
                        column: 4
                    },
                    end: {
                        line: 52,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 19
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                line: 52
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 57,
                        column: 4
                    },
                    end: {
                        line: 57,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 16
                    },
                    end: {
                        line: 65,
                        column: 5
                    }
                },
                line: 57
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 67,
                        column: 4
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 14
                    },
                    end: {
                        line: 72,
                        column: 5
                    }
                },
                line: 67
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 69,
                        column: 32
                    },
                    end: {
                        line: 69,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 38
                    },
                    end: {
                        line: 71,
                        column: 9
                    }
                },
                line: 69
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 74,
                        column: 4
                    },
                    end: {
                        line: 74,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 16
                    },
                    end: {
                        line: 79,
                        column: 5
                    }
                },
                line: 74
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 76,
                        column: 32
                    },
                    end: {
                        line: 76,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 76,
                        column: 38
                    },
                    end: {
                        line: 78,
                        column: 9
                    }
                },
                line: 76
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 81,
                        column: 4
                    },
                    end: {
                        line: 81,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 32
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                line: 81
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 83,
                        column: 54
                    },
                    end: {
                        line: 83,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 69
                    },
                    end: {
                        line: 85,
                        column: 9
                    }
                },
                line: 83
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 100,
                        column: 31
                    },
                    end: {
                        line: 100,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 100,
                        column: 43
                    },
                    end: {
                        line: 118,
                        column: 1
                    }
                },
                line: 100
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 104,
                        column: 14
                    },
                    end: {
                        line: 104,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 104,
                        column: 52
                    },
                    end: {
                        line: 116,
                        column: 9
                    }
                },
                line: 104
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 105,
                        column: 25
                    },
                    end: {
                        line: 105,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 37
                    },
                    end: {
                        line: 111,
                        column: 13
                    }
                },
                line: 105
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 111,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 111,
                        column: 33
                    },
                    end: {
                        line: 115,
                        column: 13
                    }
                },
                line: 111
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 15
            },
            '2': {
                loc: {
                    start: {
                        line: 42,
                        column: 16
                    },
                    end: {
                        line: 42,
                        column: 29
                    }
                },
                type: 'default-arg',
                locations: [{
                    start: {
                        line: 42,
                        column: 24
                    },
                    end: {
                        line: 42,
                        column: 29
                    }
                }],
                line: 42
            },
            '3': {
                loc: {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }, {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }],
                line: 43
            },
            '4': {
                loc: {
                    start: {
                        line: 60,
                        column: 12
                    },
                    end: {
                        line: 62,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 60,
                        column: 12
                    },
                    end: {
                        line: 62,
                        column: 13
                    }
                }, {
                    start: {
                        line: 60,
                        column: 12
                    },
                    end: {
                        line: 62,
                        column: 13
                    }
                }],
                line: 60
            },
            '5': {
                loc: {
                    start: {
                        line: 112,
                        column: 16
                    },
                    end: {
                        line: 114,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 112,
                        column: 16
                    },
                    end: {
                        line: 114,
                        column: 17
                    }
                }, {
                    start: {
                        line: 112,
                        column: 16
                    },
                    end: {
                        line: 114,
                        column: 17
                    }
                }],
                line: 112
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskPreviewController = function () {
    TaskPreviewController.$inject = ["StartWorkingTable", "StopWorkingService", "$rootScope", "$scope", "NewExecutionModalService"];
    function TaskPreviewController(StartWorkingTable, StopWorkingService, $rootScope, $scope, NewExecutionModalService) {
        var _this = this;

        _classCallCheck(this, TaskPreviewController);

        cov_1vruesktun.f[0]++;
        cov_1vruesktun.s[0]++;

        this.startWorkingService = StartWorkingTable.$build();
        cov_1vruesktun.s[1]++;
        this.stopWorkingService = StopWorkingService.$build({ close: '0' });
        cov_1vruesktun.s[2]++;
        this.$rootScope = $rootScope;
        cov_1vruesktun.s[3]++;
        this.NewExecutionModalService = NewExecutionModalService;

        cov_1vruesktun.s[4]++;
        $scope.$on('task-stopped', function (event, args) {
            cov_1vruesktun.f[1]++;
            cov_1vruesktun.s[5]++;

            if (args.task.id == _this.task.id) {
                cov_1vruesktun.b[0][0]++;
                cov_1vruesktun.s[6]++;

                _this.task.$refresh();
            } else {
                cov_1vruesktun.b[0][1]++;
            }
        });

        cov_1vruesktun.s[7]++;
        $scope.$on('task-started', function (event, args) {
            cov_1vruesktun.f[2]++;
            cov_1vruesktun.s[8]++;

            if (_this.task.state == 'EXECUTING') {
                cov_1vruesktun.b[1][0]++;
                cov_1vruesktun.s[9]++;

                _this.task.$refresh();
            } else {
                cov_1vruesktun.b[1][1]++;
            }
        });
    }

    _createClass(TaskPreviewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1vruesktun.f[3]++;
            cov_1vruesktun.s[10]++;

            this.startWorkingService.task = this.stopWorkingService.task = this.task.id;
        }
    }, {
        key: 'loadDetailedInfo',
        value: function loadDetailedInfo() {
            var _this2 = this;

            cov_1vruesktun.f[4]++;
            cov_1vruesktun.s[11]++;

            this.task.$load('deliverables').$load('watchers').$load('comments').$load('executions').$comments.$then(function (comments) {
                cov_1vruesktun.f[5]++;
                cov_1vruesktun.s[12]++;
                return comments.$load('user');
            }).$then(function () {
                cov_1vruesktun.f[6]++;
                cov_1vruesktun.s[13]++;

                _this2._refreshData();
            });
        }
    }, {
        key: 'closeTask',
        value: function closeTask() {
            cov_1vruesktun.f[7]++;
            cov_1vruesktun.s[14]++;

            this.stopWorking(true);
        }
    }, {
        key: 'startWorking',
        value: function startWorking() {
            var _this3 = this;

            cov_1vruesktun.f[8]++;
            cov_1vruesktun.s[15]++;

            this.startWorkingService.$save().$then(function () {
                cov_1vruesktun.f[9]++;
                cov_1vruesktun.s[16]++;

                _this3.$rootScope.$broadcast('task-started', { task: _this3.task });
                cov_1vruesktun.s[17]++;
                _this3._refreshData();
            });
        }
    }, {
        key: 'stopWorking',
        value: function stopWorking() {
            var _this4 = this;

            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1vruesktun.b[2][0]++, false);
            cov_1vruesktun.f[10]++;
            cov_1vruesktun.s[18]++;

            if (close) {
                cov_1vruesktun.b[3][0]++;
                cov_1vruesktun.s[19]++;

                this.stopWorkingService.close = '1';
            } else {
                cov_1vruesktun.b[3][1]++;
            }
            cov_1vruesktun.s[20]++;
            this.stopWorkingService.$save().$then(function () {
                cov_1vruesktun.f[11]++;
                cov_1vruesktun.s[21]++;

                _this4.$rootScope.$broadcast('task-stopped', { task: _this4.task });
                cov_1vruesktun.s[22]++;
                _this4._refreshData();
            });
        }
    }, {
        key: '_refreshData',
        value: function _refreshData() {
            cov_1vruesktun.f[12]++;
            cov_1vruesktun.s[23]++;

            this.task.$refresh();
            cov_1vruesktun.s[24]++;
            this.$rootScope.refreshDynamicData();
        }
    }, {
        key: 'isWatcher',
        value: function isWatcher() {
            cov_1vruesktun.f[13]++;

            var flag = (cov_1vruesktun.s[25]++, false);
            cov_1vruesktun.s[26]++;
            for (var i = 0; i < this.task.$watchers.length; i++) {
                cov_1vruesktun.s[27]++;

                if (this.$rootScope.me.id === this.task.$watchers[i].user) {
                    cov_1vruesktun.b[4][0]++;
                    cov_1vruesktun.s[28]++;

                    flag = true;
                } else {
                    cov_1vruesktun.b[4][1]++;
                }
            }
            cov_1vruesktun.s[29]++;
            return flag;
        }
    }, {
        key: 'pinTask',
        value: function pinTask() {
            var _this5 = this;

            cov_1vruesktun.f[14]++;
            cov_1vruesktun.s[30]++;

            this.task.order = 0;
            cov_1vruesktun.s[31]++;
            this.task.$save().$then(function () {
                cov_1vruesktun.f[15]++;
                cov_1vruesktun.s[32]++;

                _this5._refreshData();
            });
        }
    }, {
        key: 'unpinTask',
        value: function unpinTask() {
            var _this6 = this;

            cov_1vruesktun.f[16]++;
            cov_1vruesktun.s[33]++;

            this.task.order++;
            cov_1vruesktun.s[34]++;
            this.task.$save().$then(function () {
                cov_1vruesktun.f[17]++;
                cov_1vruesktun.s[35]++;

                _this6._refreshData();
            });
        }
    }, {
        key: 'displayNewExecutionModal',
        value: function displayNewExecutionModal() {
            var _this7 = this;

            cov_1vruesktun.f[18]++;
            cov_1vruesktun.s[36]++;

            this.NewExecutionModalService.task = this.task.id;
            cov_1vruesktun.s[37]++;
            this.NewExecutionModalService.display().$then(function (execution) {
                cov_1vruesktun.f[19]++;
                cov_1vruesktun.s[38]++;

                _this7.task.$executions.$add(execution);
            });
        }
    }]);

    return TaskPreviewController;
}();

cov_1vruesktun.s[39]++;


angular.module('app').component('taskPreview', {
    templateUrl: 'app/components/taskPreview/taskPreview.html',
    controller: TaskPreviewController,
    bindings: {
        task: '<',
        isOpen: '=',
        displayMinimal: '<'
    }
}).directive('forceSelectFocus', function () {
    cov_1vruesktun.f[20]++;
    cov_1vruesktun.s[40]++;

    return {
        restrict: 'A',
        require: ['^^mdSelect', '^ngModel'],
        link: function link(scope, element, controller) {
            cov_1vruesktun.f[21]++;
            cov_1vruesktun.s[41]++;

            scope.$watch(function () {
                cov_1vruesktun.f[22]++;

                var foundElement = (cov_1vruesktun.s[42]++, element);
                cov_1vruesktun.s[43]++;
                while (!foundElement.hasClass('md-select-menu-container')) {
                    cov_1vruesktun.s[44]++;

                    foundElement = foundElement.parent();
                }
                cov_1vruesktun.s[45]++;
                return foundElement.hasClass('md-active');
            }, function (newVal) {
                cov_1vruesktun.f[23]++;
                cov_1vruesktun.s[46]++;

                if (newVal) {
                    cov_1vruesktun.b[5][0]++;
                    cov_1vruesktun.s[47]++;

                    element.focus();
                } else {
                    cov_1vruesktun.b[5][1]++;
                }
            });
        }
    };
});
'use strict';

var cov_1shis9lnzz = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/taskHeadline/taskHeadline.js',
        hash = '4511bcb2ecdff30d3b7e92f456ae6ad873244547',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/taskHeadline/taskHeadline.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 62
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 74
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 37
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 65
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 10,
                    column: 37
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 11
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 37
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 84
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 11
                }
            },
            '13': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 74
                }
            },
            '14': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 32
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 9
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 48
                }
            },
            '17': {
                start: {
                    line: 40,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 11
                }
            },
            '18': {
                start: {
                    line: 41,
                    column: 12
                },
                end: {
                    line: 41,
                    column: 74
                }
            },
            '19': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 32
                }
            },
            '20': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 29
                }
            },
            '21': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 45
                }
            },
            '22': {
                start: {
                    line: 52,
                    column: 0
                },
                end: {
                    line: 60,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 101
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 35
                    },
                    end: {
                        line: 8,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 52
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 35
                    },
                    end: {
                        line: 14,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 52
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 4
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 14
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 16
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 4
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 19
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 47
                    },
                    end: {
                        line: 30,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 53
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 30
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 31
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 36
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 40,
                        column: 46
                    },
                    end: {
                        line: 40,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 52
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                },
                line: 40
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 46,
                        column: 4
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 19
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 46
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 11,
                        column: 13
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 15
            },
            '2': {
                loc: {
                    start: {
                        line: 36,
                        column: 16
                    },
                    end: {
                        line: 36,
                        column: 29
                    }
                },
                type: 'default-arg',
                locations: [{
                    start: {
                        line: 36,
                        column: 24
                    },
                    end: {
                        line: 36,
                        column: 29
                    }
                }],
                line: 36
            },
            '3': {
                loc: {
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                }, {
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                }],
                line: 37
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskHeadlineController = function () {
    TaskHeadlineController.$inject = ["StartWorkingTable", "StopWorkingService", "$rootScope", "$scope", "NewExecutionModalService"];
    function TaskHeadlineController(StartWorkingTable, StopWorkingService, $rootScope, $scope, NewExecutionModalService) {
        var _this = this;

        _classCallCheck(this, TaskHeadlineController);

        cov_1shis9lnzz.f[0]++;
        cov_1shis9lnzz.s[0]++;

        this.startWorkingService = StartWorkingTable.$build();
        cov_1shis9lnzz.s[1]++;
        this.stopWorkingService = StopWorkingService.$build({ close: '0' });
        cov_1shis9lnzz.s[2]++;
        this.$rootScope = $rootScope;
        cov_1shis9lnzz.s[3]++;
        this.NewExecutionModalService = NewExecutionModalService;

        cov_1shis9lnzz.s[4]++;
        $scope.$on('task-stopped', function (event, args) {
            cov_1shis9lnzz.f[1]++;
            cov_1shis9lnzz.s[5]++;

            if (args.task.id == _this.task.id) {
                cov_1shis9lnzz.b[0][0]++;
                cov_1shis9lnzz.s[6]++;

                _this.task.$refresh();
            } else {
                cov_1shis9lnzz.b[0][1]++;
            }
        });

        cov_1shis9lnzz.s[7]++;
        $scope.$on('task-started', function (event, args) {
            cov_1shis9lnzz.f[2]++;
            cov_1shis9lnzz.s[8]++;

            if (_this.task.state == 'EXECUTING') {
                cov_1shis9lnzz.b[1][0]++;
                cov_1shis9lnzz.s[9]++;

                _this.task.$refresh();
            } else {
                cov_1shis9lnzz.b[1][1]++;
            }
        });
    }

    _createClass(TaskHeadlineController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1shis9lnzz.f[3]++;
            cov_1shis9lnzz.s[10]++;

            this.startWorkingService.task = this.stopWorkingService.task = this.task.id;
        }
    }, {
        key: 'closeTask',
        value: function closeTask() {
            cov_1shis9lnzz.f[4]++;
            cov_1shis9lnzz.s[11]++;

            this.stopWorking(true);
        }
    }, {
        key: 'startWorking',
        value: function startWorking() {
            var _this2 = this;

            cov_1shis9lnzz.f[5]++;
            cov_1shis9lnzz.s[12]++;

            this.startWorkingService.$save().$then(function () {
                cov_1shis9lnzz.f[6]++;
                cov_1shis9lnzz.s[13]++;

                _this2.$rootScope.$broadcast('task-started', { task: _this2.task });
                cov_1shis9lnzz.s[14]++;
                _this2._refreshData();
            });
        }
    }, {
        key: 'stopWorking',
        value: function stopWorking() {
            var _this3 = this;

            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1shis9lnzz.b[2][0]++, false);
            cov_1shis9lnzz.f[7]++;
            cov_1shis9lnzz.s[15]++;

            if (close) {
                cov_1shis9lnzz.b[3][0]++;
                cov_1shis9lnzz.s[16]++;

                this.stopWorkingService.close = '1';
            } else {
                cov_1shis9lnzz.b[3][1]++;
            }
            cov_1shis9lnzz.s[17]++;
            this.stopWorkingService.$save().$then(function () {
                cov_1shis9lnzz.f[8]++;
                cov_1shis9lnzz.s[18]++;

                _this3.$rootScope.$broadcast('task-stopped', { task: _this3.task });
                cov_1shis9lnzz.s[19]++;
                _this3._refreshData();
            });
        }
    }, {
        key: '_refreshData',
        value: function _refreshData() {
            cov_1shis9lnzz.f[9]++;
            cov_1shis9lnzz.s[20]++;

            this.task.$refresh();
            cov_1shis9lnzz.s[21]++;
            this.$rootScope.refreshDynamicData();
        }
    }]);

    return TaskHeadlineController;
}();

cov_1shis9lnzz.s[22]++;


angular.module('app').component('taskHeadline', {
    templateUrl: 'app/components/taskHeadline/taskHeadline.html',
    controller: TaskHeadlineController,
    bindings: {
        task: '<'
    }
});
'use strict';

var cov_25fudiiq64 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/statisticsList/statisticsList.js',
        hash = '7f2b386272a941818538689406ef9b024b072069',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/statisticsList/statisticsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 10
                }
            },
            '1': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 33
                }
            },
            '2': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 23,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 18
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 14
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 23
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 14
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-trailing-spaces,indent */
var StatisticsListController = function () {
    function StatisticsListController() {
        _classCallCheck(this, StatisticsListController);

        cov_25fudiiq64.f[0]++;
        cov_25fudiiq64.s[0]++;

        this.groups = [{ id: 'PROJECT', name: 'Projects' }, { id: 'USER', name: 'Users' }];
    }

    _createClass(StatisticsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_25fudiiq64.f[1]++;
            cov_25fudiiq64.s[1]++;

            this.groupBy = "PROJECT";
        }
    }, {
        key: 'updateStatistics',
        value: function updateStatistics() {
            cov_25fudiiq64.f[2]++;
            cov_25fudiiq64.s[2]++;

            this.statistics.$refresh({
                start_date__gt: this.startDate,
                end_date__lt: this.endDate,
                group_by: this.groupBy
            });
        }
    }]);

    return StatisticsListController;
}();

cov_25fudiiq64.s[3]++;


angular.module('app').component('statisticsList', {
    templateUrl: 'app/components/statisticsList/statisticsList.html',
    controller: StatisticsListController,
    bindings: {
        statistics: '<'
    }
});
'use strict';

var cov_1h2rdnnjaa = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/statisticDetails/statisticDetails.js',
        hash = '4407041011acadf018f1079fef2fe8776e052660',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/statisticDetails/statisticDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 17,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 15
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatisticDetailsController = function () {
    function StatisticDetailsController() {
        _classCallCheck(this, StatisticDetailsController);

        cov_1h2rdnnjaa.f[0]++;
    }

    _createClass(StatisticDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1h2rdnnjaa.f[1]++;
        }
    }, {
        key: 'filter',
        value: function filter() {
            cov_1h2rdnnjaa.f[2]++;
            cov_1h2rdnnjaa.s[0]++;

            this.statistics.$refresh({
                'start_date__gt': this.startDate,
                'end_date__lt': this.endDate
            });
        }
    }]);

    return StatisticDetailsController;
}();

cov_1h2rdnnjaa.s[1]++;


angular.module('app').component('statisticDetails', {
    templateUrl: 'app/components/statisticDetails/statisticDetails.html',
    controller: StatisticDetailsController,
    bindings: {
        statistics: '<'
    }
});
'use strict';

var cov_13v044lo5g = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/reportsView/reportsView.js',
        hash = 'd99eecdde701e99da11291005feb559a626813fb',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/reportsView/reportsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 48
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 78
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 55
                },
                end: {
                    line: 15,
                    column: 76
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 14
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 44
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 23
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 15,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 55
                    },
                    end: {
                        line: 15,
                        column: 76
                    }
                },
                line: 15
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 10,
                        column: 19
                    },
                    end: {
                        line: 10,
                        column: 42
                    }
                },
                type: 'default-arg',
                locations: [{
                    start: {
                        line: 10,
                        column: 26
                    },
                    end: {
                        line: 10,
                        column: 42
                    }
                }],
                line: 10
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsViewController = function () {
    function ReportsViewController() {
        _classCallCheck(this, ReportsViewController);

        cov_13v044lo5g.f[0]++;
        cov_13v044lo5g.s[0]++;

        this.currentWeek = moment().format('W');
    }

    _createClass(ReportsViewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_13v044lo5g.f[1]++;
            cov_13v044lo5g.s[1]++;

            this.reports.$load('user');
        }
    }, {
        key: 'generateReport',
        value: function generateReport() {
            var _this = this;

            var week = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_13v044lo5g.b[0][0]++, this.currentWeek);
            cov_13v044lo5g.f[2]++;
            cov_13v044lo5g.s[2]++;

            this.reports.$create({
                year: this.year,
                week: week
            }).$then(function () {
                cov_13v044lo5g.f[3]++;
                cov_13v044lo5g.s[3]++;

                _this.reports.$refresh().$then(function (reports) {
                    cov_13v044lo5g.f[4]++;
                    cov_13v044lo5g.s[4]++;
                    return reports.$load('user');
                });
            });
        }
    }]);

    return ReportsViewController;
}();

cov_13v044lo5g.s[5]++;


angular.module('app').component('reportsView', {
    templateUrl: 'app/components/reportsView/reportsView.html',
    controller: ReportsViewController,
    bindings: {
        reports: '<',
        year: '<'
    }
});
'use strict';

var cov_1fbkat2hkf = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/recurrentList/recurrentList.js',
        hash = 'be1ce9bb28d85b9d873afa07f775f4cce47a194f',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/recurrentList/recurrentList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 59
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 44
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 55
                }
            },
            '5': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 27
                }
            },
            '6': {
                start: {
                    line: 23,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 40
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 50
                    },
                    end: {
                        line: 8,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 63
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 8
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 18
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 14
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 18
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecurrentListController = function () {
    RecurrentListController.$inject = ["RecurrentModalService"];
    function RecurrentListController(RecurrentModalService) {
        _classCallCheck(this, RecurrentListController);

        cov_1fbkat2hkf.f[0]++;
        cov_1fbkat2hkf.s[0]++;

        this.RecurrentModalService = RecurrentModalService;
    }

    _createClass(RecurrentListController, [{
        key: 'displayNewRecurrentModal',
        value: function displayNewRecurrentModal() {
            var _this = this;

            cov_1fbkat2hkf.f[1]++;
            cov_1fbkat2hkf.s[1]++;

            this.RecurrentModalService.display().then(function (recurrent) {
                cov_1fbkat2hkf.f[2]++;
                cov_1fbkat2hkf.s[2]++;

                _this.recurrents.$add(recurrent);
                cov_1fbkat2hkf.s[3]++;
                _this.refreshList();
            });
        }
    }, {
        key: 'refreshList',
        value: function refreshList() {
            cov_1fbkat2hkf.f[3]++;
            cov_1fbkat2hkf.s[4]++;

            this.recurrents.$load('project').$load('user');
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            cov_1fbkat2hkf.f[4]++;
            cov_1fbkat2hkf.s[5]++;

            this.refreshList();
        }
    }]);

    return RecurrentListController;
}();

cov_1fbkat2hkf.s[6]++;


angular.module('app').component('recurrentList', {
    templateUrl: 'app/components/recurrentList/recurrentList.html',
    controller: RecurrentListController,
    bindings: {
        recurrents: '<'
    }
});
'use strict';

var cov_2qdmpjhsdb = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/recurrentDetails/recurrentDetails.js',
        hash = 'b901d412ddd659b330178a35c568659a3721d268',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/recurrentDetails/recurrentDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 48
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 31
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecurrentDetailsController = function RecurrentDetailsController(ProjectsTable) {
    _classCallCheck(this, RecurrentDetailsController);

    cov_2qdmpjhsdb.f[0]++;
    cov_2qdmpjhsdb.s[0]++;

    this.projects = ProjectsTable.$search();
};
RecurrentDetailsController.$inject = ["ProjectsTable"];

cov_2qdmpjhsdb.s[1]++;


angular.module('app').component('recurrentDetails', {
    templateUrl: 'app/components/recurrentDetails/recurrentDetails.html',
    controller: RecurrentDetailsController,
    bindings: {
        recurrent: '<'
    }
});
'use strict';

var cov_iu6u8gtog = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/projectsList/projectsList.js',
        hash = 'f36f67395128eeb2a4fbe9ae976ba88a207c5956',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/projectsList/projectsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 61
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 41
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 30
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 51
                    },
                    end: {
                        line: 7,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 64
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 11
                    },
                    end: {
                        line: 9,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsListController = function () {
    ProjectsListController.$inject = ["NewProjectModalService"];
    function ProjectsListController(NewProjectModalService) {
        _classCallCheck(this, ProjectsListController);

        cov_iu6u8gtog.f[0]++;
        cov_iu6u8gtog.s[0]++;

        this.NewProjectModalService = NewProjectModalService;
    }

    _createClass(ProjectsListController, [{
        key: 'displayNewProjectModal',
        value: function displayNewProjectModal() {
            var _this = this;

            cov_iu6u8gtog.f[1]++;
            cov_iu6u8gtog.s[1]++;

            this.NewProjectModalService.display().then(function (project) {
                cov_iu6u8gtog.f[2]++;
                cov_iu6u8gtog.s[2]++;

                _this.projects.$add(project);
            }, function () {
                cov_iu6u8gtog.f[3]++;
            });
        }
    }]);

    return ProjectsListController;
}();

cov_iu6u8gtog.s[3]++;


angular.module('app').component('projectsList', {
    templateUrl: 'app/components/projectsList/projectsList.html',
    controller: ProjectsListController,
    bindings: {
        projects: '<'
    }
});
'use strict';

var cov_29w7p51sxp = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/projectStories/projectStories.js',
        hash = '6a53c335e23a1c182dcfab038e32491be1acc898',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/projectStories/projectStories.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 31
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 25
                }
            },
            '4': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 24
                }
            },
            '5': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 47
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 22
                }
            },
            '8': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 110
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 36
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            },
            '11': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 20,
                    column: 66
                }
            },
            '12': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 51
                }
            },
            '13': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 51
                }
            },
            '14': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 22
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 64
                }
            },
            '16': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 65
                }
            },
            '17': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 9
                }
            },
            '18': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 44
                }
            },
            '19': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 20
                }
            },
            '20': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 75
                }
            },
            '21': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 61
                }
            },
            '22': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 9
                }
            },
            '23': {
                start: {
                    line: 45,
                    column: 12
                },
                end: {
                    line: 45,
                    column: 60
                }
            },
            '24': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 18
                }
            },
            '25': {
                start: {
                    line: 51,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 43
                }
            },
            '26': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 52,
                    column: 49
                }
            },
            '27': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 63,
                    column: 9
                }
            },
            '28': {
                start: {
                    line: 57,
                    column: 12
                },
                end: {
                    line: 57,
                    column: 37
                }
            },
            '29': {
                start: {
                    line: 60,
                    column: 12
                },
                end: {
                    line: 62,
                    column: 15
                }
            },
            '30': {
                start: {
                    line: 61,
                    column: 16
                },
                end: {
                    line: 61,
                    column: 50
                }
            },
            '31': {
                start: {
                    line: 67,
                    column: 8
                },
                end: {
                    line: 69,
                    column: 9
                }
            },
            '32': {
                start: {
                    line: 68,
                    column: 12
                },
                end: {
                    line: 68,
                    column: 49
                }
            },
            '33': {
                start: {
                    line: 70,
                    column: 8
                },
                end: {
                    line: 72,
                    column: 11
                }
            },
            '34': {
                start: {
                    line: 71,
                    column: 12
                },
                end: {
                    line: 71,
                    column: 127
                }
            },
            '35': {
                start: {
                    line: 76,
                    column: 20
                },
                end: {
                    line: 76,
                    column: 35
                }
            },
            '36': {
                start: {
                    line: 77,
                    column: 20
                },
                end: {
                    line: 77,
                    column: 22
                }
            },
            '37': {
                start: {
                    line: 78,
                    column: 21
                },
                end: {
                    line: 78,
                    column: 45
                }
            },
            '38': {
                start: {
                    line: 79,
                    column: 8
                },
                end: {
                    line: 92,
                    column: 9
                }
            },
            '39': {
                start: {
                    line: 80,
                    column: 12
                },
                end: {
                    line: 80,
                    column: 34
                }
            },
            '40': {
                start: {
                    line: 81,
                    column: 28
                },
                end: {
                    line: 81,
                    column: 32
                }
            },
            '41': {
                start: {
                    line: 82,
                    column: 12
                },
                end: {
                    line: 88,
                    column: 13
                }
            },
            '42': {
                start: {
                    line: 83,
                    column: 16
                },
                end: {
                    line: 83,
                    column: 43
                }
            },
            '43': {
                start: {
                    line: 84,
                    column: 16
                },
                end: {
                    line: 87,
                    column: 17
                }
            },
            '44': {
                start: {
                    line: 85,
                    column: 20
                },
                end: {
                    line: 85,
                    column: 38
                }
            },
            '45': {
                start: {
                    line: 86,
                    column: 20
                },
                end: {
                    line: 86,
                    column: 26
                }
            },
            '46': {
                start: {
                    line: 89,
                    column: 12
                },
                end: {
                    line: 91,
                    column: 13
                }
            },
            '47': {
                start: {
                    line: 90,
                    column: 16
                },
                end: {
                    line: 90,
                    column: 37
                }
            },
            '48': {
                start: {
                    line: 93,
                    column: 8
                },
                end: {
                    line: 93,
                    column: 21
                }
            },
            '49': {
                start: {
                    line: 97,
                    column: 0
                },
                end: {
                    line: 143,
                    column: 7
                }
            },
            '50': {
                start: {
                    line: 108,
                    column: 8
                },
                end: {
                    line: 142,
                    column: 10
                }
            },
            '51': {
                start: {
                    line: 113,
                    column: 16
                },
                end: {
                    line: 113,
                    column: 56
                }
            },
            '52': {
                start: {
                    line: 114,
                    column: 16
                },
                end: {
                    line: 114,
                    column: 77
                }
            },
            '53': {
                start: {
                    line: 115,
                    column: 16
                },
                end: {
                    line: 117,
                    column: 42
                }
            },
            '54': {
                start: {
                    line: 119,
                    column: 16
                },
                end: {
                    line: 119,
                    column: 52
                }
            },
            '55': {
                start: {
                    line: 121,
                    column: 16
                },
                end: {
                    line: 130,
                    column: 18
                }
            },
            '56': {
                start: {
                    line: 122,
                    column: 20
                },
                end: {
                    line: 122,
                    column: 37
                }
            },
            '57': {
                start: {
                    line: 123,
                    column: 20
                },
                end: {
                    line: 123,
                    column: 44
                }
            },
            '58': {
                start: {
                    line: 124,
                    column: 20
                },
                end: {
                    line: 129,
                    column: 21
                }
            },
            '59': {
                start: {
                    line: 125,
                    column: 24
                },
                end: {
                    line: 125,
                    column: 84
                }
            },
            '60': {
                start: {
                    line: 128,
                    column: 24
                },
                end: {
                    line: 128,
                    column: 52
                }
            },
            '61': {
                start: {
                    line: 132,
                    column: 16
                },
                end: {
                    line: 135,
                    column: 19
                }
            },
            '62': {
                start: {
                    line: 133,
                    column: 20
                },
                end: {
                    line: 133,
                    column: 34
                }
            },
            '63': {
                start: {
                    line: 134,
                    column: 20
                },
                end: {
                    line: 134,
                    column: 33
                }
            },
            '64': {
                start: {
                    line: 137,
                    column: 16
                },
                end: {
                    line: 140,
                    column: 19
                }
            },
            '65': {
                start: {
                    line: 138,
                    column: 20
                },
                end: {
                    line: 138,
                    column: 34
                }
            },
            '66': {
                start: {
                    line: 139,
                    column: 20
                },
                end: {
                    line: 139,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 50
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 17,
                        column: 4
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 17
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 19,
                        column: 64
                    },
                    end: {
                        line: 19,
                        column: 65
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 77
                    },
                    end: {
                        line: 21,
                        column: 9
                    }
                },
                line: 19
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 20
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 31
                    },
                    end: {
                        line: 38,
                        column: 5
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 40,
                        column: 4
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 15
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                line: 40
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 50,
                        column: 4
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 23
                    },
                    end: {
                        line: 53,
                        column: 5
                    }
                },
                line: 50
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 55,
                        column: 4
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 38
                    },
                    end: {
                        line: 64,
                        column: 5
                    }
                },
                line: 55
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 60,
                        column: 43
                    },
                    end: {
                        line: 60,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 49
                    },
                    end: {
                        line: 62,
                        column: 13
                    }
                },
                line: 60
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 66,
                        column: 4
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 18
                    },
                    end: {
                        line: 73,
                        column: 5
                    }
                },
                line: 66
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 70,
                        column: 36
                    },
                    end: {
                        line: 70,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 42
                    },
                    end: {
                        line: 72,
                        column: 9
                    }
                },
                line: 70
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 75,
                        column: 4
                    },
                    end: {
                        line: 75,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 75,
                        column: 29
                    },
                    end: {
                        line: 94,
                        column: 5
                    }
                },
                line: 75
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 107,
                        column: 27
                    },
                    end: {
                        line: 107,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 107,
                        column: 47
                    },
                    end: {
                        line: 143,
                        column: 5
                    }
                },
                line: 107
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 110,
                        column: 18
                    },
                    end: {
                        line: 110,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 56
                    },
                    end: {
                        line: 141,
                        column: 13
                    }
                },
                line: 110
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 121,
                        column: 25
                    },
                    end: {
                        line: 121,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 41
                    },
                    end: {
                        line: 130,
                        column: 17
                    }
                },
                line: 121
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 132,
                        column: 38
                    },
                    end: {
                        line: 132,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 132,
                        column: 54
                    },
                    end: {
                        line: 135,
                        column: 17
                    }
                },
                line: 132
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 137,
                        column: 41
                    },
                    end: {
                        line: 137,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 137,
                        column: 57
                    },
                    end: {
                        line: 140,
                        column: 17
                    }
                },
                line: 137
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 25,
                        column: 23
                    },
                    end: {
                        line: 25,
                        column: 50
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 25,
                        column: 44
                    },
                    end: {
                        line: 25,
                        column: 46
                    }
                }, {
                    start: {
                        line: 25,
                        column: 49
                    },
                    end: {
                        line: 25,
                        column: 50
                    }
                }],
                line: 25
            },
            '1': {
                loc: {
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }, {
                    start: {
                        line: 34,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }],
                line: 34
            },
            '2': {
                loc: {
                    start: {
                        line: 44,
                        column: 8
                    },
                    end: {
                        line: 46,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 44,
                        column: 8
                    },
                    end: {
                        line: 46,
                        column: 9
                    }
                }, {
                    start: {
                        line: 44,
                        column: 8
                    },
                    end: {
                        line: 46,
                        column: 9
                    }
                }],
                line: 44
            },
            '3': {
                loc: {
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 63,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 63,
                        column: 9
                    }
                }, {
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 63,
                        column: 9
                    }
                }],
                line: 56
            },
            '4': {
                loc: {
                    start: {
                        line: 67,
                        column: 8
                    },
                    end: {
                        line: 69,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 67,
                        column: 8
                    },
                    end: {
                        line: 69,
                        column: 9
                    }
                }, {
                    start: {
                        line: 67,
                        column: 8
                    },
                    end: {
                        line: 69,
                        column: 9
                    }
                }],
                line: 67
            },
            '5': {
                loc: {
                    start: {
                        line: 67,
                        column: 12
                    },
                    end: {
                        line: 67,
                        column: 75
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 67,
                        column: 12
                    },
                    end: {
                        line: 67,
                        column: 44
                    }
                }, {
                    start: {
                        line: 67,
                        column: 48
                    },
                    end: {
                        line: 67,
                        column: 75
                    }
                }],
                line: 67
            },
            '6': {
                loc: {
                    start: {
                        line: 84,
                        column: 16
                    },
                    end: {
                        line: 87,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 84,
                        column: 16
                    },
                    end: {
                        line: 87,
                        column: 17
                    }
                }, {
                    start: {
                        line: 84,
                        column: 16
                    },
                    end: {
                        line: 87,
                        column: 17
                    }
                }],
                line: 84
            },
            '7': {
                loc: {
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                }, {
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                }],
                line: 89
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectStoriesController = function () {
    ProjectStoriesController.$inject = ["UsersTable", "$rootScope", "$filter"];
    function ProjectStoriesController(UsersTable, $rootScope, $filter) {
        _classCallCheck(this, ProjectStoriesController);

        cov_29w7p51sxp.f[0]++;
        cov_29w7p51sxp.s[0]++;

        this.$filter = $filter;
        cov_29w7p51sxp.s[1]++;
        this.currentNav = 'user_stories';
        cov_29w7p51sxp.s[2]++;
        this.requestData = {};
        cov_29w7p51sxp.s[3]++;
        this.blocked = 0;
        cov_29w7p51sxp.s[4]++;
        this.roles = [];
    }

    _createClass(ProjectStoriesController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_29w7p51sxp.f[1]++;
            cov_29w7p51sxp.s[5]++;

            this.requestData.ordering = 'delivery';
            cov_29w7p51sxp.s[6]++;
            this.proposal.$load('stories');
            cov_29w7p51sxp.s[7]++;
            this.update();
            cov_29w7p51sxp.s[8]++;
            this.newStory = this.proposal.$stories.$build({ project: this.project.id, proposal: this.proposal.id });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this = this;

            cov_29w7p51sxp.f[2]++;
            cov_29w7p51sxp.s[9]++;

            this.currentDelivery = null;
            cov_29w7p51sxp.s[10]++;
            this.proposal.$stories.$refresh(this.requestData).$then(function (stories) {
                cov_29w7p51sxp.f[3]++;
                cov_29w7p51sxp.s[11]++;

                _this.currentDelivery = _this.getFirstDelivery(stories);
            });
        }
    }, {
        key: 'filterBlocked',
        value: function filterBlocked() {
            cov_29w7p51sxp.f[4]++;
            cov_29w7p51sxp.s[12]++;

            this.blocked = this.blocked === 1 ? (cov_29w7p51sxp.b[0][0]++, '') : (cov_29w7p51sxp.b[0][1]++, 1);
            cov_29w7p51sxp.s[13]++;
            this.requestData.is_blocked = this.blocked;
            cov_29w7p51sxp.s[14]++;
            this.update();
        }
    }, {
        key: 'getFirstDelivery',
        value: function getFirstDelivery(stories) {
            cov_29w7p51sxp.f[5]++;

            var filtered;
            cov_29w7p51sxp.s[15]++;
            filtered = this.$filter('orderBy')(stories, 'delivery');
            cov_29w7p51sxp.s[16]++;
            filtered = this.$filter('groupBy')(filtered, 'delivery');
            cov_29w7p51sxp.s[17]++;
            if (Object.keys(filtered).length > 0) {
                cov_29w7p51sxp.b[1][0]++;
                cov_29w7p51sxp.s[18]++;

                return Object.keys(filtered)[0];
            } else {
                cov_29w7p51sxp.b[1][1]++;
            }
            cov_29w7p51sxp.s[19]++;
            return null;
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            cov_29w7p51sxp.f[6]++;

            var filtered;
            cov_29w7p51sxp.s[20]++;
            filtered = this.$filter('orderBy')(this.proposal.$stories, 'role');
            cov_29w7p51sxp.s[21]++;
            filtered = this.$filter('groupBy')(filtered, 'role');
            cov_29w7p51sxp.s[22]++;
            if (Object.keys(filtered).length > 0) {
                cov_29w7p51sxp.b[2][0]++;
                cov_29w7p51sxp.s[23]++;

                return this.roles.concat(Object.keys(filtered));
            } else {
                cov_29w7p51sxp.b[2][1]++;
            }
            cov_29w7p51sxp.s[24]++;
            return [];
        }
    }, {
        key: 'changeBlock',
        value: function changeBlock(story) {
            cov_29w7p51sxp.f[7]++;
            cov_29w7p51sxp.s[25]++;

            story.isBlocked = !story.isBlocked;
            cov_29w7p51sxp.s[26]++;
            this.changeAttribute(story, 'isBlocked');
        }
    }, {
        key: 'changeAttribute',
        value: function changeAttribute(story, attribute) {
            var _this2 = this;

            cov_29w7p51sxp.f[8]++;
            cov_29w7p51sxp.s[27]++;

            if (story.version === null) {
                cov_29w7p51sxp.b[3][0]++;
                cov_29w7p51sxp.s[28]++;

                story.$save([attribute]);
            } else {
                cov_29w7p51sxp.b[3][1]++;
                cov_29w7p51sxp.s[29]++;

                story.$save([attribute]).$then(function () {
                    cov_29w7p51sxp.f[9]++;
                    cov_29w7p51sxp.s[30]++;

                    _this2.proposal.$stories.$refresh();
                });
            }
        }
    }, {
        key: 'createStory',
        value: function createStory() {
            var _this3 = this;

            cov_29w7p51sxp.f[10]++;
            cov_29w7p51sxp.s[31]++;

            if ((cov_29w7p51sxp.b[5][0]++, this.newStory.role === undefined) || (cov_29w7p51sxp.b[5][1]++, this.newStory.role === null)) {
                cov_29w7p51sxp.b[4][0]++;
                cov_29w7p51sxp.s[32]++;

                this.newStory.role = this.searchText;
            } else {
                cov_29w7p51sxp.b[4][1]++;
            }
            cov_29w7p51sxp.s[33]++;
            this.newStory.$save().$then(function () {
                cov_29w7p51sxp.f[11]++;
                cov_29w7p51sxp.s[34]++;

                _this3.newStory = _this3.proposal.$stories.$build({ project: _this3.project.id, proposal: _this3.proposal.id, delivery: 1 });
            });
        }
    }, {
        key: 'querySearch',
        value: function querySearch(searchText) {
            cov_29w7p51sxp.f[12]++;

            var roles = (cov_29w7p51sxp.s[35]++, this.getRoles());
            var items = (cov_29w7p51sxp.s[36]++, []);
            var search = (cov_29w7p51sxp.s[37]++, searchText.toLowerCase());
            cov_29w7p51sxp.s[38]++;
            for (var i = 0; i < roles.length; i++) {
                cov_29w7p51sxp.s[39]++;

                console.log(roles[i]);
                var contained = (cov_29w7p51sxp.s[40]++, true);
                cov_29w7p51sxp.s[41]++;
                for (var j = 0; j < searchText.length; j++) {
                    cov_29w7p51sxp.s[42]++;

                    console.log(searchText[j]);
                    cov_29w7p51sxp.s[43]++;
                    if (roles[i].toLowerCase().indexOf(search[j]) === -1) {
                        cov_29w7p51sxp.b[6][0]++;
                        cov_29w7p51sxp.s[44]++;

                        contained = false;
                        cov_29w7p51sxp.s[45]++;
                        break;
                    } else {
                        cov_29w7p51sxp.b[6][1]++;
                    }
                }
                cov_29w7p51sxp.s[46]++;
                if (contained) {
                    cov_29w7p51sxp.b[7][0]++;
                    cov_29w7p51sxp.s[47]++;

                    items.push(roles[i]);
                } else {
                    cov_29w7p51sxp.b[7][1]++;
                }
            }
            cov_29w7p51sxp.s[48]++;
            return items;
        }
    }]);

    return ProjectStoriesController;
}();

cov_29w7p51sxp.s[49]++;


angular.module('app').component('projectStories', {
    templateUrl: 'app/components/projectStories/projectStories.html',
    controller: ProjectStoriesController,
    bindings: {
        project: '<',
        proposal: '<'
    }
}).directive('autosize', ["$document", function ($document) {
    cov_29w7p51sxp.f[13]++;
    cov_29w7p51sxp.s[50]++;

    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, ctrl) {
            cov_29w7p51sxp.f[14]++;

            var span, resize;

            cov_29w7p51sxp.s[51]++;
            span = angular.element('<span></span>');
            cov_29w7p51sxp.s[52]++;
            span[0].style.cssText = getComputedStyle(element[0]).cssText;
            cov_29w7p51sxp.s[53]++;
            span.css('display', 'none').css('visibility', 'hidden').css('width', 'auto');

            cov_29w7p51sxp.s[54]++;
            $document.find('body').append(span);

            cov_29w7p51sxp.s[55]++;
            resize = function resize(value) {
                cov_29w7p51sxp.f[15]++;
                cov_29w7p51sxp.s[56]++;

                span.text(value);
                cov_29w7p51sxp.s[57]++;
                span.css('display', '');
                cov_29w7p51sxp.s[58]++;
                try {
                    cov_29w7p51sxp.s[59]++;

                    element.css('width', span.prop('offsetWidth') + 2 + 'px');
                } finally {
                    cov_29w7p51sxp.s[60]++;

                    span.css('display', 'none');
                }
            };

            cov_29w7p51sxp.s[61]++;
            ctrl.$parsers.unshift(function (value) {
                cov_29w7p51sxp.f[16]++;
                cov_29w7p51sxp.s[62]++;

                resize(value);
                cov_29w7p51sxp.s[63]++;
                return value;
            });

            cov_29w7p51sxp.s[64]++;
            ctrl.$formatters.unshift(function (value) {
                cov_29w7p51sxp.f[17]++;
                cov_29w7p51sxp.s[65]++;

                resize(value);
                cov_29w7p51sxp.s[66]++;
                return value;
            });
        }
    };
}]);
'use strict';

var cov_2aif0omwvg = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/projectStatistic/projectStatistic.js',
        hash = '65c854658b8a4917ed6fafe4f651cc12d8a3b29b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/projectStatistic/projectStatistic.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2aif0omwvg.s[0]++;
angular.module('app').component('projectStatistic', {
    templateUrl: 'app/components/projectStatistic/projectStatistic.html',
    bindings: {
        statistic: '<'
    }
});
'use strict';

var cov_2cuu6w70ki = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/projectSelector/projectSelector.js',
        hash = '073c488b564037d9cb382dd77949919987d50264',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/projectSelector/projectSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 9
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 12
                },
                end: {
                    line: 4,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 15
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }, {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }],
                line: 3
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectSelectorController = function () {
    function ProjectSelectorController() {
        _classCallCheck(this, ProjectSelectorController);
    }

    _createClass(ProjectSelectorController, [{
        key: 'changed',
        value: function changed() {
            cov_2cuu6w70ki.f[0]++;
            cov_2cuu6w70ki.s[0]++;

            if (this.ngModel == 'null') {
                cov_2cuu6w70ki.b[0][0]++;
                cov_2cuu6w70ki.s[1]++;

                this.ngModel = null;
            } else {
                cov_2cuu6w70ki.b[0][1]++;
            }
            cov_2cuu6w70ki.s[2]++;
            this.ngChange({ $project: this.ngModel });
        }
    }]);

    return ProjectSelectorController;
}();

cov_2cuu6w70ki.s[3]++;


angular.module('app').component('projectSelector', {
    templateUrl: 'app/components/projectSelector/projectSelector.html',
    controller: ProjectSelectorController,
    bindings: {
        ngChange: '&',
        ngModel: '='
    }
});
'use strict';

var cov_22wcmjkpzy = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/projectDetails/projectDetails.js',
        hash = 'b839089f946b3f705441a8a15c4f3d617557d8fd',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/projectDetails/projectDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 44
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 31
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 34
                }
            },
            '5': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 36
                }
            },
            '6': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 29
                }
            },
            '7': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 24
                }
            },
            '8': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 29
                }
            },
            '9': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 55
                }
            },
            '10': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 41
                }
            },
            '11': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 73
                }
            },
            '12': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 89
                }
            },
            '13': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 40
                }
            },
            '14': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 38
                }
            },
            '15': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 66
                }
            },
            '16': {
                start: {
                    line: 21,
                    column: 45
                },
                end: {
                    line: 21,
                    column: 64
                }
            },
            '17': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 11
                }
            },
            '18': {
                start: {
                    line: 23,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 53
                }
            },
            '19': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 9
                }
            },
            '20': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 55
                }
            },
            '21': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 37
                }
            },
            '22': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 36
                }
            },
            '23': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 41
                }
            },
            '24': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 43
                }
            },
            '25': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 61
                }
            },
            '26': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 39
                }
            },
            '27': {
                start: {
                    line: 40,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 66
                }
            },
            '28': {
                start: {
                    line: 40,
                    column: 45
                },
                end: {
                    line: 40,
                    column: 64
                }
            },
            '29': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 44,
                    column: 24
                }
            },
            '30': {
                start: {
                    line: 45,
                    column: 22
                },
                end: {
                    line: 45,
                    column: 95
                }
            },
            '31': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 52,
                    column: 11
                }
            },
            '32': {
                start: {
                    line: 47,
                    column: 33
                },
                end: {
                    line: 47,
                    column: 103
                }
            },
            '33': {
                start: {
                    line: 48,
                    column: 27
                },
                end: {
                    line: 48,
                    column: 74
                }
            },
            '34': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 51,
                    column: 13
                }
            },
            '35': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 51
                }
            },
            '36': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 29
                }
            },
            '37': {
                start: {
                    line: 57,
                    column: 22
                },
                end: {
                    line: 57,
                    column: 99
                }
            },
            '38': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 64,
                    column: 11
                }
            },
            '39': {
                start: {
                    line: 59,
                    column: 33
                },
                end: {
                    line: 59,
                    column: 103
                }
            },
            '40': {
                start: {
                    line: 60,
                    column: 27
                },
                end: {
                    line: 60,
                    column: 78
                }
            },
            '41': {
                start: {
                    line: 61,
                    column: 12
                },
                end: {
                    line: 63,
                    column: 13
                }
            },
            '42': {
                start: {
                    line: 62,
                    column: 16
                },
                end: {
                    line: 62,
                    column: 56
                }
            },
            '43': {
                start: {
                    line: 68,
                    column: 8
                },
                end: {
                    line: 68,
                    column: 35
                }
            },
            '44': {
                start: {
                    line: 69,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 11
                }
            },
            '45': {
                start: {
                    line: 70,
                    column: 12
                },
                end: {
                    line: 70,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 71,
                    column: 12
                },
                end: {
                    line: 71,
                    column: 36
                }
            },
            '47': {
                start: {
                    line: 72,
                    column: 12
                },
                end: {
                    line: 72,
                    column: 41
                }
            },
            '48': {
                start: {
                    line: 73,
                    column: 12
                },
                end: {
                    line: 73,
                    column: 43
                }
            },
            '49': {
                start: {
                    line: 78,
                    column: 23
                },
                end: {
                    line: 78,
                    column: 99
                }
            },
            '50': {
                start: {
                    line: 79,
                    column: 8
                },
                end: {
                    line: 80,
                    column: 26
                }
            },
            '51': {
                start: {
                    line: 79,
                    column: 33
                },
                end: {
                    line: 79,
                    column: 45
                }
            },
            '52': {
                start: {
                    line: 80,
                    column: 13
                },
                end: {
                    line: 80,
                    column: 26
                }
            },
            '53': {
                start: {
                    line: 84,
                    column: 23
                },
                end: {
                    line: 84,
                    column: 99
                }
            },
            '54': {
                start: {
                    line: 85,
                    column: 22
                },
                end: {
                    line: 85,
                    column: 23
                }
            },
            '55': {
                start: {
                    line: 86,
                    column: 21
                },
                end: {
                    line: 86,
                    column: 26
                }
            },
            '56': {
                start: {
                    line: 87,
                    column: 8
                },
                end: {
                    line: 92,
                    column: 11
                }
            },
            '57': {
                start: {
                    line: 88,
                    column: 12
                },
                end: {
                    line: 90,
                    column: 13
                }
            },
            '58': {
                start: {
                    line: 89,
                    column: 16
                },
                end: {
                    line: 89,
                    column: 30
                }
            },
            '59': {
                start: {
                    line: 91,
                    column: 12
                },
                end: {
                    line: 91,
                    column: 25
                }
            },
            '60': {
                start: {
                    line: 93,
                    column: 8
                },
                end: {
                    line: 93,
                    column: 22
                }
            },
            '61': {
                start: {
                    line: 97,
                    column: 18
                },
                end: {
                    line: 100,
                    column: 9
                }
            },
            '62': {
                start: {
                    line: 101,
                    column: 8
                },
                end: {
                    line: 103,
                    column: 9
                }
            },
            '63': {
                start: {
                    line: 102,
                    column: 12
                },
                end: {
                    line: 102,
                    column: 31
                }
            },
            '64': {
                start: {
                    line: 105,
                    column: 8
                },
                end: {
                    line: 105,
                    column: 92
                }
            },
            '65': {
                start: {
                    line: 105,
                    column: 72
                },
                end: {
                    line: 105,
                    column: 90
                }
            },
            '66': {
                start: {
                    line: 106,
                    column: 8
                },
                end: {
                    line: 106,
                    column: 30
                }
            },
            '67': {
                start: {
                    line: 110,
                    column: 18
                },
                end: {
                    line: 114,
                    column: 9
                }
            },
            '68': {
                start: {
                    line: 115,
                    column: 8
                },
                end: {
                    line: 115,
                    column: 64
                }
            },
            '69': {
                start: {
                    line: 116,
                    column: 8
                },
                end: {
                    line: 116,
                    column: 34
                }
            },
            '70': {
                start: {
                    line: 117,
                    column: 8
                },
                end: {
                    line: 117,
                    column: 37
                }
            },
            '71': {
                start: {
                    line: 121,
                    column: 8
                },
                end: {
                    line: 124,
                    column: 11
                }
            },
            '72': {
                start: {
                    line: 122,
                    column: 12
                },
                end: {
                    line: 122,
                    column: 33
                }
            },
            '73': {
                start: {
                    line: 123,
                    column: 12
                },
                end: {
                    line: 123,
                    column: 47
                }
            },
            '74': {
                start: {
                    line: 128,
                    column: 8
                },
                end: {
                    line: 128,
                    column: 68
                }
            },
            '75': {
                start: {
                    line: 129,
                    column: 8
                },
                end: {
                    line: 131,
                    column: 11
                }
            },
            '76': {
                start: {
                    line: 130,
                    column: 12
                },
                end: {
                    line: 130,
                    column: 45
                }
            },
            '77': {
                start: {
                    line: 135,
                    column: 0
                },
                end: {
                    line: 159,
                    column: 7
                }
            },
            '78': {
                start: {
                    line: 145,
                    column: 8
                },
                end: {
                    line: 158,
                    column: 10
                }
            },
            '79': {
                start: {
                    line: 146,
                    column: 25
                },
                end: {
                    line: 146,
                    column: 27
                }
            },
            '80': {
                start: {
                    line: 147,
                    column: 12
                },
                end: {
                    line: 156,
                    column: 15
                }
            },
            '81': {
                start: {
                    line: 148,
                    column: 16
                },
                end: {
                    line: 155,
                    column: 17
                }
            },
            '82': {
                start: {
                    line: 149,
                    column: 20
                },
                end: {
                    line: 154,
                    column: 21
                }
            },
            '83': {
                start: {
                    line: 150,
                    column: 24
                },
                end: {
                    line: 150,
                    column: 42
                }
            },
            '84': {
                start: {
                    line: 152,
                    column: 25
                },
                end: {
                    line: 154,
                    column: 21
                }
            },
            '85': {
                start: {
                    line: 153,
                    column: 24
                },
                end: {
                    line: 153,
                    column: 42
                }
            },
            '86': {
                start: {
                    line: 157,
                    column: 12
                },
                end: {
                    line: 157,
                    column: 26
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 123
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 17,
                        column: 4
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 14
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 17
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 21,
                        column: 34
                    },
                    end: {
                        line: 21,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 45
                    },
                    end: {
                        line: 21,
                        column: 64
                    }
                },
                line: 21
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 22,
                        column: 38
                    },
                    end: {
                        line: 22,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 44
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 4
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 29
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 37,
                        column: 4
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 24
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 37
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 40,
                        column: 34
                    },
                    end: {
                        line: 40,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 45
                    },
                    end: {
                        line: 40,
                        column: 64
                    }
                },
                line: 40
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 23
                    },
                    end: {
                        line: 53,
                        column: 5
                    }
                },
                line: 43
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 46,
                        column: 22
                    },
                    end: {
                        line: 46,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 44
                    },
                    end: {
                        line: 52,
                        column: 9
                    }
                },
                line: 46
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 55,
                        column: 4
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 28
                    },
                    end: {
                        line: 65,
                        column: 5
                    }
                },
                line: 55
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 58,
                        column: 22
                    },
                    end: {
                        line: 58,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 44
                    },
                    end: {
                        line: 64,
                        column: 9
                    }
                },
                line: 58
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 67,
                        column: 4
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 28
                    },
                    end: {
                        line: 75,
                        column: 5
                    }
                },
                line: 67
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 69,
                        column: 47
                    },
                    end: {
                        line: 69,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 53
                    },
                    end: {
                        line: 74,
                        column: 9
                    }
                },
                line: 69
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 77,
                        column: 4
                    },
                    end: {
                        line: 77,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 17
                    },
                    end: {
                        line: 81,
                        column: 5
                    }
                },
                line: 77
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 83,
                        column: 4
                    },
                    end: {
                        line: 83,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 16
                    },
                    end: {
                        line: 94,
                        column: 5
                    }
                },
                line: 83
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 87,
                        column: 34
                    },
                    end: {
                        line: 87,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 87,
                        column: 45
                    },
                    end: {
                        line: 92,
                        column: 9
                    }
                },
                line: 87
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 96,
                        column: 4
                    },
                    end: {
                        line: 96,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 96,
                        column: 27
                    },
                    end: {
                        line: 107,
                        column: 5
                    }
                },
                line: 96
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 105,
                        column: 62
                    },
                    end: {
                        line: 105,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 72
                    },
                    end: {
                        line: 105,
                        column: 90
                    }
                },
                line: 105
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 109,
                        column: 4
                    },
                    end: {
                        line: 109,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 32
                    },
                    end: {
                        line: 118,
                        column: 5
                    }
                },
                line: 109
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 120,
                        column: 4
                    },
                    end: {
                        line: 120,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 120,
                        column: 21
                    },
                    end: {
                        line: 125,
                        column: 5
                    }
                },
                line: 120
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 121,
                        column: 39
                    },
                    end: {
                        line: 121,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 45
                    },
                    end: {
                        line: 124,
                        column: 9
                    }
                },
                line: 121
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 127,
                        column: 4
                    },
                    end: {
                        line: 127,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 127,
                        column: 35
                    },
                    end: {
                        line: 132,
                        column: 5
                    }
                },
                line: 127
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 129,
                        column: 57
                    },
                    end: {
                        line: 129,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 129,
                        column: 63
                    },
                    end: {
                        line: 131,
                        column: 9
                    }
                },
                line: 129
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 144,
                        column: 29
                    },
                    end: {
                        line: 144,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 53
                    },
                    end: {
                        line: 159,
                        column: 5
                    }
                },
                line: 144
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 145,
                        column: 15
                    },
                    end: {
                        line: 145,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 41
                    },
                    end: {
                        line: 158,
                        column: 9
                    }
                },
                line: 145
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 147,
                        column: 35
                    },
                    end: {
                        line: 147,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 147,
                        column: 51
                    },
                    end: {
                        line: 156,
                        column: 13
                    }
                },
                line: 147
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 28,
                        column: 8
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 28,
                        column: 8
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                }, {
                    start: {
                        line: 28,
                        column: 8
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                }],
                line: 28
            },
            '1': {
                loc: {
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }, {
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }],
                line: 49
            },
            '2': {
                loc: {
                    start: {
                        line: 49,
                        column: 16
                    },
                    end: {
                        line: 49,
                        column: 74
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 49,
                        column: 16
                    },
                    end: {
                        line: 49,
                        column: 38
                    }
                }, {
                    start: {
                        line: 49,
                        column: 42
                    },
                    end: {
                        line: 49,
                        column: 74
                    }
                }],
                line: 49
            },
            '3': {
                loc: {
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                }, {
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                }],
                line: 61
            },
            '4': {
                loc: {
                    start: {
                        line: 61,
                        column: 16
                    },
                    end: {
                        line: 61,
                        column: 74
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 61,
                        column: 16
                    },
                    end: {
                        line: 61,
                        column: 38
                    }
                }, {
                    start: {
                        line: 61,
                        column: 42
                    },
                    end: {
                        line: 61,
                        column: 74
                    }
                }],
                line: 61
            },
            '5': {
                loc: {
                    start: {
                        line: 79,
                        column: 8
                    },
                    end: {
                        line: 80,
                        column: 26
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 79,
                        column: 8
                    },
                    end: {
                        line: 80,
                        column: 26
                    }
                }, {
                    start: {
                        line: 79,
                        column: 8
                    },
                    end: {
                        line: 80,
                        column: 26
                    }
                }],
                line: 79
            },
            '6': {
                loc: {
                    start: {
                        line: 88,
                        column: 12
                    },
                    end: {
                        line: 90,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 88,
                        column: 12
                    },
                    end: {
                        line: 90,
                        column: 13
                    }
                }, {
                    start: {
                        line: 88,
                        column: 12
                    },
                    end: {
                        line: 90,
                        column: 13
                    }
                }],
                line: 88
            },
            '7': {
                loc: {
                    start: {
                        line: 88,
                        column: 16
                    },
                    end: {
                        line: 88,
                        column: 74
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 88,
                        column: 16
                    },
                    end: {
                        line: 88,
                        column: 42
                    }
                }, {
                    start: {
                        line: 88,
                        column: 46
                    },
                    end: {
                        line: 88,
                        column: 74
                    }
                }],
                line: 88
            },
            '8': {
                loc: {
                    start: {
                        line: 101,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 101,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                }, {
                    start: {
                        line: 101,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                }],
                line: 101
            },
            '9': {
                loc: {
                    start: {
                        line: 101,
                        column: 12
                    },
                    end: {
                        line: 101,
                        column: 35
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 101,
                        column: 12
                    },
                    end: {
                        line: 101,
                        column: 16
                    }
                }, {
                    start: {
                        line: 101,
                        column: 20
                    },
                    end: {
                        line: 101,
                        column: 35
                    }
                }],
                line: 101
            },
            '10': {
                loc: {
                    start: {
                        line: 148,
                        column: 16
                    },
                    end: {
                        line: 155,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 148,
                        column: 16
                    },
                    end: {
                        line: 155,
                        column: 17
                    }
                }, {
                    start: {
                        line: 148,
                        column: 16
                    },
                    end: {
                        line: 155,
                        column: 17
                    }
                }],
                line: 148
            },
            '11': {
                loc: {
                    start: {
                        line: 149,
                        column: 20
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 149,
                        column: 20
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                }, {
                    start: {
                        line: 149,
                        column: 20
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                }],
                line: 149
            },
            '12': {
                loc: {
                    start: {
                        line: 152,
                        column: 25
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 152,
                        column: 25
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                }, {
                    start: {
                        line: 152,
                        column: 25
                    },
                    end: {
                        line: 154,
                        column: 21
                    }
                }],
                line: 152
            },
            '13': {
                loc: {
                    start: {
                        line: 152,
                        column: 29
                    },
                    end: {
                        line: 152,
                        column: 69
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 152,
                        column: 29
                    },
                    end: {
                        line: 152,
                        column: 44
                    }
                }, {
                    start: {
                        line: 152,
                        column: 48
                    },
                    end: {
                        line: 152,
                        column: 69
                    }
                }],
                line: 152
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0,
            '75': 0,
            '76': 0,
            '77': 0,
            '78': 0,
            '79': 0,
            '80': 0,
            '81': 0,
            '82': 0,
            '83': 0,
            '84': 0,
            '85': 0,
            '86': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0],
            '11': [0, 0],
            '12': [0, 0],
            '13': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectDetailsController = function () {
    ProjectDetailsController.$inject = ["UsersTable", "ProjectReportsTable", "NewProjectReportModalService", "StoriesTable", "$rootScope", "$filter", "$window"];
    function ProjectDetailsController(UsersTable, ProjectReportsTable, NewProjectReportModalService, StoriesTable, $rootScope, $filter, $window) {
        _classCallCheck(this, ProjectDetailsController);

        cov_22wcmjkpzy.f[0]++;
        cov_22wcmjkpzy.s[0]++;

        this.users = UsersTable.$all;
        cov_22wcmjkpzy.s[1]++;
        this.newTaskUser = $rootScope.me.id;
        cov_22wcmjkpzy.s[2]++;
        this.$filter = $filter;
        cov_22wcmjkpzy.s[3]++;
        this.$window = $window;
        cov_22wcmjkpzy.s[4]++;
        this.currentNav = "tasks";
        cov_22wcmjkpzy.s[5]++;
        this.currentProposal = null;
        cov_22wcmjkpzy.s[6]++;
        this.proposal = null;
        cov_22wcmjkpzy.s[7]++;
        this.roles = [];
        cov_22wcmjkpzy.s[8]++;
        this.deliveries = [];
        cov_22wcmjkpzy.s[9]++;
        this.ProjectReportsTable = ProjectReportsTable;
        cov_22wcmjkpzy.s[10]++;
        this.StoriesTable = StoriesTable;
        cov_22wcmjkpzy.s[11]++;
        this.NewProjectReportModalService = NewProjectReportModalService;
    }

    _createClass(ProjectDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_22wcmjkpzy.f[1]++;
            cov_22wcmjkpzy.s[12]++;

            this.project.$load('tasks').$load('stories').$load('proposals').$load('reports');
            cov_22wcmjkpzy.s[13]++;
            this.project.$tasks.$limit = 25;
            cov_22wcmjkpzy.s[14]++;
            this.project.$tasks.$refresh();
            cov_22wcmjkpzy.s[15]++;
            this.project.$tasks.$then(function (tasks) {
                cov_22wcmjkpzy.f[2]++;
                cov_22wcmjkpzy.s[16]++;
                return tasks.$load('user');
            });
            cov_22wcmjkpzy.s[17]++;
            this.project.$proposals.$then(function () {
                cov_22wcmjkpzy.f[3]++;
                cov_22wcmjkpzy.s[18]++;

                _this.project.$proposals.$load('stories');
            });
        }
    }, {
        key: 'selectProposal',
        value: function selectProposal(proposal) {
            cov_22wcmjkpzy.f[4]++;
            cov_22wcmjkpzy.s[19]++;

            if (proposal !== null) {
                cov_22wcmjkpzy.b[0][0]++;
                cov_22wcmjkpzy.s[20]++;

                this.currentProposal = String(proposal.id);
                cov_22wcmjkpzy.s[21]++;
                this.proposal = proposal;
                cov_22wcmjkpzy.s[22]++;
                this.getProposalRoles();
                cov_22wcmjkpzy.s[23]++;
                this.getProposalDeliveries();
                cov_22wcmjkpzy.s[24]++;
                this.proposal.$load('stories');
            } else {
                cov_22wcmjkpzy.b[0][1]++;
            }
        }
    }, {
        key: 'filterTasks',
        value: function filterTasks(filter) {
            cov_22wcmjkpzy.f[5]++;
            cov_22wcmjkpzy.s[25]++;

            this.project.$tasks.$params.name__icontains = filter;
            cov_22wcmjkpzy.s[26]++;
            this.project.$tasks.$refresh();
            cov_22wcmjkpzy.s[27]++;
            this.project.$tasks.$then(function (tasks) {
                cov_22wcmjkpzy.f[6]++;
                cov_22wcmjkpzy.s[28]++;
                return tasks.$load('user');
            });
        }
    }, {
        key: 'getProposalRoles',
        value: function getProposalRoles() {
            var _this2 = this;

            cov_22wcmjkpzy.f[7]++;
            cov_22wcmjkpzy.s[29]++;

            this.roles = [];
            var stories = (cov_22wcmjkpzy.s[30]++, this.StoriesTable.$search({ proposal: this.proposal.id, ordering: 'role' }));
            cov_22wcmjkpzy.s[31]++;
            stories.$then(function (filtered_stories) {
                cov_22wcmjkpzy.f[8]++;

                var actual_stories = (cov_22wcmjkpzy.s[32]++, _this2.$filter('actualVersion')(filtered_stories, _this2.proposal.version));
                var filtered = (cov_22wcmjkpzy.s[33]++, _this2.$filter('groupBy')(actual_stories, 'role'));
                cov_22wcmjkpzy.s[34]++;
                if ((cov_22wcmjkpzy.b[2][0]++, filtered !== undefined) && (cov_22wcmjkpzy.b[2][1]++, Object.keys(filtered).length > 0)) {
                    cov_22wcmjkpzy.b[1][0]++;
                    cov_22wcmjkpzy.s[35]++;

                    _this2.roles = Object.keys(filtered);
                } else {
                    cov_22wcmjkpzy.b[1][1]++;
                }
            });
        }
    }, {
        key: 'getProposalDeliveries',
        value: function getProposalDeliveries() {
            var _this3 = this;

            cov_22wcmjkpzy.f[9]++;
            cov_22wcmjkpzy.s[36]++;

            this.deliveries = [];
            var stories = (cov_22wcmjkpzy.s[37]++, this.StoriesTable.$search({ proposal: this.proposal.id, ordering: 'delivery' }));
            cov_22wcmjkpzy.s[38]++;
            stories.$then(function (filtered_stories) {
                cov_22wcmjkpzy.f[10]++;

                var actual_stories = (cov_22wcmjkpzy.s[39]++, _this3.$filter('actualVersion')(filtered_stories, _this3.proposal.version));
                var filtered = (cov_22wcmjkpzy.s[40]++, _this3.$filter('groupBy')(actual_stories, 'delivery'));
                cov_22wcmjkpzy.s[41]++;
                if ((cov_22wcmjkpzy.b[4][0]++, filtered !== undefined) && (cov_22wcmjkpzy.b[4][1]++, Object.keys(filtered).length > 0)) {
                    cov_22wcmjkpzy.b[3][0]++;
                    cov_22wcmjkpzy.s[42]++;

                    _this3.deliveries = Object.keys(filtered);
                } else {
                    cov_22wcmjkpzy.b[3][1]++;
                }
            });
        }
    }, {
        key: 'updateProposalVersion',
        value: function updateProposalVersion() {
            var _this4 = this;

            cov_22wcmjkpzy.f[11]++;
            cov_22wcmjkpzy.s[43]++;

            this.proposal.version += 1;
            cov_22wcmjkpzy.s[44]++;
            this.proposal.$save(['version']).$then(function () {
                cov_22wcmjkpzy.f[12]++;
                cov_22wcmjkpzy.s[45]++;

                _this4.proposal.$refresh();
                cov_22wcmjkpzy.s[46]++;
                _this4.getProposalRoles();
                cov_22wcmjkpzy.s[47]++;
                _this4.getProposalDeliveries();
                cov_22wcmjkpzy.s[48]++;
                _this4.proposal.$load('stories');
            });
        }
    }, {
        key: 'notUpdated',
        value: function notUpdated() {
            cov_22wcmjkpzy.f[13]++;

            var filtered = (cov_22wcmjkpzy.s[49]++, this.$filter('actualVersion')(this.proposal.$stories, this.proposal.version));
            cov_22wcmjkpzy.s[50]++;
            if (filtered.length > 0) {
                    cov_22wcmjkpzy.b[5][0]++;
                    cov_22wcmjkpzy.s[51]++;
                    return true;
                } else {
                    cov_22wcmjkpzy.b[5][1]++;
                    cov_22wcmjkpzy.s[52]++;
                    return false;
                }
        }
    }, {
        key: 'questions',
        value: function questions() {
            cov_22wcmjkpzy.f[14]++;

            var filtered = (cov_22wcmjkpzy.s[53]++, this.$filter('actualVersion')(this.proposal.$stories, this.proposal.version));
            var counter = (cov_22wcmjkpzy.s[54]++, 0);
            var result = (cov_22wcmjkpzy.s[55]++, false);
            cov_22wcmjkpzy.s[56]++;
            angular.forEach(filtered, function (story) {
                cov_22wcmjkpzy.f[15]++;
                cov_22wcmjkpzy.s[57]++;

                if ((cov_22wcmjkpzy.b[7][0]++, story.description !== null) && (cov_22wcmjkpzy.b[7][1]++, story.description.length > 0)) {
                    cov_22wcmjkpzy.b[6][0]++;
                    cov_22wcmjkpzy.s[58]++;

                    result = true;
                } else {
                    cov_22wcmjkpzy.b[6][1]++;
                }
                cov_22wcmjkpzy.s[59]++;
                counter += 1;
            });
            cov_22wcmjkpzy.s[60]++;
            return result;
        }
    }, {
        key: 'createTask',
        value: function createTask(name, user) {
            cov_22wcmjkpzy.f[16]++;

            var obj = (cov_22wcmjkpzy.s[61]++, {
                name: name,
                project: this.project.id
            });
            cov_22wcmjkpzy.s[62]++;
            if ((cov_22wcmjkpzy.b[9][0]++, user) && (cov_22wcmjkpzy.b[9][1]++, user !== 'None')) {
                cov_22wcmjkpzy.b[8][0]++;
                cov_22wcmjkpzy.s[63]++;

                obj['user'] = user;
            } else {
                cov_22wcmjkpzy.b[8][1]++;
            }

            cov_22wcmjkpzy.s[64]++;
            this.newTask = this.project.$tasks.$create(obj).$then(function (task) {
                cov_22wcmjkpzy.f[17]++;
                cov_22wcmjkpzy.s[65]++;
                return task.$load('user');
            });
            cov_22wcmjkpzy.s[66]++;
            this.newTaskName = '';
        }
    }, {
        key: 'createProposal',
        value: function createProposal(name, order) {
            cov_22wcmjkpzy.f[18]++;

            var obj = (cov_22wcmjkpzy.s[67]++, {
                project: this.project.id,
                name: name,
                order: order
            });
            cov_22wcmjkpzy.s[68]++;
            this.newProposal = this.project.$proposals.$create(obj);
            cov_22wcmjkpzy.s[69]++;
            this.newProposalName = '';
            cov_22wcmjkpzy.s[70]++;
            this.newProposalOrder = null;
        }
    }, {
        key: 'removeProposal',
        value: function removeProposal() {
            var _this5 = this;

            cov_22wcmjkpzy.f[19]++;
            cov_22wcmjkpzy.s[71]++;

            this.proposal.$destroy().$then(function () {
                cov_22wcmjkpzy.f[20]++;
                cov_22wcmjkpzy.s[72]++;

                _this5.proposal = null;
                cov_22wcmjkpzy.s[73]++;
                _this5.project.$proposals.$refresh();
            });
        }
    }, {
        key: 'displayNewProjectReportModal',
        value: function displayNewProjectReportModal() {
            var _this6 = this;

            cov_22wcmjkpzy.f[21]++;
            cov_22wcmjkpzy.s[74]++;

            this.NewProjectReportModalService.project = this.project.id;
            cov_22wcmjkpzy.s[75]++;
            this.NewProjectReportModalService.display().then(function () {
                cov_22wcmjkpzy.f[22]++;
                cov_22wcmjkpzy.s[76]++;

                _this6.project.$reports.$refresh();
            });
        }
    }]);

    return ProjectDetailsController;
}();

cov_22wcmjkpzy.s[77]++;


angular.module('app').component('projectDetails', {
    templateUrl: 'app/components/projectDetails/projectDetails.html',
    controller: ProjectDetailsController,
    bindings: {
        project: '<'
    }
}).filter('actualVersion', ["StoriesTable", function (StoriesTable) {
    cov_22wcmjkpzy.f[23]++;
    cov_22wcmjkpzy.s[78]++;

    return function (items, version) {
        cov_22wcmjkpzy.f[24]++;

        var result = (cov_22wcmjkpzy.s[79]++, []);
        cov_22wcmjkpzy.s[80]++;
        angular.forEach(items, function (item) {
            cov_22wcmjkpzy.f[25]++;
            cov_22wcmjkpzy.s[81]++;

            if (item.version !== null) {
                cov_22wcmjkpzy.b[10][0]++;
                cov_22wcmjkpzy.s[82]++;

                if (item.version === version) {
                    cov_22wcmjkpzy.b[11][0]++;
                    cov_22wcmjkpzy.s[83]++;

                    result.push(item);
                } else {
                        cov_22wcmjkpzy.b[11][1]++;
                        cov_22wcmjkpzy.s[84]++;
                        if ((cov_22wcmjkpzy.b[13][0]++, !item.isDeleted) && (cov_22wcmjkpzy.b[13][1]++, item.duplicates === 0)) {
                            cov_22wcmjkpzy.b[12][0]++;
                            cov_22wcmjkpzy.s[85]++;

                            result.push(item);
                        } else {
                            cov_22wcmjkpzy.b[12][1]++;
                        }
                    }
            } else {
                cov_22wcmjkpzy.b[10][1]++;
            }
        });
        cov_22wcmjkpzy.s[86]++;
        return result;
    };
}]);
'use strict';

var cov_1itzf79zk3 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/paginator/paginator.js',
        hash = 'de72c22662a66fb3b4fafc2d1b313a8a7494e980',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 34
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 40
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 23
                },
                end: {
                    line: 14,
                    column: 63
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 38
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 20,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 45
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 27
                }
            },
            '10': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 37
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 43
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 58
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 0
                },
                end: {
                    line: 42,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 41
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 13
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 13,
                        column: 4
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 23
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 19
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                line: 25
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 8,
                        column: 8
                    },
                    end: {
                        line: 10,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 8,
                        column: 8
                    },
                    end: {
                        line: 10,
                        column: 9
                    }
                }, {
                    start: {
                        line: 8,
                        column: 8
                    },
                    end: {
                        line: 10,
                        column: 9
                    }
                }],
                line: 8
            },
            '1': {
                loc: {
                    start: {
                        line: 8,
                        column: 11
                    },
                    end: {
                        line: 8,
                        column: 64
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 8,
                        column: 11
                    },
                    end: {
                        line: 8,
                        column: 33
                    }
                }, {
                    start: {
                        line: 8,
                        column: 37
                    },
                    end: {
                        line: 8,
                        column: 64
                    }
                }],
                line: 8
            },
            '2': {
                loc: {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 38
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 38
                    }
                }, {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 38
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    PaginatorController.$inject = ["$stateParams", "$location"];
    function PaginatorController($stateParams, $location) {
        _classCallCheck(this, PaginatorController);

        cov_1itzf79zk3.f[0]++;
        cov_1itzf79zk3.s[0]++;

        this.$location = $location;
        cov_1itzf79zk3.s[1]++;
        this.$stateParams = $stateParams;
    }

    _createClass(PaginatorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1itzf79zk3.f[1]++;
            cov_1itzf79zk3.s[2]++;

            if ((cov_1itzf79zk3.b[1][0]++, this.$stateParams.page) && (cov_1itzf79zk3.b[1][1]++, this.$stateParams.page != 1)) {
                cov_1itzf79zk3.b[0][0]++;
                cov_1itzf79zk3.s[3]++;

                this.goToPage(this.$stateParams.page);
            } else {
                cov_1itzf79zk3.b[0][1]++;
            }
        }
    }, {
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_1itzf79zk3.f[2]++;

            var previous = (cov_1itzf79zk3.s[4]++, Math.max(1, this.collection.$page - 1));
            cov_1itzf79zk3.s[5]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_1itzf79zk3.f[3]++;
            cov_1itzf79zk3.s[6]++;

            if (!this.collection.$page) {
                    cov_1itzf79zk3.b[2][0]++;
                    cov_1itzf79zk3.s[7]++;

                    this.collection.$page = 0;
                } else {
                cov_1itzf79zk3.b[2][1]++;
            }var next = (cov_1itzf79zk3.s[8]++, this.collection.$page + 1);
            cov_1itzf79zk3.s[9]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_1itzf79zk3.f[4]++;
            cov_1itzf79zk3.s[10]++;

            this.collection.$page = page;

            cov_1itzf79zk3.s[11]++;
            this.$location.search('page', page);

            cov_1itzf79zk3.s[12]++;
            this.collection.$refresh(this.collection.$params);
        }
    }]);

    return PaginatorController;
}();

cov_1itzf79zk3.s[13]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});
'use strict';

var cov_18jup3pkoh = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/newRecurrentModal/newRecurrentModal.js',
        hash = 'f21a3699ea56f29437328a444b49343b337e7fd2',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/newRecurrentModal/newRecurrentModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 61
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 50
                }
            },
            '6': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 86
                }
            },
            '10': {
                start: {
                    line: 32,
                    column: 61
                },
                end: {
                    line: 32,
                    column: 84
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RecurrentModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 47
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'RecurrentModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 89
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 29
                    },
                    end: {
                        line: 27,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 41
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 31,
                        column: 37
                    },
                    end: {
                        line: 31,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 31
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 32,
                        column: 50
                    },
                    end: {
                        line: 32,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 61
                    },
                    end: {
                        line: 32,
                        column: 84
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_18jup3pkoh.s[0]++;
(function () {
    'use strict';

    RecurrentModalService.$inject = ["$mdDialog"];
    RecurrentModalController.$inject = ["$scope", "$mdDialog", "ProjectsTable", "RecurrentTable"];
    cov_18jup3pkoh.f[0]++;
    cov_18jup3pkoh.s[1]++;
    angular.module('app').service('RecurrentModalService', RecurrentModalService);

    /* @ngInject */
    function RecurrentModalService($mdDialog) {
        cov_18jup3pkoh.f[1]++;
        cov_18jup3pkoh.s[2]++;

        this.display = function () {
            cov_18jup3pkoh.f[2]++;
            cov_18jup3pkoh.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newRecurrentModal/newRecurrentModal.html',
                controller: RecurrentModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function RecurrentModalController($scope, $mdDialog, ProjectsTable, RecurrentTable) {
        cov_18jup3pkoh.f[3]++;
        cov_18jup3pkoh.s[4]++;


        $scope.newRecurrentTask = RecurrentTable.$build();

        cov_18jup3pkoh.s[5]++;
        $scope.projects = ProjectsTable.$search();

        cov_18jup3pkoh.s[6]++;
        $scope.closeDialog = function () {
            cov_18jup3pkoh.f[4]++;
            cov_18jup3pkoh.s[7]++;

            $mdDialog.cancel();
        };

        cov_18jup3pkoh.s[8]++;
        $scope.createRecurrentTask = function () {
            cov_18jup3pkoh.f[5]++;
            cov_18jup3pkoh.s[9]++;

            $scope.newRecurrentTask.$save().$then(function (project) {
                cov_18jup3pkoh.f[6]++;
                cov_18jup3pkoh.s[10]++;
                return $mdDialog.hide(project);
            });
        };
    }
})(angular);
'use strict';

var cov_mjp86hmws = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/newProjectReportModal/newProjectReportModal.js',
        hash = '79a52e20122ebbc5fccc5287c676dd75776e5b26',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/newProjectReportModal/newProjectReportModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 79
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 73
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 108
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 47
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 45
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 15
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProjectReportModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'NewProjectReportModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 116
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 37
                    },
                    end: {
                        line: 30,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 49
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 33,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 61
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 33
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_mjp86hmws.s[0]++;
(function () {
    'use strict';

    NewProjectReportModalService.$inject = ["$mdDialog"];
    NewProjectReportModalController.$inject = ["$scope", "$mdDialog", "ProjectReportsTable", "NewProjectReportModalService"];
    cov_mjp86hmws.f[0]++;
    cov_mjp86hmws.s[1]++;
    angular.module('app').service('NewProjectReportModalService', NewProjectReportModalService);

    /* @ngInject */
    function NewProjectReportModalService($mdDialog) {
        cov_mjp86hmws.f[1]++;

        var Service = (cov_mjp86hmws.s[2]++, this);
        cov_mjp86hmws.s[3]++;
        this.display = function () {
            cov_mjp86hmws.f[2]++;
            cov_mjp86hmws.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newProjectReportModal/newProjectReportModal.html',
                controller: NewProjectReportModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function NewProjectReportModalController($scope, $mdDialog, ProjectReportsTable, NewProjectReportModalService) {
        cov_mjp86hmws.f[3]++;
        cov_mjp86hmws.s[5]++;

        this.NewProjectReportModalService = NewProjectReportModalService;
        cov_mjp86hmws.s[6]++;
        $scope.newReport = ProjectReportsTable.$build({ project: this.NewProjectReportModalService.project });

        cov_mjp86hmws.s[7]++;
        $scope.closeDialog = function () {
            cov_mjp86hmws.f[4]++;
            cov_mjp86hmws.s[8]++;

            $mdDialog.cancel();
        };

        cov_mjp86hmws.s[9]++;
        $scope.createProjectReport = function () {
            cov_mjp86hmws.f[5]++;
            cov_mjp86hmws.s[10]++;

            $scope.newReport.start.setHours(2);
            cov_mjp86hmws.s[11]++;
            $scope.newReport.end.setHours(2);
            cov_mjp86hmws.s[12]++;
            $scope.newReport.$save().$then(function (report) {
                cov_mjp86hmws.f[6]++;
                cov_mjp86hmws.s[13]++;

                $mdDialog.hide(report);
            });
        };
    }
})(angular);
'use strict';

var cov_2kwhanbluk = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/newExecutionModal/newExecutionModal.js',
        hash = 'af222270cb3fe04531a05be3227573b9438e8457',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/newExecutionModal/newExecutionModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 71
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 65
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 97
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewExecutionModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'NewExecutionModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 104
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 33
                    },
                    end: {
                        line: 30,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 31,
                        column: 46
                    },
                    end: {
                        line: 31,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 67
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 31
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2kwhanbluk.s[0]++;
(function () {
    'use strict';

    NewExecutionModalService.$inject = ["$mdDialog"];
    NewExecutionModalController.$inject = ["$scope", "$mdDialog", "ExecutionsTable", "NewExecutionModalService"];
    cov_2kwhanbluk.f[0]++;
    cov_2kwhanbluk.s[1]++;
    angular.module('app').service('NewExecutionModalService', NewExecutionModalService);

    /* @ngInject */
    function NewExecutionModalService($mdDialog) {
        cov_2kwhanbluk.f[1]++;

        var Service = (cov_2kwhanbluk.s[2]++, this);
        cov_2kwhanbluk.s[3]++;
        this.display = function () {
            cov_2kwhanbluk.f[2]++;
            cov_2kwhanbluk.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newExecutionModal/newExecutionModal.html',
                controller: NewExecutionModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function NewExecutionModalController($scope, $mdDialog, ExecutionsTable, NewExecutionModalService) {
        cov_2kwhanbluk.f[3]++;
        cov_2kwhanbluk.s[5]++;

        this.NewExecutionModalService = NewExecutionModalService;
        cov_2kwhanbluk.s[6]++;
        $scope.newExecution = ExecutionsTable.$build({ task: this.NewExecutionModalService.task });

        cov_2kwhanbluk.s[7]++;
        $scope.closeDialog = function () {
            cov_2kwhanbluk.f[4]++;
            cov_2kwhanbluk.s[8]++;

            $mdDialog.cancel();
        };

        cov_2kwhanbluk.s[9]++;
        $scope.createExecution = function () {
            cov_2kwhanbluk.f[5]++;
            cov_2kwhanbluk.s[10]++;

            $scope.newExecution.$save().$then(function (execution) {
                cov_2kwhanbluk.f[6]++;
                cov_2kwhanbluk.s[11]++;

                $mdDialog.hide(execution);
            });
        };
    }
})(angular);
"use strict";

var cov_2bbwke2xjz = function () {
    var path = "/home/lobo/repos/taskatone-app/src/app/components/inputDuration/inputDuration.js",
        hash = "ab2f491382be43ff14096600dc9ba85324c3327f",
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = "__coverage__",
        coverageData = {
        path: "/home/lobo/repos/taskatone-app/src/app/components/inputDuration/inputDuration.js",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 11
                }
            },
            "1": {
                start: {
                    line: 4,
                    column: 12
                },
                end: {
                    line: 4,
                    column: 33
                }
            },
            "2": {
                start: {
                    line: 12,
                    column: 22
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            "3": {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 46
                }
            },
            "4": {
                start: {
                    line: 14,
                    column: 22
                },
                end: {
                    line: 14,
                    column: 65
                }
            },
            "5": {
                start: {
                    line: 15,
                    column: 22
                },
                end: {
                    line: 15,
                    column: 63
                }
            },
            "6": {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 46
                }
            },
            "7": {
                start: {
                    line: 17,
                    column: 25
                },
                end: {
                    line: 17,
                    column: 45
                }
            },
            "8": {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 52
                }
            },
            "9": {
                start: {
                    line: 18,
                    column: 27
                },
                end: {
                    line: 18,
                    column: 51
                }
            },
            "10": {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 52
                }
            },
            "11": {
                start: {
                    line: 19,
                    column: 27
                },
                end: {
                    line: 19,
                    column: 51
                }
            },
            "12": {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 49
                }
            },
            "13": {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 39
                }
            },
            "14": {
                start: {
                    line: 25,
                    column: 32
                },
                end: {
                    line: 25,
                    column: 39
                }
            },
            "15": {
                start: {
                    line: 26,
                    column: 20
                },
                end: {
                    line: 26,
                    column: 48
                }
            },
            "16": {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 9
                }
            },
            "17": {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 66
                }
            },
            "18": {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 49
                }
            },
            "19": {
                start: {
                    line: 34,
                    column: 0
                },
                end: {
                    line: 43,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 25
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 2
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 3,
                        column: 39
                    },
                    end: {
                        line: 3,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 45
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                },
                line: 3
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 15
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 8
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 21
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 11
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 22
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                line: 24
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 12,
                        column: 22
                    },
                    end: {
                        line: 12,
                        column: 39
                    }
                },
                type: "binary-expr",
                locations: [{
                    start: {
                        line: 12,
                        column: 22
                    },
                    end: {
                        line: 12,
                        column: 34
                    }
                }, {
                    start: {
                        line: 12,
                        column: 38
                    },
                    end: {
                        line: 12,
                        column: 39
                    }
                }],
                line: 12
            },
            "1": {
                loc: {
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 46
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 46
                    }
                }, {
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 46
                    }
                }],
                line: 17
            },
            "2": {
                loc: {
                    start: {
                        line: 18,
                        column: 8
                    },
                    end: {
                        line: 18,
                        column: 52
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 18,
                        column: 8
                    },
                    end: {
                        line: 18,
                        column: 52
                    }
                }, {
                    start: {
                        line: 18,
                        column: 8
                    },
                    end: {
                        line: 18,
                        column: 52
                    }
                }],
                line: 18
            },
            "3": {
                loc: {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 19,
                        column: 52
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 19,
                        column: 52
                    }
                }, {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 19,
                        column: 52
                    }
                }],
                line: 19
            },
            "4": {
                loc: {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 25,
                        column: 39
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 25,
                        column: 39
                    }
                }, {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 25,
                        column: 39
                    }
                }],
                line: 25
            },
            "5": {
                loc: {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                }, {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                }],
                line: 27
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0],
            "5": [0, 0]
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InputDurationController = function () {
    InputDurationController.$inject = ["$scope"];
    function InputDurationController($scope) {
        var _this = this;

        _classCallCheck(this, InputDurationController);

        cov_2bbwke2xjz.f[0]++;
        cov_2bbwke2xjz.s[0]++;

        $scope.$watch('$ctrl.ngModel', function () {
            cov_2bbwke2xjz.f[1]++;
            cov_2bbwke2xjz.s[1]++;

            _this.parseDuration();
        });
    }

    _createClass(InputDurationController, [{
        key: "$onInit",
        value: function $onInit() {
            cov_2bbwke2xjz.f[2]++;
        }
    }, {
        key: "parseDuration",
        value: function parseDuration() {
            cov_2bbwke2xjz.f[3]++;

            var sec_num = (cov_2bbwke2xjz.s[2]++, (cov_2bbwke2xjz.b[0][0]++, this.ngModel) || (cov_2bbwke2xjz.b[0][1]++, 0)); // don't forget the second param
            var hours = (cov_2bbwke2xjz.s[3]++, Math.floor(sec_num / 3600));
            var minutes = (cov_2bbwke2xjz.s[4]++, Math.floor((sec_num - hours * 3600) / 60));
            var seconds = (cov_2bbwke2xjz.s[5]++, sec_num - hours * 3600 - minutes * 60);

            cov_2bbwke2xjz.s[6]++;
            if (hours < 10) {
                cov_2bbwke2xjz.b[1][0]++;
                cov_2bbwke2xjz.s[7]++;
                hours = "0" + hours;
            } else {
                cov_2bbwke2xjz.b[1][1]++;
            }
            cov_2bbwke2xjz.s[8]++;
            if (minutes < 10) {
                cov_2bbwke2xjz.b[2][0]++;
                cov_2bbwke2xjz.s[9]++;
                minutes = "0" + minutes;
            } else {
                cov_2bbwke2xjz.b[2][1]++;
            }
            cov_2bbwke2xjz.s[10]++;
            if (seconds < 10) {
                cov_2bbwke2xjz.b[3][0]++;
                cov_2bbwke2xjz.s[11]++;
                seconds = "0" + seconds;
            } else {
                cov_2bbwke2xjz.b[3][1]++;
            }

            cov_2bbwke2xjz.s[12]++;
            this.viewDuration = hours + ':' + minutes;
        }
    }, {
        key: "changeDuration",
        value: function changeDuration() {
            cov_2bbwke2xjz.f[4]++;
            cov_2bbwke2xjz.s[13]++;

            if (!this.viewDuration) {
                    cov_2bbwke2xjz.b[4][0]++;
                    cov_2bbwke2xjz.s[14]++;
                    return;
                } else {
                cov_2bbwke2xjz.b[4][1]++;
            }var times = (cov_2bbwke2xjz.s[15]++, this.viewDuration.split(':'));
            cov_2bbwke2xjz.s[16]++;
            if (times.length == 2) {
                cov_2bbwke2xjz.b[5][0]++;
                cov_2bbwke2xjz.s[17]++;

                this.ngModel = times[1] * 60 + times[0] * 60 * 60;
                cov_2bbwke2xjz.s[18]++;
                this.ngChange({ value: this.ngModel });
            } else {
                cov_2bbwke2xjz.b[5][1]++;
            }
        }
    }]);

    return InputDurationController;
}();

cov_2bbwke2xjz.s[19]++;


angular.module('app').component('inputDuration', {
    templateUrl: 'app/components/inputDuration/inputDuration.html',
    controller: InputDurationController,
    bindings: {
        ngModel: '=',
        ngChange: '&'
    }
});
'use strict';

var cov_wkjbkyrxw = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/executionPreview/executionPreview.js',
        hash = '7e2a60c69138d6b14e914080e30c27bb855444e5',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/executionPreview/executionPreview.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExecutionPreviewController = function ExecutionPreviewController() {
    _classCallCheck(this, ExecutionPreviewController);
};

cov_wkjbkyrxw.s[0]++;


angular.module('app').component('executionPreview', {
    templateUrl: 'app/components/executionPreview/executionPreview.html',
    controller: ExecutionPreviewController,
    bindings: {
        execution: '<'
    }
});
'use strict';

var cov_gocqxqxkf = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/dashboard/dashboard.controller.js',
        hash = '06f0a97431051254f989a26f8f24585904d3b329',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/dashboard/dashboard.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 19
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 14
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 56
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 13,
                        column: 17
                    },
                    end: {
                        line: 13,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 29
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 32
                    },
                    end: {
                        line: 14,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 48
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                },
                line: 14
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_gocqxqxkf.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state"];
    cov_gocqxqxkf.f[0]++;
    cov_gocqxqxkf.s[1]++;
    angular.module('app').controller('DashboardController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state) {
        cov_gocqxqxkf.f[1]++;

        var vm = (cov_gocqxqxkf.s[2]++, this);
        cov_gocqxqxkf.s[3]++;
        activate();

        function activate() {
            cov_gocqxqxkf.f[2]++;
            cov_gocqxqxkf.s[4]++;

            $rootScope.me.$then(function (user) {
                cov_gocqxqxkf.f[3]++;
                cov_gocqxqxkf.s[5]++;

                $state.go('userProfile', { id: user.id });
            });
        }
    }
})();
'use strict';

var cov_2ab4oeddii = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/createProjectModal/createProjectModal.js',
        hash = 'b3b2dd0118be78a3bcafff6a1bcea217a3f17d0b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/createProjectModal/createProjectModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 51
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 14
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProjectModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'CreateProjectModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 77
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 31
                    },
                    end: {
                        line: 29,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 44
                    },
                    end: {
                        line: 30,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 63
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ab4oeddii.s[0]++;
(function () {
    'use strict';

    NewProjectModalService.$inject = ["$mdDialog"];
    CreateProjectModalController.$inject = ["$scope", "$mdDialog", "ProjectsTable"];
    cov_2ab4oeddii.f[0]++;
    cov_2ab4oeddii.s[1]++;
    angular.module('app').service('NewProjectModalService', NewProjectModalService);

    /* @ngInject */
    function NewProjectModalService($mdDialog) {
        cov_2ab4oeddii.f[1]++;

        var Service = (cov_2ab4oeddii.s[2]++, this);
        cov_2ab4oeddii.s[3]++;
        this.display = function () {
            cov_2ab4oeddii.f[2]++;
            cov_2ab4oeddii.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createProjectModal/createProjectModal.html',
                controller: CreateProjectModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateProjectModalController($scope, $mdDialog, ProjectsTable) {
        cov_2ab4oeddii.f[3]++;
        cov_2ab4oeddii.s[5]++;

        $scope.newProject = ProjectsTable.$build();

        cov_2ab4oeddii.s[6]++;
        $scope.closeDialog = function () {
            cov_2ab4oeddii.f[4]++;
            cov_2ab4oeddii.s[7]++;

            $mdDialog.cancel();
        };

        cov_2ab4oeddii.s[8]++;
        $scope.createProject = function () {
            cov_2ab4oeddii.f[5]++;
            cov_2ab4oeddii.s[9]++;

            $scope.newProject.$save().$then(function (project) {
                cov_2ab4oeddii.f[6]++;
                cov_2ab4oeddii.s[10]++;

                $mdDialog.hide(project);
            });
        };
    }
})(angular);
'use strict';

var cov_239bdq0w8f = function () {
  var path = '/home/lobo/repos/taskatone-app/src/app/components/clockBar/clockBar.js',
      hash = '8daa3dbabf1f73fe46a22e34664e6f3d91f919f1',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/lobo/repos/taskatone-app/src/app/components/clockBar/clockBar.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 42
        }
      },
      '1': {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 12,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 16
          },
          end: {
            line: 4,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClockBarController = function ClockBarController() {
  _classCallCheck(this, ClockBarController);

  cov_239bdq0w8f.f[0]++;
  cov_239bdq0w8f.s[0]++;

  this.text = 'My brand new component!';
};

cov_239bdq0w8f.s[1]++;


angular.module('app').component('clockBar', {
  templateUrl: 'app/components/clockBar/clockBar.html',
  controller: ClockBarController
});
'use strict';

var cov_82d8jkcj = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.set.password.controller.js',
        hash = 'dabaec9f68a3c05db11a3a3157f7f90b79ec5208',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.set.password.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 50,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 76
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 37
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 18
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 16
                },
                end: {
                    line: 39,
                    column: 35
                }
            },
            '11': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 18
                }
            },
            '12': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 50,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthSetPasswordController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 91
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'setPassword',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 31
                    },
                    end: {
                        line: 48,
                        column: 9
                    }
                },
                line: 24
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 33,
                        column: 29
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 47
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                line: 33
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 40,
                        column: 15
                    },
                    end: {
                        line: 40,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 27
                    },
                    end: {
                        line: 47,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 35
                    }
                }, {
                    start: {
                        line: 19,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_82d8jkcj.s[0]++;
(function () {
    'use strict';

    AuthSetPasswordController.$inject = ["$state", "$http", "AppSettings", "$stateParams", "$mdToast"];
    cov_82d8jkcj.f[0]++;
    cov_82d8jkcj.s[1]++;
    angular.module('app').controller('AuthSetPasswordController', AuthSetPasswordController);

    /* @ngInject */
    function AuthSetPasswordController($state, $http, AppSettings, $stateParams, $mdToast) {
        cov_82d8jkcj.f[1]++;

        var vm = (cov_82d8jkcj.s[2]++, this);

        cov_82d8jkcj.s[3]++;
        vm.requestStatus = {};

        cov_82d8jkcj.s[4]++;
        vm.setPassword = setPassword;

        cov_82d8jkcj.s[5]++;
        activate();

        function activate() {
            cov_82d8jkcj.f[2]++;
            cov_82d8jkcj.s[6]++;

            if ((cov_82d8jkcj.b[1][0]++, !$stateParams.email) || (cov_82d8jkcj.b[1][1]++, !$stateParams.token)) {
                cov_82d8jkcj.b[0][0]++;
                cov_82d8jkcj.s[7]++;

                $state.go('login');
            } else {
                cov_82d8jkcj.b[0][1]++;
            }
        }

        function setPassword() {
            cov_82d8jkcj.f[3]++;
            cov_82d8jkcj.s[8]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/set_password/',
                data: {
                    email: $stateParams.email,
                    token: $stateParams.token,
                    password: vm.password
                }
            }).then(function successCallback() {
                cov_82d8jkcj.f[4]++;
                cov_82d8jkcj.s[9]++;

                $mdToast.show($mdToast.simple().textContent('Your password has been changed!').hideDelay(3000));
                cov_82d8jkcj.s[10]++;
                $state.go('login');
            }, function () {
                cov_82d8jkcj.f[5]++;
                cov_82d8jkcj.s[11]++;

                $mdToast.show($mdToast.simple().textContent('An error has ocurred!').hideDelay(3000));
                cov_82d8jkcj.s[12]++;
                $state.go('projectsList');
            });
        }
    }
})();
'use strict';

var cov_10s8ru6nqy = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.service.js',
        hash = '028ca33e7f0f680a04112b5bac728f0765753f9c',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 26
                },
                end: {
                    line: 10,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 31
                },
                end: {
                    line: 12,
                    column: 78
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 62
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 29
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 32
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 24,
                    column: 16
                },
                end: {
                    line: 24,
                    column: 62
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 10
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 53
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 37
                }
            },
            '16': {
                start: {
                    line: 34,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 42
                }
            },
            '17': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 44,
                    column: 10
                }
            },
            '18': {
                start: {
                    line: 38,
                    column: 32
                },
                end: {
                    line: 38,
                    column: 46
                }
            },
            '19': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 15
                }
            },
            '20': {
                start: {
                    line: 40,
                    column: 16
                },
                end: {
                    line: 40,
                    column: 38
                }
            },
            '21': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 41,
                    column: 40
                }
            },
            '22': {
                start: {
                    line: 43,
                    column: 12
                },
                end: {
                    line: 43,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 46,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 45,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 21
                    },
                    end: {
                        line: 11,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 48
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 30
                    },
                    end: {
                        line: 13,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 15,
                        column: 15
                    },
                    end: {
                        line: 15,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 32
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                line: 15
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 29
                    },
                    end: {
                        line: 22,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 22
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 23,
                        column: 55
                    },
                    end: {
                        line: 23,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 67
                    },
                    end: {
                        line: 25,
                        column: 13
                    }
                },
                line: 23
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 40
                    },
                    end: {
                        line: 28,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 52
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 29,
                        column: 57
                    },
                    end: {
                        line: 29,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 69
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 29
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 37,
                        column: 22
                    },
                    end: {
                        line: 37,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 34
                    },
                    end: {
                        line: 44,
                        column: 9
                    }
                },
                line: 37
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 39,
                        column: 31
                    },
                    end: {
                        line: 39,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 43
                    },
                    end: {
                        line: 42,
                        column: 13
                    }
                },
                line: 39
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_10s8ru6nqy.s[0]++;
(function () {
    'use strict';

    service.$inject = ["$auth", "$rootScope", "$state", "UsersTable"];
    cov_10s8ru6nqy.f[0]++;
    cov_10s8ru6nqy.s[1]++;
    angular.module('app').service('AuthService', service);

    /* @ngInject */
    function service($auth, $rootScope, $state, UsersTable) {
        cov_10s8ru6nqy.f[1]++;

        var AuthService = (cov_10s8ru6nqy.s[2]++, this);
        cov_10s8ru6nqy.s[3]++;
        this.login = function (email, password) {
            cov_10s8ru6nqy.f[2]++;

            var loginPromise = (cov_10s8ru6nqy.s[4]++, $auth.login({ email: email, password: password }));
            cov_10s8ru6nqy.s[5]++;
            loginPromise.then(function () {
                cov_10s8ru6nqy.f[3]++;
                cov_10s8ru6nqy.s[6]++;

                return AuthService.refreshAuthenticatedInfo();
            }, function (error) {
                cov_10s8ru6nqy.f[4]++;
                cov_10s8ru6nqy.s[7]++;

                return error;
            });

            cov_10s8ru6nqy.s[8]++;
            return loginPromise;
        };

        cov_10s8ru6nqy.s[9]++;
        this.loginFacebook = function () {
            cov_10s8ru6nqy.f[5]++;
            cov_10s8ru6nqy.s[10]++;

            return $auth.authenticate('facebook').then(function () {
                cov_10s8ru6nqy.f[6]++;
                cov_10s8ru6nqy.s[11]++;

                return AuthService.refreshAuthenticatedInfo();
            });
        };

        cov_10s8ru6nqy.s[12]++;
        this.refreshAuthenticatedInfo = function () {
            cov_10s8ru6nqy.f[7]++;
            cov_10s8ru6nqy.s[13]++;

            $rootScope.me = UsersTable.$find('me').$then(function () {
                cov_10s8ru6nqy.f[8]++;
                cov_10s8ru6nqy.s[14]++;

                $rootScope.me.$pk = $rootScope.me.id;
                cov_10s8ru6nqy.s[15]++;
                return $rootScope.me;
            });

            cov_10s8ru6nqy.s[16]++;
            return $rootScope.me.$promise;
        };

        cov_10s8ru6nqy.s[17]++;
        this.logout = function () {
            cov_10s8ru6nqy.f[9]++;

            var logoutPromise = (cov_10s8ru6nqy.s[18]++, $auth.logout());
            cov_10s8ru6nqy.s[19]++;
            logoutPromise.then(function () {
                cov_10s8ru6nqy.f[10]++;
                cov_10s8ru6nqy.s[20]++;

                $rootScope.me = false;
                cov_10s8ru6nqy.s[21]++;
                $rootScope.cart = false;
            });
            cov_10s8ru6nqy.s[22]++;
            return logoutPromise;
        };
    }
})();
'use strict';

var cov_28ot2wo4ax = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.run.js',
        hash = '64a38c3b59085e0dcbf2cd4629219a294be08ece',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 15
                },
                end: {
                    line: 13,
                    column: 34
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 38
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 76
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 33
                    },
                    end: {
                        line: 11,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 56
                    },
                    end: {
                        line: 20,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 68
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 15
                    },
                    end: {
                        line: 21,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 27
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 201
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 30
                    }
                }, {
                    start: {
                        line: 12,
                        column: 35
                    },
                    end: {
                        line: 12,
                        column: 62
                    }
                }, {
                    start: {
                        line: 12,
                        column: 66
                    },
                    end: {
                        line: 12,
                        column: 94
                    }
                }, {
                    start: {
                        line: 12,
                        column: 98
                    },
                    end: {
                        line: 12,
                        column: 132
                    }
                }, {
                    start: {
                        line: 12,
                        column: 136
                    },
                    end: {
                        line: 12,
                        column: 166
                    }
                }, {
                    start: {
                        line: 12,
                        column: 170
                    },
                    end: {
                        line: 12,
                        column: 200
                    }
                }],
                line: 12
            },
            '2': {
                loc: {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                }, {
                    start: {
                        line: 19,
                        column: 8
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0, 0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_28ot2wo4ax.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "$state", "$auth", "AuthService", "$transitions"];
    cov_28ot2wo4ax.f[0]++;
    cov_28ot2wo4ax.s[1]++;
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, AuthService, $transitions) {
        cov_28ot2wo4ax.f[1]++;
        cov_28ot2wo4ax.s[2]++;


        $transitions.onStart({}, function (trans) {
            cov_28ot2wo4ax.f[2]++;
            cov_28ot2wo4ax.s[3]++;

            if ((cov_28ot2wo4ax.b[1][0]++, !$rootScope.me) && (cov_28ot2wo4ax.b[1][1]++, trans.to().name !== 'login') && (cov_28ot2wo4ax.b[1][2]++, trans.to().name !== 'forgot') && (cov_28ot2wo4ax.b[1][3]++, trans.to().name !== 'set_password') && (cov_28ot2wo4ax.b[1][4]++, trans.to().name !== 'register') && (cov_28ot2wo4ax.b[1][5]++, trans.to().name !== 'activate')) {
                cov_28ot2wo4ax.b[0][0]++;
                cov_28ot2wo4ax.s[4]++;

                $state.go("login");
            } else {
                cov_28ot2wo4ax.b[0][1]++;
            }

            cov_28ot2wo4ax.s[5]++;
            $rootScope.closeSidebar();
        });

        cov_28ot2wo4ax.s[6]++;
        if ($auth.isAuthenticated()) {
            cov_28ot2wo4ax.b[2][0]++;
            cov_28ot2wo4ax.s[7]++;

            AuthService.refreshAuthenticatedInfo().then(function () {
                cov_28ot2wo4ax.f[3]++;
            }, function () {
                cov_28ot2wo4ax.f[4]++;
                cov_28ot2wo4ax.s[8]++;

                AuthService.logout().then($state.go('login'));
            });
        } else {
            cov_28ot2wo4ax.b[2][1]++;
        }
    }
})();
'use strict';

var cov_ee1cybymz = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.register.controller.js',
        hash = '1887b6ccd61b08e2d2bd5fc9b432b03e9b23539f',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.register.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 51,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 32
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 26
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 27
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 39
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 100
                }
            },
            '13': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 42,
                    column: 33
                }
            },
            '15': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 98
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 16
                },
                end: {
                    line: 44,
                    column: 32
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 99
                }
            },
            '18': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 51,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthRegisterController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 78
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 22,
                        column: 17
                    },
                    end: {
                        line: 22,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 28
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                line: 22
            },
            '3': {
                name: 'register',
                decl: {
                    start: {
                        line: 26,
                        column: 17
                    },
                    end: {
                        line: 26,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 28
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 26
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 34
                    },
                    end: {
                        line: 27,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 13
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 15
                    },
                    end: {
                        line: 29,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 27
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            },
            '6': {
                name: 'resend',
                decl: {
                    start: {
                        line: 34,
                        column: 17
                    },
                    end: {
                        line: 34,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 26
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 34
            },
            '7': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 41,
                        column: 29
                    },
                    end: {
                        line: 41,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 55
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                line: 41
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 45,
                        column: 15
                    },
                    end: {
                        line: 45,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 35
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                },
                line: 45
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_ee1cybymz.s[0]++;
(function () {
    'use strict';

    AuthRegisterController.$inject = ["UsersTable", "$mdToast", "$http", "AppSettings"];
    cov_ee1cybymz.f[0]++;
    cov_ee1cybymz.s[1]++;
    angular.module('app').controller('AuthRegisterController', AuthRegisterController);

    /* @ngInject */
    function AuthRegisterController(UsersTable, $mdToast, $http, AppSettings) {
        cov_ee1cybymz.f[1]++;

        var vm = (cov_ee1cybymz.s[2]++, this);

        cov_ee1cybymz.s[3]++;
        vm.registering = true;
        cov_ee1cybymz.s[4]++;
        vm.user = UsersTable.$build();
        cov_ee1cybymz.s[5]++;
        vm.resendStatus = false;
        cov_ee1cybymz.s[6]++;
        vm.resent = false;

        cov_ee1cybymz.s[7]++;
        vm.register = register;
        cov_ee1cybymz.s[8]++;
        vm.resend = resend;

        cov_ee1cybymz.s[9]++;
        activate();

        function activate() {
            cov_ee1cybymz.f[2]++;
        }

        function register() {
            cov_ee1cybymz.f[3]++;
            cov_ee1cybymz.s[10]++;

            vm.user.$save().$then(function () {
                cov_ee1cybymz.f[4]++;
                cov_ee1cybymz.s[11]++;

                vm.registering = false;
            }, function () {
                cov_ee1cybymz.f[5]++;
                cov_ee1cybymz.s[12]++;

                $mdToast.show($mdToast.simple().textContent('Please fill in all required fields!'));
            });
        }

        function resend() {
            cov_ee1cybymz.f[6]++;
            cov_ee1cybymz.s[13]++;

            vm.resendStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/resend_verification_email/',
                data: {
                    email: vm.user.email
                }
            }).then(function successCallback(response) {
                cov_ee1cybymz.f[7]++;
                cov_ee1cybymz.s[14]++;

                vm.resent = true;
                cov_ee1cybymz.s[15]++;
                $mdToast.show($mdToast.simple().textContent('We sent an email to your account!'));
                cov_ee1cybymz.s[16]++;
                return response;
            }, function (response) {
                cov_ee1cybymz.f[8]++;
                cov_ee1cybymz.s[17]++;

                $mdToast.show($mdToast.simple().textContent(response.data['non_field_errors'][0]));
                cov_ee1cybymz.s[18]++;
                return response;
            });
        }
    }
})();
'use strict';

var cov_10gfz5tafb = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.logout.controller.js',
        hash = 'a0630258531810cecbb9e1edfc46aafea7a615cd',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.logout.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 28
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 16,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 28
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 16
            },
            '3': {
                name: 'logout',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 38
                    },
                    end: {
                        line: 21,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 49
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_10gfz5tafb.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state", "AuthService"];
    cov_10gfz5tafb.f[0]++;
    cov_10gfz5tafb.s[1]++;
    angular.module('app').controller('AuthLogoutController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state, AuthService) {
        cov_10gfz5tafb.f[1]++;

        var vm = (cov_10gfz5tafb.s[2]++, this);
        cov_10gfz5tafb.s[3]++;
        vm.title = 'Logout';
        cov_10gfz5tafb.s[4]++;
        vm.logout = logout;

        cov_10gfz5tafb.s[5]++;
        activate();

        function activate() {
            cov_10gfz5tafb.f[2]++;
            cov_10gfz5tafb.s[6]++;

            vm.logout();
        }

        function logout() {
            cov_10gfz5tafb.f[3]++;
            cov_10gfz5tafb.s[7]++;

            AuthService.logout().then(function () {
                cov_10gfz5tafb.f[4]++;
                cov_10gfz5tafb.s[8]++;

                $rootScope.profileMenuPageActive = false;
                cov_10gfz5tafb.s[9]++;
                $state.go('login');
            });
        }
    }
})();
'use strict';

var cov_gdzdldjls = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.login.controller.js',
        hash = 'd1c7389b4d562a1475d881ab2bd63114b11ebf36',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.login.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 49,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 25
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 30
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 29
                }
            },
            '9': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 34
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 29
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 34
                }
            },
            '13': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 33
                }
            },
            '14': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 40
                }
            },
            '15': {
                start: {
                    line: 43,
                    column: 12
                },
                end: {
                    line: 45,
                    column: 15
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 16
                },
                end: {
                    line: 44,
                    column: 65
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 49,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 72
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 29
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'login',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 26
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 58
                    },
                    end: {
                        line: 22,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 76
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 24,
                        column: 15
                    },
                    end: {
                        line: 24,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 32
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                line: 24
            },
            '6': {
                name: 'loginFacebook',
                decl: {
                    start: {
                        line: 29,
                        column: 17
                    },
                    end: {
                        line: 29,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 34
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 29
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 30,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 57
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 32,
                        column: 15
                    },
                    end: {
                        line: 32,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 32
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                },
                line: 32
            },
            '9': {
                name: 'logout',
                decl: {
                    start: {
                        line: 37,
                        column: 17
                    },
                    end: {
                        line: 37,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 27
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                line: 37
            },
            '10': {
                name: 'afterLogin',
                decl: {
                    start: {
                        line: 41,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 31
                    },
                    end: {
                        line: 46,
                        column: 9
                    }
                },
                line: 41
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 43,
                        column: 32
                    },
                    end: {
                        line: 43,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 44
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                line: 43
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_gdzdldjls.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$state", "AuthService", "$rootScope", "$stateParams"];
    cov_gdzdldjls.f[0]++;
    cov_gdzdldjls.s[1]++;
    angular.module('app').controller('AuthLoginController', Controller);

    /* @ngInject */
    function Controller($state, AuthService, $rootScope, $stateParams) {
        cov_gdzdldjls.f[1]++;

        var vm = (cov_gdzdldjls.s[2]++, this);
        cov_gdzdldjls.s[3]++;
        vm.login = login;
        cov_gdzdldjls.s[4]++;
        vm.loginFacebook = loginFacebook;

        cov_gdzdldjls.s[5]++;
        vm.authenticated = {};

        cov_gdzdldjls.s[6]++;
        activate();

        function activate() {
            cov_gdzdldjls.f[2]++;
        }

        function login() {
            cov_gdzdldjls.f[3]++;
            cov_gdzdldjls.s[7]++;

            AuthService.login(vm.email, vm.password).then(function (result) {
                cov_gdzdldjls.f[4]++;
                cov_gdzdldjls.s[8]++;

                afterLogin();
            }, function (error) {
                cov_gdzdldjls.f[5]++;
                cov_gdzdldjls.s[9]++;

                vm.member = error;
            });
        }

        function loginFacebook() {
            cov_gdzdldjls.f[6]++;
            cov_gdzdldjls.s[10]++;

            AuthService.loginFacebook().then(function () {
                cov_gdzdldjls.f[7]++;
                cov_gdzdldjls.s[11]++;

                afterLogin();
            }, function (error) {
                cov_gdzdldjls.f[8]++;
                cov_gdzdldjls.s[12]++;

                vm.member = error;
            });
        }

        function logout() {
            cov_gdzdldjls.f[9]++;
            cov_gdzdldjls.s[13]++;

            AuthService.logout();
        }

        function afterLogin() {
            cov_gdzdldjls.f[10]++;
            cov_gdzdldjls.s[14]++;

            $rootScope.loadStaticData();
            cov_gdzdldjls.s[15]++;
            $rootScope.me.$then(function () {
                cov_gdzdldjls.f[11]++;
                cov_gdzdldjls.s[16]++;

                $state.go('userProfile', { id: $rootScope.me.id });
            });
        }
    }
})();
'use strict';

var cov_1pvcnyb8l4 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.forgot.controller.js',
        hash = '9e70eb0de144a936c1e586b8e6edc4b28ac99cf6',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.forgot.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 32
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthForgotController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'requestChange',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 33
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 28,
                        column: 29
                    },
                    end: {
                        line: 28,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 55
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 35
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1pvcnyb8l4.s[0]++;
(function () {
    'use strict';

    AuthForgotController.$inject = ["$http", "AppSettings"];
    cov_1pvcnyb8l4.f[0]++;
    cov_1pvcnyb8l4.s[1]++;
    angular.module('app').controller('AuthForgotController', AuthForgotController);

    /* @ngInject */
    function AuthForgotController($http, AppSettings) {
        cov_1pvcnyb8l4.f[1]++;

        var vm = (cov_1pvcnyb8l4.s[2]++, this);

        cov_1pvcnyb8l4.s[3]++;
        vm.requestStatus = {};

        cov_1pvcnyb8l4.s[4]++;
        vm.requestChange = requestChange;

        cov_1pvcnyb8l4.s[5]++;
        activate();

        function activate() {
            cov_1pvcnyb8l4.f[2]++;
        }

        function requestChange() {
            cov_1pvcnyb8l4.f[3]++;
            cov_1pvcnyb8l4.s[6]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/reset_password/',
                data: {
                    email: vm.email
                }
            }).then(function successCallback(response) {
                cov_1pvcnyb8l4.f[4]++;
                cov_1pvcnyb8l4.s[7]++;

                return response;
            }, function (response) {
                cov_1pvcnyb8l4.f[5]++;
                cov_1pvcnyb8l4.s[8]++;

                return response;
            });
        }
    }
})();
'use strict';

var cov_29i11hr360 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.config.js',
        hash = '3a06680be19535868b50394eecb73a1b80253561',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 52
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_29i11hr360.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["$authProvider", "AppSettings"];
    cov_29i11hr360.f[0]++;
    cov_29i11hr360.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config($authProvider, AppSettings) {
        cov_29i11hr360.f[1]++;
        cov_29i11hr360.s[2]++;

        $authProvider.baseUrl = AppSettings.apiUrl;

        cov_29i11hr360.s[3]++;
        $authProvider.loginUrl = '/api-token-auth/';

        cov_29i11hr360.s[4]++;
        $authProvider.facebook({
            clientId: AppSettings.facebookAppId,
            url: '/auth/facebook/'
        });
    }
})();
'use strict';

var cov_1hl36c8351 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.activate.controller.js',
        hash = 'dce5bbc931fbb801be650fd49799f35785938511',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/auth/auth.activate.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 40,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 19
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 18
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 65
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 18
                }
            },
            '11': {
                start: {
                    line: 36,
                    column: 16
                },
                end: {
                    line: 36,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 40,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthActivateController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 100
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 14,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 28
                    },
                    end: {
                        line: 38,
                        column: 9
                    }
                },
                line: 14
            },
            '3': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 21,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 47
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 47
                    },
                    end: {
                        line: 27,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 59
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 27
                    },
                    end: {
                        line: 37,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1hl36c8351.s[0]++;
(function () {
    'use strict';

    AuthActivateController.$inject = ["$http", "$state", "$stateParams", "AppSettings", "$mdToast", "$rootScope"];
    cov_1hl36c8351.f[0]++;
    cov_1hl36c8351.s[1]++;
    angular.module('app').controller('AuthActivateController', AuthActivateController);

    /* @ngInject */
    function AuthActivateController($http, $state, $stateParams, AppSettings, $mdToast, $rootScope) {
        cov_1hl36c8351.f[1]++;

        var vm = (cov_1hl36c8351.s[2]++, this);

        cov_1hl36c8351.s[3]++;
        activate();

        function activate() {
            cov_1hl36c8351.f[2]++;
            cov_1hl36c8351.s[4]++;

            if (!$stateParams.token) {
                cov_1hl36c8351.b[0][0]++;
                cov_1hl36c8351.s[5]++;

                $state.go('/');
            } else {
                cov_1hl36c8351.b[0][1]++;
            }
            cov_1hl36c8351.s[6]++;
            vm.requestStatus = $http({
                method: 'GET',
                url: AppSettings.apiUrl + '/users/activate/?token=' + $stateParams.token
            }).then(function successCallback() {
                cov_1hl36c8351.f[3]++;
                cov_1hl36c8351.s[7]++;

                $mdToast.show($mdToast.simple().textContent('Your account has been activated!').hideDelay(3000));
                cov_1hl36c8351.s[8]++;
                $state.go('projectsList').then(function () {
                    cov_1hl36c8351.f[4]++;
                    cov_1hl36c8351.s[9]++;

                    $rootScope.openHeaderPage('loginPageActive');
                });
            }, function () {
                cov_1hl36c8351.f[5]++;
                cov_1hl36c8351.s[10]++;

                $mdToast.show($mdToast.simple().textContent('Activation error!').hideDelay(3000));
                cov_1hl36c8351.s[11]++;
                $state.go('login');
            });
        }
    }
})();
'use strict';

var cov_ipyzih9ki = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/strings.js',
        hash = '491ddaeca2a6bb50fcc62cf72025a47f15b68f66',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/strings.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 2
                }
            },
            '1': {
                start: {
                    line: 2,
                    column: 4
                },
                end: {
                    line: 2,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 2
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 9,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 2
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 4
                },
                end: {
                    line: 16,
                    column: 7
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 2
                }
            },
            '9': {
                start: {
                    line: 21,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 2
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 18
                },
                end: {
                    line: 27,
                    column: 36
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 42
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 18
                },
                end: {
                    line: 29,
                    column: 61
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 4
                },
                end: {
                    line: 31,
                    column: 42
                }
            },
            '16': {
                start: {
                    line: 31,
                    column: 21
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '17': {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 32,
                    column: 48
                }
            },
            '18': {
                start: {
                    line: 32,
                    column: 23
                },
                end: {
                    line: 32,
                    column: 47
                }
            },
            '19': {
                start: {
                    line: 33,
                    column: 4
                },
                end: {
                    line: 33,
                    column: 33
                }
            },
            '20': {
                start: {
                    line: 36,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 2
                }
            },
            '21': {
                start: {
                    line: 37,
                    column: 18
                },
                end: {
                    line: 37,
                    column: 36
                }
            },
            '22': {
                start: {
                    line: 38,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 42
                }
            },
            '23': {
                start: {
                    line: 39,
                    column: 18
                },
                end: {
                    line: 39,
                    column: 61
                }
            },
            '24': {
                start: {
                    line: 40,
                    column: 18
                },
                end: {
                    line: 40,
                    column: 59
                }
            },
            '25': {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 42
                }
            },
            '26': {
                start: {
                    line: 42,
                    column: 21
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '27': {
                start: {
                    line: 43,
                    column: 4
                },
                end: {
                    line: 43,
                    column: 48
                }
            },
            '28': {
                start: {
                    line: 43,
                    column: 23
                },
                end: {
                    line: 43,
                    column: 47
                }
            },
            '29': {
                start: {
                    line: 44,
                    column: 4
                },
                end: {
                    line: 44,
                    column: 48
                }
            },
            '30': {
                start: {
                    line: 44,
                    column: 23
                },
                end: {
                    line: 44,
                    column: 47
                }
            },
            '31': {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 45,
                    column: 49
                }
            },
            '32': {
                start: {
                    line: 48,
                    column: 0
                },
                end: {
                    line: 55,
                    column: 2
                }
            },
            '33': {
                start: {
                    line: 49,
                    column: 18
                },
                end: {
                    line: 49,
                    column: 36
                }
            },
            '34': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 42
                }
            },
            '35': {
                start: {
                    line: 51,
                    column: 18
                },
                end: {
                    line: 51,
                    column: 61
                }
            },
            '36': {
                start: {
                    line: 52,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 59
                }
            },
            '37': {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 99
                }
            },
            '38': {
                start: {
                    line: 57,
                    column: 0
                },
                end: {
                    line: 66,
                    column: 2
                }
            },
            '39': {
                start: {
                    line: 58,
                    column: 15
                },
                end: {
                    line: 58,
                    column: 29
                }
            },
            '40': {
                start: {
                    line: 59,
                    column: 14
                },
                end: {
                    line: 59,
                    column: 28
                }
            },
            '41': {
                start: {
                    line: 60,
                    column: 16
                },
                end: {
                    line: 60,
                    column: 31
                }
            },
            '42': {
                start: {
                    line: 61,
                    column: 19
                },
                end: {
                    line: 64,
                    column: 5
                }
            },
            '43': {
                start: {
                    line: 65,
                    column: 4
                },
                end: {
                    line: 65,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 24
                    },
                    end: {
                        line: 1,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 36
                    },
                    end: {
                        line: 3,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 27
                    },
                    end: {
                        line: 6,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 10,
                        column: 1
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 38
                    },
                    end: {
                        line: 7,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 14,
                        column: 36
                    },
                    end: {
                        line: 14,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 32
                    },
                    end: {
                        line: 20,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 44
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 20
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 21,
                        column: 36
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 26,
                        column: 26
                    },
                    end: {
                        line: 26,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 38
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 26
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 36,
                        column: 28
                    },
                    end: {
                        line: 36,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 40
                    },
                    end: {
                        line: 46,
                        column: 1
                    }
                },
                line: 36
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 48,
                        column: 29
                    },
                    end: {
                        line: 48,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 41
                    },
                    end: {
                        line: 55,
                        column: 1
                    }
                },
                line: 48
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 57,
                        column: 31
                    },
                    end: {
                        line: 57,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 42
                    },
                    end: {
                        line: 66,
                        column: 1
                    }
                },
                line: 57
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }, {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }],
                line: 31
            },
            '1': {
                loc: {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }, {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }],
                line: 32
            },
            '2': {
                loc: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }, {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }],
                line: 42
            },
            '3': {
                loc: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }, {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }],
                line: 43
            },
            '4': {
                loc: {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }, {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }],
                line: 44
            },
            '5': {
                loc: {
                    start: {
                        line: 54,
                        column: 12
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 26
                    },
                    end: {
                        line: 54,
                        column: 38
                    }
                }, {
                    start: {
                        line: 54,
                        column: 41
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                }],
                line: 54
            },
            '6': {
                loc: {
                    start: {
                        line: 54,
                        column: 65
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 79
                    },
                    end: {
                        line: 54,
                        column: 81
                    }
                }, {
                    start: {
                        line: 54,
                        column: 84
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                }],
                line: 54
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_ipyzih9ki.s[0]++;
String.prototype.trim = function () {
    cov_ipyzih9ki.f[0]++;
    cov_ipyzih9ki.s[1]++;

    return this.replace(/^\s+|\s+$/g, "");
};

//To Camel Case
cov_ipyzih9ki.s[2]++;
String.prototype.toCamel = function () {
    cov_ipyzih9ki.f[1]++;
    cov_ipyzih9ki.s[3]++;

    return this.replace(/(\-[a-z])/g, function ($1) {
        cov_ipyzih9ki.f[2]++;
        cov_ipyzih9ki.s[4]++;

        return $1.toUpperCase().replace('-', '');
    });
};

//To Dashed from Camel Case
cov_ipyzih9ki.s[5]++;
String.prototype.toDash = function () {
    cov_ipyzih9ki.f[3]++;
    cov_ipyzih9ki.s[6]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_ipyzih9ki.f[4]++;
        cov_ipyzih9ki.s[7]++;

        return "-" + $1.toLowerCase();
    });
};

//To Underscore from Camel Case
cov_ipyzih9ki.s[8]++;
String.prototype.toUnderscore = function () {
    cov_ipyzih9ki.f[5]++;
    cov_ipyzih9ki.s[9]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_ipyzih9ki.f[6]++;
        cov_ipyzih9ki.s[10]++;

        return "_" + $1.toLowerCase();
    });
};

cov_ipyzih9ki.s[11]++;
String.prototype.toHHMM = function () {
    cov_ipyzih9ki.f[7]++;

    var sec_num = (cov_ipyzih9ki.s[12]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_ipyzih9ki.s[13]++, Math.floor(sec_num / 3600));
    var minutes = (cov_ipyzih9ki.s[14]++, Math.floor((sec_num - hours * 3600) / 60));

    cov_ipyzih9ki.s[15]++;
    if (hours < 10) {
        cov_ipyzih9ki.b[0][0]++;
        cov_ipyzih9ki.s[16]++;
        hours = "0" + hours;
    } else {
        cov_ipyzih9ki.b[0][1]++;
    }
    cov_ipyzih9ki.s[17]++;
    if (minutes < 10) {
        cov_ipyzih9ki.b[1][0]++;
        cov_ipyzih9ki.s[18]++;
        minutes = "0" + minutes;
    } else {
        cov_ipyzih9ki.b[1][1]++;
    }
    cov_ipyzih9ki.s[19]++;
    return hours + ':' + minutes;
};

cov_ipyzih9ki.s[20]++;
String.prototype.toHHMMSS = function () {
    cov_ipyzih9ki.f[8]++;

    var sec_num = (cov_ipyzih9ki.s[21]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_ipyzih9ki.s[22]++, Math.floor(sec_num / 3600));
    var minutes = (cov_ipyzih9ki.s[23]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_ipyzih9ki.s[24]++, sec_num - hours * 3600 - minutes * 60);

    cov_ipyzih9ki.s[25]++;
    if (hours < 10) {
        cov_ipyzih9ki.b[2][0]++;
        cov_ipyzih9ki.s[26]++;
        hours = "0" + hours;
    } else {
        cov_ipyzih9ki.b[2][1]++;
    }
    cov_ipyzih9ki.s[27]++;
    if (minutes < 10) {
        cov_ipyzih9ki.b[3][0]++;
        cov_ipyzih9ki.s[28]++;
        minutes = "0" + minutes;
    } else {
        cov_ipyzih9ki.b[3][1]++;
    }
    cov_ipyzih9ki.s[29]++;
    if (seconds < 10) {
        cov_ipyzih9ki.b[4][0]++;
        cov_ipyzih9ki.s[30]++;
        seconds = "0" + seconds;
    } else {
        cov_ipyzih9ki.b[4][1]++;
    }
    cov_ipyzih9ki.s[31]++;
    return hours + ':' + minutes + ':' + seconds;
};

cov_ipyzih9ki.s[32]++;
String.prototype.toHhMmSSs = function () {
    cov_ipyzih9ki.f[9]++;

    var sec_num = (cov_ipyzih9ki.s[33]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_ipyzih9ki.s[34]++, Math.floor(sec_num / 3600));
    var minutes = (cov_ipyzih9ki.s[35]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_ipyzih9ki.s[36]++, sec_num - hours * 3600 - minutes * 60);

    cov_ipyzih9ki.s[37]++;
    return (hours > 0 ? (cov_ipyzih9ki.b[5][0]++, hours + 'h ') : (cov_ipyzih9ki.b[5][1]++, '')) + minutes + 'm ' + (hours > 0 ? (cov_ipyzih9ki.b[6][0]++, '') : (cov_ipyzih9ki.b[6][1]++, seconds + 's'));
};

cov_ipyzih9ki.s[38]++;
String.prototype.toDayOfYear = function () {
    cov_ipyzih9ki.f[10]++;

    var date = (cov_ipyzih9ki.s[39]++, new Date(this));
    var day = (cov_ipyzih9ki.s[40]++, date.getDate());
    var month = (cov_ipyzih9ki.s[41]++, date.getMonth());
    var months = (cov_ipyzih9ki.s[42]++, ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']);
    cov_ipyzih9ki.s[43]++;
    return day + ' de ' + months[month];
};
'use strict';

var cov_t1dm10lp0 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/contenteditable.directive.js',
        hash = '164ae335707b992b449e46af90e3965e2c8ab647',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/contenteditable.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 25,
                    column: 7
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 20
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 59
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 18
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 59
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 19
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 46
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 18
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 9
            },
            '3': {
                name: 'read',
                decl: {
                    start: {
                        line: 11,
                        column: 25
                    },
                    end: {
                        line: 11,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 33
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 11
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 34
                    },
                    end: {
                        line: 16,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 46
                    },
                    end: {
                        line: 18,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 50
                    },
                    end: {
                        line: 20,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 62
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 51
                    }
                }, {
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                }, {
                    start: {
                        line: 17,
                        column: 55
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_t1dm10lp0.s[0]++;
(function () {
    'use strict';

    cov_t1dm10lp0.f[0]++;
    cov_t1dm10lp0.s[1]++;
    angular.module('app').directive("contenteditable", function () {
        cov_t1dm10lp0.f[1]++;
        cov_t1dm10lp0.s[2]++;

        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attrs, ngModel) {
                cov_t1dm10lp0.f[2]++;


                function read() {
                    cov_t1dm10lp0.f[3]++;
                    cov_t1dm10lp0.s[3]++;

                    ngModel.$setViewValue(element.text());
                    cov_t1dm10lp0.s[4]++;
                    element.text((cov_t1dm10lp0.b[0][0]++, ngModel.$viewValue) || (cov_t1dm10lp0.b[0][1]++, ""));
                }

                cov_t1dm10lp0.s[5]++;
                ngModel.$render = function () {
                    cov_t1dm10lp0.f[4]++;
                    cov_t1dm10lp0.s[6]++;

                    element.text((cov_t1dm10lp0.b[1][0]++, ngModel.$viewValue) || (cov_t1dm10lp0.b[1][1]++, ""));
                };

                cov_t1dm10lp0.s[7]++;
                element.bind("blur keyup change", function () {
                    cov_t1dm10lp0.f[5]++;
                    cov_t1dm10lp0.s[8]++;

                    scope.$apply(read);
                });
            }
        };
    });
})();
'use strict';

var cov_2e5lewc3hb = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/fab/fab.js',
        hash = '3c4567d972592b4ffbf32221ced6cb34415bc8fc',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/fab/fab.js',
        statementMap: {
            '0': {
                start: {
                    line: 7,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FabController = function FabController() {
    _classCallCheck(this, FabController);

    cov_2e5lewc3hb.f[0]++;
};

cov_2e5lewc3hb.s[0]++;


angular.module('app').component('fab', {
    templateUrl: 'app/shared/fab/fab.html',
    controller: FabController,
    bindings: {
        onAction: '&',
        tooltip: '@',
        icon: '@'
    }
});
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/shared/fab/fab.html","<md-fab-speed-dial md-direction=\"up\" class=\"md-fling md-fab-bottom-right\">\n    <md-fab-trigger>\n        <md-button aria-label=\"Criar projeto\" class=\"md-fab\" ng-click=\"$ctrl.onAction()\">\n            <md-tooltip ng-if=\"$ctrl.tooltip\" md-direction=\"left\">{{::$ctrl.tooltip}}</md-tooltip>\n            <md-icon ng-if=\"$ctrl.icon\">{{::$ctrl.icon}}</md-icon>\n        </md-button>\n    </md-fab-trigger>\n</md-fab-speed-dial>\n");
$templateCache.put("app/components/clockBar/clockBar.html","<task-preview task=\"$root.me.$lastTask\" ng-if=\"$root.me.$lastTask.state == \'EXECUTING\'\"></task-preview>\n<h1 ng-if=\"!$root.me.$lastTask || $root.me.$lastTask.state != \'EXECUTING\'\" class=\"text-center text-fade\">Nothing going on. Start working</h1>\n");
$templateCache.put("app/components/createProjectModal/createProjectModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newProject.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Create new project</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Project name</label>\n            <input type=\"text\" ng-model=\"newProject.name\" maxlength=\"50\">\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createProject()\">Create project</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/executionPreview/executionPreview.html","<div layout=\"row\" layout-align=\"start center\">\n    <task-preview task=\"$ctrl.execution.$task\" display-minimal=\"true\" flex></task-preview>\n\n    <div class=\"open-new-window\">\n        <a target=\"_blank\" ui-sref=\"taskView({id: $ctrl.execution.$task.id})\" class=\"md-button md-icon-button\">\n            <md-tooltip>Open task in a new window</md-tooltip>\n            <md-icon>open_in_new</md-icon>\n        </a>\n    </div>\n\n    <small class=\"text-fade\">\n        ( {{($ctrl.execution.duration + \'\').toHhMmSSs()}} )\n    </small>\n    <mdp-time-picker ng-model=\"$ctrl.execution.start\" ng-change=\"$ctrl.execution.$save()\"></mdp-time-picker>\n    <b style=\"font-size: 20px\">~</b>\n    <mdp-time-picker ng-model=\"$ctrl.execution.end\" ng-change=\"$ctrl.execution.$save()\"></mdp-time-picker>\n\n\n    <md-menu md-position-mode=\"target-right target\">\n        <div ng-click=\"$mdMenu.open($event)\">\n            <md-tooltip>Click to modify the day</md-tooltip>\n            <md-button class=\"md-icon-button\" style=\"margin-left: 0; padding-left: 0\">\n                <md-icon md-menu-origin>today</md-icon>\n            </md-button>\n        </div>\n\n        <md-menu-content width=\"6\" id=\"execution-day-menu-content\">\n            <md-menu-item>\n                <h2 class=\"text-center\" flex>Which day did it happen?</h2>\n            </md-menu-item>\n            <md-menu-item>\n                <div layout=\"row\" style=\"padding-top: 20px\">\n                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                        <h3>Start</h3>\n                        <mdp-date-picker md-menu-align-target ng-model=\"$ctrl.execution.start\">\n                    </div>\n                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                        <h3>End</h3>\n                        <mdp-date-picker md-menu-align-target ng-model=\"$ctrl.execution.end\">\n                    </div>\n                </div>\n            </md-menu-item>\n            <div layout=\"row\" layout-align=\"center center\" cg-busy=\"$ctrl.user.$executions.$promise\">\n                <md-button class=\"md-button md-raised md-accent\" ng-click=\"$ctrl.execution.$save([\'start\', \'end\'])\">\n                    Save\n                </md-button>\n            </div>\n        </md-menu-content>\n    </md-menu>\n</div>\n");
$templateCache.put("app/components/inputDuration/inputDuration.html","<input type=\"text\" ng-model=\"$ctrl.viewDuration\" ui-mask=\"99:99\" model-view-value=\"true\" ui-mask-placeholder ui-mask-placeholder-char=\"0\" ng-change=\"$ctrl.changeDuration()\" style=\"width: 42px\" class=\"fake-input\">\n");
$templateCache.put("app/components/newExecutionModal/newExecutionModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newExecution.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add new execution</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-menu>\n            <md-menu-content id=\"execution-day-menu-content\">\n                <md-menu-item>\n                    <div layout=\"row\" style=\"padding-top: 20px\">\n                        <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                            <md-input-container>\n                                <input placeholder=\"Start\" type=\"datetime-local\" ng-model=\"newExecution.start\">\n                            </md-input-container>\n                        </div>\n                        &nbsp &nbsp &nbsp &nbsp\n                        <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                            <md-input-container>\n                                <input placeholder=\"End\" type=\"datetime-local\" ng-model=\"newExecution.end\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n        <br> <br>\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createExecution()\">Add execution</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/newProjectReportModal/newProjectReportModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newReport.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Generate new project report</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n	<div style=\"padding-top: 20px\">\n	    <md-input-container class=\"md-block\">\n		<input placeholder=\"Name\" ng-model=\"newReport.name\">\n            </md-input-container>\n	</div>\n\n	<div>\n	    <md-input-container class=\"md-block\">\n		<label>Description</label>\n		<textarea ng-model=\"newReport.description\" rows=\"3\"></textarea>\n            </md-input-container>\n	</div>\n\n	<md-input-container class=\"md-block\">\n	    <label>Type</label>\n	    <md-select ng-model=\"newReport.type\">\n		<md-option value=\"DETAIL\">Detail</md-option>\n		<md-option value=\"SUMMARY\">Summary</md-option>\n	    </md-select>\n        </md-input-container>\n\n        <div layout=\"row\" style=\"padding-top: 20px\">\n            <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                <md-input-container>\n                    <input placeholder=\"Start\" type=\"date\" ng-model=\"newReport.start\" style=\"max-width: 140px\">\n                </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                <md-input-container>\n                    <input placeholder=\"End\" type=\"date\" ng-model=\"newReport.end\" style=\"max-width: 140px\">\n                </md-input-container>\n            </div>\n        </div>\n        <br> <br>\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createProjectReport()\">Generate report</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/newRecurrentModal/newRecurrentModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newRecurrentTask.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Create Recurrent Task</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Name</label>\n            <input type=\"text\" ng-model=\"newRecurrentTask.name\">\n        </md-input-container>\n\n	<md-input-container class=\"md-block\">\n	    <label>Description</label>\n	    <textarea ng-model=\"newRecurrentTask.description\"></textarea>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\">\n            <label>Project</label>\n            <md-select ng-model=\"newRecurrentTask.project\">\n                <md-option ng-repeat=\"project in projects\" ng-value=\"project.id\">\n                    {{project.name}}\n                </md-option>\n            </md-select>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\">\n            <label>Recurrence</label>\n            <md-select ng-model=\"newRecurrentTask.recurrence\">\n                <md-option value=\"WORKDAILY\">\n                    Working Days\n                </md-option>\n                <md-option value=\"DAILY\">\n                    Daily\n                </md-option>\n                <md-option value=\"WEEKLY\">\n                    Weekly\n                </md-option>\n                <md-option value=\"MONTHLY\">\n                    Monthly\n                </md-option>\n            </md-select>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\">\n\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createRecurrentTask()\">Create Recurrent Task</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/paginator/paginator.html","<div layout=\"row\" layout-align=\"center center\">\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToPreviousPage()\" ng-disabled=\"$ctrl.collection.$page == 1\">\n        <md-icon>chevron_left</md-icon>\n    </md-button>\n    <div class=\"text-fade text-center\">\n        <span style=\"font-size: 14px; text-transform: uppercase\">Página</span>\n        <span>{{$ctrl.collection.$page}}</span>\n    </div>\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToNextPage()\" ng-disabled=\"($ctrl.collection.$page * 25) >= $ctrl.collection.$totalCount\">\n        <md-icon>chevron_right</md-icon>\n    </md-button>\n</div>\n");
$templateCache.put("app/components/projectDetails/projectDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex cg-busy=\"$ctrl.project.$tasks.$promise\">\n    <div class=\"padding\">\n        <div class=\"hide-on-print\">\n            <div layout=\"row\" layout-align=\"start center\">\n                <input type=\"text\" ng-model=\"$ctrl.project.name\" class=\"title-input\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.project.$save([\'name\'])\" style=\"margin: 0px\"> <span flex></span>\n\n                <div layout=\"column\" style=\"margin: 0 15px\">\n                    <md-nav-bar md-selected-nav-item=\"$ctrl.currentNav\" aria-label=\"Menu\">\n			<md-nav-item name=\"general\" md-nav-click=\"$ctrl.currentNav = \'general\'\">\n                            General\n                        </md-nav-item>\n                        <md-nav-item name=\"tasks\" md-nav-click=\"$ctrl.currentNav = \'tasks\'\">\n                            Tasks\n                        </md-nav-item>\n                        <md-nav-item name=\"stories\" md-nav-click=\"$ctrl.currentNav = \'stories\'\">\n                            Stories\n                        </md-nav-item>\n                        <md-nav-item name=\"reports\" md-nav-click=\"$ctrl.currentNav = \'reports\'\">\n                            Reports\n                        </md-nav-item>\n                    </md-nav-bar>\n                </div>\n                <md-menu md-position-mode=\"target-right target\">\n                    <md-button aria-label=\"Open profile menu\" ng-click=\"$mdMenu.open($event)\">\n                        <md-icon>settings</md-icon>\n                        <md-icon md-menu-origin>arrow_drop_down</md-icon>\n                    </md-button>\n                    <md-menu-content width=\"4\" style=\"padding: 0\">\n                        <md-menu-item>\n                            <span>Billable Rate</span>\n                            <input ng-model=\"$ctrl.project.billableRate\" class=\"title-input\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.project.$save([\'billableRate\'])\">\n                        </md-menu-item>\n                    </md-menu-content>\n                </md-menu>\n            </div>\n            <br> <br>\n        </div>\n\n        <div ng-if=\"$ctrl.currentNav === \'tasks\'\">\n            <div layout=\"column\" layout-align=\"start start\" style=\"border: solid 1px #ccc; background-color: #eee; padding: 20px; font-size: 20px; font-weight: 300; letter-spacing: 1px; opacity: 0.8; line-height: 35px\">\n                <div>ETA {{($ctrl.project.totalEta + \'\').toHhMmSSs()}}</div>\n                <div>Completed {{($ctrl.project.totalDuration + \'\').toHhMmSSs()}}</div>\n                <div>Billable Rate {{$ctrl.project.billableRate}}€</div>\n                <div>Billable Amount {{$ctrl.project.billableAmount}}€</div>\n            </div>\n\n            <br> <br>\n            <div layout=\"row\" layout-align=\"center center\">\n                <h1>Tasks</h1>\n                <span flex></span>\n                <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <md-icon>search</md-icon>\n                    </div>\n                    <input type=\"text\" flex placeholder=\"Search task\" ng-change=\"$ctrl.filterTasks(searchTasks)\" ng-model=\"searchTasks\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                </div>\n            </div>\n            <br> <br> <br>\n\n            <md-list class=\"tasks-list\" ng-if=\"!($ctrl.project.$tasks | isEmpty)\">\n                <md-list-item ng-repeat=\"task in $ctrl.project.$tasks\" layout=\"row\">\n                    <task-preview task=\"task\" flex></task-preview>\n                </md-list-item>\n            </md-list>\n\n            <div layout=\"row\" layout-align=\"center center\" ng-if=\"!($ctrl.project.$tasks | isEmpty)\">\n                <paginator collection=\"$ctrl.project.$tasks\"></paginator>\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.currentNav === \'stories\'\">\n            <div class=\"hide-on-print\">\n                <div layout=\"row\" layout-align=\"start center\" ng-if=\"!($ctrl.project.$proposals | isEmpty)\">\n                    <div layout=\"column\">\n                        <md-nav-bar md-selected-nav-item=\"$ctrl.currentProposal\" aria-label=\"Proposals\">\n                            <md-nav-item ng-repeat=\"proposal in $ctrl.project.$proposals | orderBy: \'id\'\" name=\"{{proposal.id}}\" md-nav-click=\"$ctrl.selectProposal(proposal)\" ng-init=\"$ctrl.proposal = ($first ? proposal: $ctrl.proposal); $ctrl.selectProposal($ctrl.proposal)\">\n                                Proposal {{::proposal.id}}\n                            </md-nav-item>\n                        </md-nav-bar>\n                    </div>\n                    <span flex></span>\n                    <div layout=\"row\" ng-if=\"$ctrl.currentProposal\">\n                        <div layout=\"column\" layout-align=\"center center\" ng-if=\"$ctrl.proposal.nonVersionedStories > 0\">\n                            <md-button class=\"md-icon-button\" ng-click=\"$ctrl.updateProposalVersion()\">\n                                <md-tooltip md-direction=\"top\">\n                                    Stories updated\n                                </md-tooltip>\n                                <md-icon>\n                                    update\n                                </md-icon>\n                            </md-button>\n                        </div>\n                        <md-menu md-position-mode=\"target-right target\" md-offset=\"0 40\">\n                            <md-button class=\"md-icon-button\" aria-label=\"Open profile menu\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>more_vert</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"2\" style=\"padding: 0\">\n                                <md-menu-item>\n                                    <md-button ng-click=\"$ctrl.$window.print()\">\n                                        Print\n                                    </md-button>\n                                </md-menu-item>\n                                <md-menu-item>\n                                    <md-button ui-sref=\"projectStories({id: $ctrl.project.id, proposal: $ctrl.currentProposal})\">\n                                        <span style=\"color: black\">Edit</span>\n                                    </md-button>\n                                </md-menu-item>\n                                <md-menu-item>\n                                    <md-button ng-click=\"$ctrl.removeProposal()\">\n                                        Remove\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </div>\n                </div>\n                <br>\n            </div>\n            <div layout=\"column\" flex class=\"proposal-preview\" ng-if=\"$ctrl.proposal\">\n                <span class=\"proposal-title\">Plano de Entregas {{$ctrl.proposal.name}}</span>\n                <div class=\"proposal-section\">\n                    <ul class=\"section-content\">\n                        <li>\n                            <span class=\"proposal-text\">Versão: {{$ctrl.proposal.version}}</span>\n                        </li>\n                        <li>\n                            <span class=\"proposal-text\">Data: {{($ctrl.proposal.date + \'\').toDayOfYear()}}</span>\n                        </li>\n                    </ul>\n                </div>\n                <div class=\"proposal-section\" ng-if=\"$ctrl.proposal.introduction\">\n                    <div layout=\"row\" class=\"proposal-subtitle section-title\">Introdução</div>\n                    <div class=\"proposal-text section-content\">{{$ctrl.proposal.introduction}}</div>\n                </div>\n                <div class=\"proposal-section\" ng-if=\"$ctrl.roles.length\">\n                    <div layout=\"row\" class=\"proposal-subtitle section-title\">Tipos de Utilizador</div>\n                    <ul class=\"section-content\">\n                        <li ng-repeat=\"role in $ctrl.roles\">\n                            <span class=\"proposal-text\">{{role}}</span>\n                        </li>\n                    </ul>\n                </div>\n                <div class=\"proposal-section\" ng-if=\"$ctrl.notUpdated()\">\n                    <div layout=\"row\" class=\"proposal-subtitle section-title\">Funcionalidades</div>\n\n                    <div layout=\"column\" class=\"section-content\" ng-repeat=\"role in $ctrl.roles\">\n                        <div layout=\"row\" class=\"proposal-sub-subtitle section-title\">{{role}}</div>\n                        <ul class=\"sub-section-content\">\n                            <li ng-repeat=\"story in $ctrl.proposal.$stories | filter: {role: role} | actualVersion: $ctrl.proposal.version | orderBy: \'order\'\">\n                                <span class=\"proposal-text\">#{{story.order}} {{story.role}} {{story.name}}<strong ng-if=\"story.description && story.description!== \'\'\">*</strong></span>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n                <div class=\"proposal-section\" ng-if=\"$ctrl.questions()\">\n                    <div layout=\"row\" class=\"proposal-subtitle section-title\">Questões e Detalhes</div>\n                    <div class=\"proposal-text section-content\">{{$ctrl.proposal.questions}}</div>\n                    <div layout=\"column\" class=\"section-content\" ng-repeat=\"story in $ctrl.proposal.$stories | actualVersion: $ctrl.proposal.version | orderBy: \'order\'\" ng-if=\"story.description !== null && story.description.length > 0\">\n                        <div layout=\"row\" class=\"proposal-sub-subtitle section-title\">\n                            #{{story.order}} {{story.name}}<span ng-if=\"story.isBlocked\">&nbsp;| PENDENTE</span><span ng-if=\"!story.isBlocked\">&nbsp;| PRONTO</span>\n                        </div>\n                        <div class=\"proposal-text section-content\">{{story.description}}</div>\n                    </div>\n                </div>\n                <div class=\"proposal-section\" ng-if=\"$ctrl.deliveries.length\">\n                    <div layout=\"row\" class=\"proposal-subtitle section-title\">Entregas</div>\n\n                    <div layout=\"column\" class=\"section-content\" ng-repeat=\"delivery in $ctrl.deliveries\">\n                        <div layout=\"row\" class=\"proposal-sub-subtitle section-title\">Entrega {{delivery}}</div>\n                        <ul class=\"sub-section-content\">\n                            <li ng-repeat=\"story in $ctrl.proposal.$stories | filter: {delivery: delivery} | actualVersion: $ctrl.proposal.version | orderBy: \'order\'\">\n                                <span class=\"proposal-text\">#{{story.order}} {{story.role}} {{story.name}}<strong ng-if=\"story.description && story.description!== \'\'\">*</strong></span>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.currentNav === \'reports\'\">\n            <div layout=\"row\" layout-align=\"center center\" ng-if=\"!($ctrl.project.$tasks | isEmpty)\">\n                <h1>Project Reports</h1>\n                <span flex></span>\n                <div layout=\"row\" layout-align=\"start stretch\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewProjectReportModal()\">\n                            <md-icon>add</md-icon>\n                            New Report\n                        </md-button>\n                    </div>\n                </div>\n            </div>\n            <md-list class=\"reports-list\">\n                <md-list-item ng-repeat=\"report in $ctrl.project.$reports  | filter: {isDeleted: false} | orderBy: \'-start\'\">\n                    <p flex layout=\"row\" layout-align=\"start center\">\n                        <span class=\"text-fade\" style=\"padding-left: 5px\">{{report.start | date: \'dd-MM-yyyy\'}} - {{report.end |date:\'dd-MM-yyyy\'}} (v{{report.version}})</span>\n                    </p>\n                    <div class=\"text-fade\" style=\"margin-right: 5px\">\n                        {{::(report.duration + \'\').toHhMmSSs()}}\n                    </div>\n                    <a href=\"{{report.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\">\n                        <md-icon>file_download</md-icon>\n                    </a>\n                </md-list-item>\n            </md-list>\n        </div>\n    </div>\n\n    <div ng-if=\"$ctrl.currentNav === \'general\'\" class=\"hide-on-print\">\n	<div class=\"padding\">\n	    <div layout=\"row\" layout-align=\"start center\">\n\n		<md-input-container class=\"md-block\" flex>\n		    <label>Evaluation</label>\n		    <textarea ng-model=\"$ctrl.project.evaluation\" placeholder=\"Evaluation\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.project.$save([\'evaluation\'])\"></textarea>\n\n		</md-input-container>\n	    </div>\n	</div>\n    </div>\n</md-content>\n\n\n<div ng-if=\"$ctrl.currentNav === \'tasks\'\">\n    <div ng-if=\"($ctrl.project.$tasks | isEmpty)\" layout=\"column\" layout-align=\"center center\" class=\"no-tasks-warning\">\n        <h1>No tasks found</h1>\n        <div layout=\"row\" layout-align=\"center center\" layout-margin>\n            <md-icon>arrow_downward</md-icon>\n            <h3>Add one!</h3>\n            <md-icon>arrow_downward</md-icon>\n        </div>\n    </div>\n\n    <div cg-busy=\"$ctrl.newTask.$promise\">\n        <form layout=\"row\" layout-align=\"center center\" style=\"width: 100%; padding-top: 15px\" ng-submit=\"$ctrl.createTask($ctrl.newTaskName, $ctrl.newTaskUser)\">\n            <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\">\n                <input type=\"text\" ng-model=\"$ctrl.newTaskName\" flex placeholder=\"Add a task to {{$ctrl.project.name}}\">\n                <md-input-container class=\"no-margin\">\n                    <label>Team</label>\n                    <md-select ng-model=\"$ctrl.newTaskUser\" aria-label=\"Select an user\">\n                        <md-select-header>\n                            <input ng-model=\"searchTerm\" type=\"search\" class=\"md-text task-project-select-search\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 0, \'blur\': 0}, updateOnDefault: true}\">\n                        </md-select-header>\n                        <md-option><span style=\"padding-left: 55px\" class=\"text-fade\">None</span></md-option>\n                        <md-option ng-repeat=\"user in $ctrl.users | orderBy: \'name\' | fuzzyBy: \'name\' :searchTerm\" ng-value=\"user.id\">\n                            <div layout=\"row\" layout-align=\"center center\">\n                                <img ng-src=\"{{user.avatar | mediaUrl}}\" class=\"avatar-sm\">\n                                <div style=\"padding-left: 15px\">{{user.name}}</div>\n                            </div>\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <input type=\"submit\" hide>\n        </form>\n    </div>\n</div>\n\n<div ng-if=\"$ctrl.currentNav === \'stories\'\" class=\"hide-on-print\">\n    <div ng-if=\"($ctrl.project.$proposals | isEmpty)\" layout=\"column\" layout-align=\"center center\" class=\"no-tasks-warning\">\n        <h1>{{$ctrl.project.name}} has no proposals yet</h1>\n        <div layout=\"row\" layout-align=\"center center\" layout-margin>\n            <md-icon>arrow_downward</md-icon>\n            <h3>Add the first one!</h3>\n            <md-icon>arrow_downward</md-icon>\n        </div>\n    </div>\n\n    <div cg-busy=\"$ctrl.newProposal.$promise\">\n        <form layout=\"row\" layout-align=\"center center\" style=\"width: 100%; padding-top: 15px\" ng-submit=\"$ctrl.newProposalName && $ctrl.createProposal($ctrl.newProposalName, $ctrl.newProposalOrder)\">\n            <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\">\n                <input type=\"text\" ng-model=\"$ctrl.newProposalName\" flex placeholder=\"Add a proposal to {{$ctrl.project.name}}\" required>\n                <input type=\"number\" ng-model=\"$ctrl.newProposalOrder\" aria-label=\"proposal-id\" placeholder=\"Prospector ID\" step=\"1\" min=\"1\" autosize ng-style=\"{\'min-width\': $ctrl.newProposalOrder ? \'10px\' : \'130px\'}\">\n            </div>\n            <input type=\"submit\" hide>\n        </form>\n    </div>\n</div>\n");
$templateCache.put("app/components/projectSelector/projectSelector.html","<md-input-container class=\"project-select\">\n    <md-select ng-model=\"$ctrl.ngModel\" ng-change=\"$ctrl.changed()\" class=\"md-no-underline\">\n        <md-select-header>\n            <input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Search project\" class=\"md-text task-project-select-search\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 0, \'blur\': 0}, updateOnDefault: true}\">\n        </md-select-header>\n\n        <md-option value=\"null\"><i class=\"text-fade\">Without project</i></md-option>\n        <md-option ng-value=\"project.id\" ng-repeat=\"project in $root.activeProjects | fuzzyBy: \'name\' : searchTerm  | orderBy: \'name\'\" class=\"hide-icons\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <span>{{project.name}}</span>\n            </div>\n        </md-option>\n    </md-select>\n</md-input-container>\n");
$templateCache.put("app/components/projectStatistic/projectStatistic.html","<div style=\"padding: 0 30px; border-bottom: solid 1px #eee\" layout=\"column\">\n    <div ng-repeat=\"working in $ctrl.statistic.workingByUser\" ng-if=\"working.duration\" layout=\"row\" layout-align=\"start center\">\n        <user-badge user=\"working.user\" style=\"min-width: 200px\"></user-badge>\n        <span class=\"text-fade\">{{(working.duration + \'\').toHhMmSSs()}}</span>\n    </div>\n</div>\n");
$templateCache.put("app/components/projectStories/projectStories.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div layout=\"row\" layout-align=\"start center\" style=\"border-bottom: solid 1px #e1e1e8\">\n        <md-button class=\"md-accent\" ui-sref=\"projectDetails({id: $ctrl.proposal.project})\">\n            <md-icon>arrow_back</md-icon>\n            Back to Project\n        </md-button>\n        <span flex></span>\n        <div layout=\"column\" style=\"margin: 0 15px\">\n            <md-nav-bar md-selected-nav-item=\"$ctrl.currentNav\">\n                <md-nav-item name=\"user_stories\" md-nav-click=\"$ctrl.currentNav = \'user_stories\'\">\n                    User Stories\n                </md-nav-item>\n                <md-nav-item name=\"proposal_details\" md-nav-click=\"$ctrl.currentNav = \'proposal_details\'\">\n                    Proposal Details\n                </md-nav-item>\n            </md-nav-bar>\n            <!--<md-nav-bar md-selected-nav-item=\"$ctrl.currentDelivery\">-->\n            <!--<md-nav-item ng-repeat=\"(key, value) in $ctrl.proposal.$stories | orderBy: \'delivery\' | groupBy: \'delivery\'\" name=\"{{key}}\" md-nav-click=\"$ctrl.currentDelivery = \'{{key}}\'\" ng-init=\"$first ? $ctrl.currentDelivery = (\'\' + key) : \'\'\">-->\n            <!--Entrega <span ng-if=\"key !== null && key !== \'null\'\">{{::key}}</span>-->\n            <!--</md-nav-item>-->\n            <!--</md-nav-bar>-->\n        </div>\n    </div>\n\n    <div ng-if=\"$ctrl.currentNav == \'user_stories\'\">\n        <div layout=\"row\" layout-align=\"start center\" style=\"padding: 5px; border-bottom: solid 1px #e1e1e8\">\n            <md-button class=\"md-icon-button\" ng-click=\"$ctrl.filterBlocked()\">\n                <md-icon ng-class=\"{grey: !$ctrl.blocked, red: $ctrl.blocked}\">block</md-icon>\n                <md-tooltip md-direction=\"right\" ng-if=\"!$ctrl.blocked\">Filter blocked stories</md-tooltip>\n                <md-tooltip md-direction=\"right\" ng-if=\"$ctrl.blocked\">All stories</md-tooltip>\n            </md-button>\n            <span flex></span>\n            <div layout=\"row\" layout-align=\"end center\" style=\"font-size: 14px\">\n                <span style=\"margin-right: 10px\">Sort by:</span>\n                <md-select ng-model=\"$ctrl.requestData.ordering\" ng-change=\"$ctrl.update()\" aria-label=\"Sort by\" style=\"margin: 0\">\n                    <md-option value=\"delivery\">\n                        Entregas\n                    </md-option>\n                    <md-option value=\"role\">\n                        Roles\n                    </md-option>\n                </md-select>\n            </div>\n        </div>\n        <div style=\"padding: 0 16px\">\n            <md-list>\n                <md-list-item ng-repeat=\"(key, value) in $ctrl.proposal.$stories | groupBy: $ctrl.requestData.ordering\" class=\"main-item\">\n                    <div layout=\"column\" flex>\n                        <div layout=\"row\">\n                            <h4 flex ng-if=\"$ctrl.requestData.ordering === \'role\'\">\n                                <span ng-if=\"key === \'\'\" class=\"text-fade\">No role</span>\n                                <span ng-if=\"key !== \'\'\">{{::key}}</span>\n                            </h4>\n                            <h4 flex ng-if=\"$ctrl.requestData.ordering === \'delivery\'\">Entrega {{::key}}</h4>\n                        </div>\n                        <div layout=\"row\" flex>\n                            <md-list class=\"no-padding\" flex>\n                                <md-list-item ng-repeat=\"story in value | orderBy: \'order\'\" flex class=\"disable-md-clickable\" style=\"outline: none; cursor: default; font-size: 15px\" ng-if=\"!story.isDeleted && (!story.version || (story.version && !story.duplicates))\">\n                                    <div layout=\"column\" flex ng-click=\"$event.stopPropagation()\" style=\"outline: none; cursor: default\">\n                                        <div layout=\"row\" flex style=\"padding: 10px\" ng-mouseenter=\"$scope.options = true;\" ng-mouseleave=\"$scope.options = false;\" ng-class=\"{\'no-border\': !$scope.editing, \'light-border\': $scope.editing, \'normal\': !$scope.options, \'on-hover\': $scope.options || $scope.editing}\">\n                                            <div layout=\"column\" class=\"small-button right baseline\">\n                                                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.changeBlock(story)\">\n                                                    <md-tooltip ng-if=\"!story.isBlocked\">Block</md-tooltip>\n                                                    <md-tooltip ng-if=\"story.isBlocked\">Unlock</md-tooltip>\n                                                    <md-icon class=\"small-icon\" ng-class=\"{grey: !story.isBlocked, red: story.isBlocked, visible: $scope.options || story.isBlocked || $scope.editing, invisible: !$scope.options && !story.isBlocked && !$scope.editing}\">block</md-icon>\n                                                </md-button>\n                                            </div>\n                                            <div layout=\"column\" class=\"small-button right baseline\">\n                                                <md-button class=\"md-icon-button\" ng-click=\"$scope.editing = !$scope.editing\">\n                                                    <md-tooltip ng-if=\"!story.description\">Add description</md-tooltip>\n                                                    <md-tooltip ng-if=\"story.description\">Edit description</md-tooltip>\n                                                    <md-icon class=\"small-icon\" ng-class=\"{grey: !story.description, blue: story.description, visible: $scope.options || story.description || $scope.editing, invisible: !$scope.options && !story.description && !$scope.editing}\">description</md-icon>\n                                                </md-button>\n                                            </div>\n                                            <div layout=\"row\" flex>\n                                                <span class=\"baseline\">#{{story.order}}</span>\n                                                &nbsp\n                                                <input autosize type=\"text\" ng-model=\"story.role\" ng-change=\"$ctrl.changeAttribute(story, \'role\');\" class=\"disguised baseline\">\n\n                                                &nbsp\n                                                <div contenteditable ng-model=\"story.name\" ng-change=\"$ctrl.changeAttribute(story, \'name\')\" class=\"disguised baseline\" flex></div>\n                                                <delivery-input ng-model=\"story.delivery\" ng-change=\"story.delivery = $delivery; $ctrl.changeAttribute(story, \'delivery\')\" ng-show=\"$scope.options || $scope.editing || $ctrl.requestData.ordering === \'role\'\"></delivery-input>\n                                            </div>\n\n                                            <md-menu md-position-mode=\"target-right target\" md-offset=\"0 20\" class=\"small-button left\" ng-class=\"{visible: $scope.options || $scope.editing || $mdMenuIsOpen, invisible: !$scope.options && !$scope.editing && !$mdMenuIsOpen}\">\n                                                <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                                    <md-icon class=\"small-icon\">more_vert</md-icon>\n                                                </md-button>\n                                                <md-menu-content width=\"2\" style=\"padding: 0\">\n                                                    <md-menu-item>\n                                                        <md-button class=\"md-button\" ng-click=\"story.$destroy()\">\n                                                            <md-icon class=\"small-icon\">delete</md-icon>\n                                                            Delete\n                                                        </md-button>\n                                                    </md-menu-item>\n                                                </md-menu-content>\n                                            </md-menu>\n                                        </div>\n                                        <div layout=\"row\" flex style=\"padding: 5px 16px\" ng-show=\"$scope.editing\" ng-class=\"{\'no-border\': !$scope.editing, \'light-border\': $scope.editing}\">\n                                            <div contenteditable ng-model=\"story.description\" ng-change=\"$ctrl.changeAttribute(story, \'description\')\" class=\"disguised baseline\" style=\"width: 100%\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </md-list-item>\n                            </md-list>\n                        </div>\n                    </div>\n                </md-list-item>\n            </md-list>\n        </div>\n    </div>\n    <div ng-if=\"$ctrl.currentNav == \'proposal_details\'\" style=\"padding: 20px\">\n        <div layout=\"row\" flex>\n            <md-input-container flex>\n                <label>Name</label>\n                <input type=\"text\" ng-model=\"$ctrl.proposal.name\" class=\"title-input\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.proposal.$save([\'name\'])\" style=\"margin: 0px; width: 100%\">\n            </md-input-container>\n        </div>\n        <br>\n        <div layout=\"row\" flex>\n            <md-input-container flex>\n                <label>Introduction</label>\n                <textarea ng-model=\"$ctrl.proposal.introduction\" ng-change=\"$ctrl.proposal.$save([\'introduction\'])\" style=\"width: 100%; text-align: justify\">\n                </textarea>\n            </md-input-container>\n        </div>\n    </div>\n</md-content>\n\n<div ng-if=\"$ctrl.currentNav === \'user_stories\'\">\n    <div ng-if=\"($ctrl.proposal.$stories | isEmpty)\" layout=\"column\" layout-align=\"center center\" class=\"no-stories-warning\">\n        <h1>{{$ctrl.proposal.name}} has no user stories yet</h1>\n        <div layout=\"row\" layout-align=\"center center\" layout-margin>\n            <md-icon>arrow_downward</md-icon>\n            <h3>Add the first one!</h3>\n            <md-icon>arrow_downward</md-icon>\n        </div>\n    </div>\n\n    <div cg-busy=\"$ctrl.newStory.$promise\">\n        <form layout=\"row\" layout-align=\"center center\" style=\"width: 100%; padding-top: 15px; font-size: 14px\" ng-submit=\"$ctrl.createStory()\">\n            <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\">\n                <md-autocomplete md-input-name=\"autocompleteField\" md-no-cache class=\"role-complete\" md-selected-item=\"$ctrl.newStory.role\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-clear-button=\"false\" placeholder=\"Role\" required>\n                    <md-item-template>\n                        <span md-highlight-text=\"$ctrl.searchText\">{{item}}</span>\n                    </md-item-template>\n                </md-autocomplete>\n\n                <input type=\"text\" ng-model=\"$ctrl.newStory.name\" flex placeholder=\"Add a user story to proposal {{$ctrl.proposal.name}}\" style=\"padding: 0 5px\" required>\n                <input type=\"number\" ng-model=\"$ctrl.newStory.delivery\" placeholder=\"Entrega\" style=\"width: 65px; text-align: center\" min=\"1\" required>\n                <div layout=\"column\">\n                    <md-button type=\"submit\" class=\"md-icon-button\">\n                        <md-icon>save</md-icon>\n                    </md-button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n");
$templateCache.put("app/components/projectsList/projectsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Projects</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewProjectModal()\">\n                <md-icon>add</md-icon>\n                Create Project\n            </md-button>\n        </div>\n\n        <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Search project\" ng-model=\"searchProjects\">\n        </div>\n\n        <md-list>\n            <md-list-item ui-sref=\"projectDetails({id: project.id})\" ng-repeat=\"project in $ctrl.projects | orderBy: \'name\' | fuzzyBy: \'name\' :searchProjects\">\n\n                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                    <h3 flex>{{project.name}}</h3>\n\n                    <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                        <small>ETA</small>\n                        <div ng-if=\"project.totalEta\">{{::(project.totalEta + \'\').toHHMM()}}</div>\n                        <div ng-if=\"!project.totalEta\">00:00</div>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                        <small>Completed</small>\n                        <div ng-if=\"project.totalDuration\">{{::(project.totalDuration + \'\').toHHMM()}}</div>\n                        <div ng-if=\"!project.totalDuration\">00:00</div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"end end\" class=\"small-input-column progress\">\n                        <div ng-if=\"project.totalDuration != null && project.totalEta\">\n                            {{::(project.totalDuration / project.totalEta * 100).toFixed(0)}}%\n                        </div>\n                        <div ng-if=\"!(project.totalDuration != null && project.totalEta)\">- - -</div>\n                        <md-icon>timelapse</md-icon>\n                    </div>\n                </div>\n\n            </md-list-item>\n        </md-list>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/recurrentDetails/recurrentDetails.html","<md-content>\n    <div class=\"padding\">\n	<div layout=\"row\" layout-align=\"center center\">\n            <h1 ng-if=\"$ctrl.recurrent.name\">{{$ctrl.recurrent.name}}</h1>\n	    <h1 ng-if=\"!$ctrl.recurrent.name\">Recurrent Task</h1>\n            <span flex></span>\n	</div>\n	<div>\n	    <md-input-container class=\"md-block\">\n		<label>Name</label>\n		<input type=\"text\" ng-model=\"$ctrl.recurrent.name\">\n            </md-input-container>\n\n	    <md-input-container class=\"md-block\">\n		<label>Description</label>\n		<textarea ng-model=\"$ctrl.recurrent.description\"></textarea>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\">\n		<label>Project</label>\n		<md-select ng-model=\"$ctrl.recurrent.project\">\n                    <md-option ng-repeat=\"project in $ctrl.projects\" ng-value=\"project.id\">\n			{{project.name}}\n                    </md-option>\n		</md-select>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\">\n		<label>Recurrence</label>\n		<md-select ng-model=\"$ctrl.recurrent.recurrence\">\n                    <md-option value=\"WORKDAILY\">\n			Working Days\n                    </md-option>\n                    <md-option value=\"DAILY\">\n			Daily\n                    </md-option>\n                    <md-option value=\"WEEKLY\">\n			Weekly\n                    </md-option>\n                    <md-option value=\"MONTHLY\">\n			Monthly\n                    </md-option>\n		    <md-option value=\"ONDAY\">\n			On Day\n                    </md-option>\n		</md-select>\n            </md-input-container>\n\n	    <md-input-container class=\"md-block\" ng-if=\"$ctrl.recurrent.recurrence === \'ONDAY\'\">\n		<label>Day</label>\n		<md-select ng-model=\"$ctrl.recurrent.day\">\n		    <md-option value=\"{{day}}\" ng-repeat=\"day in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]\">{{day}}</md-option>\n		</md-select>\n            </md-input-container>\n\n	    <div layout=\"row\" layout-align=\"center center\">\n		<md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.recurrent.$save()\">Update Recurrent Task</md-button>\n            </div>\n\n	</div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/recurrentList/recurrentList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Recurrent Tasks</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewRecurrentModal()\">\n                <md-icon>add</md-icon>\n                Create Recurrent Task\n            </md-button>\n        </div>\n\n	<div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Search recurrent\" ng-model=\"searchRecurrent\">\n        </div>\n\n\n        <md-list>\n            <md-list-item ng-repeat=\"recurrent in $ctrl.recurrents | fuzzyBy: \'name\' :searchRecurrent\" ui-sref=\"recurrentDetails({id: recurrent.id})\">\n\n                <div layout=\"row\" style=\"width: 95%\" layout-align=\"start center\">\n                    <h3 flex=\"50\">{{recurrent.name | limitTo: 50}}</h3>\n                    <p flex=\"30\">{{recurrent.$project.name}}</p>\n\n                    <div flex=\"10\" layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                        {{recurrent.recurrence}} {{recurrent.day}}\n                    </div>\n\n                    <div flex=\"10\" layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                        <md-icon ng-if=\"recurrent.notify\">email_alert</md-icon>\n                    </div>\n                </div>\n\n            </md-list-item>\n        </md-list>\n\n    </div>\n</md-content>\n");
$templateCache.put("app/components/reportsView/reportsView.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\" cg-busy=\"$ctrl.reports.$promise\">\n        <div layout=\"row\" layout-align=\"start center\">\n            <h1 flex>Weekly Reports\n                <small>{{$ctrl.year}}</small>\n            </h1>\n\n            <md-button class=\"tab-btn\" ui-sref=\"reports({year: 2017})\" ng-class=\"{\'active\': $ctrl.year == 2017}\">\n                2017\n            </md-button>\n            <md-button class=\"tab-btn\" ui-sref=\"reports({year: 2018})\" ng-class=\"{\'active\': $ctrl.year == 2018}\">\n                2018\n            </md-button>\n	    <md-button class=\"tab-btn\" ui-sref=\"reports({year: 2019})\" ng-class=\"{\'active\': $ctrl.year == 2019}\">\n                2019\n            </md-button>\n	    <md-button class=\"tab-btn\" ui-sref=\"reports({year: 2020})\" ng-class=\"{\'active\': $ctrl.year == 2020}\">\n                2020\n            </md-button>\n        </div>\n        <br> <br> <br>\n\n        <div ng-repeat=\"(week, reports) in $ctrl.reports | groupBy: \'week\'\" class=\"week-view\">\n            <h2 class=\"text-fade\">\n                Week {{week}}\n                <md-button class=\"md-accent\" ng-click=\"$ctrl.generateReport(week)\">Generate report</md-button>\n            </h2>\n\n            <md-list class=\"reports-list\">\n                <md-list-item ng-repeat=\"report in reports\">\n                    <p flex layout=\"row\" layout-align=\"start center\">\n                        <user-badge user=\"report.$user\"></user-badge>\n                        <span class=\"text-fade\" style=\"padding-left: 5px; opacity: 0.4\">(v{{report.version}})</span>\n                    </p>\n                    <div class=\"text-fade\" style=\"margin-right: 5px\">\n                        {{::(report.totalDuration + \'\').toHhMmSSs()}}\n                    </div>\n                    <small class=\"text-fade\" style=\"margin-right: 20px\">\n                        <span ng-if=\"report.totalEta && report.totalDuration\">\n                            ( {{(report.totalDuration / report.totalEta * 100 + \'\').toFixed(0)}} % )\n                        </span> <span>\n                            ( - - - )\n                        </span>\n                    </small>\n                    <a href=\"mailto:team@solo.com.pt?subject=Weekly Report #{{week}}&body=Aqui vai o meu report da semana {{week}}: {{report.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\" ng-if=\"report.user==$root.me.id\">\n                        <md-icon>mail</md-icon>\n                    </a>\n                    <a href=\"#\" class=\"md-button md-icon-button\" ng-if=\"report.user!=$root.me.id\" disabled=\"disabled\" style=\"opacity: 0.2\">\n                        <md-icon>mail</md-icon>\n                    </a> <a href=\"{{report.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\">\n                    <md-icon>file_download</md-icon>\n                </a>\n                </md-list-item>\n            </md-list>\n        </div>\n\n        <div ng-if=\"($ctrl.reports | filter: {week: $ctrl.currentWeek -1}) | isEmpty\" class=\"week-view\">\n            <h2 class=\"text-fade\">\n                Week {{$ctrl.currentWeek -1}}\n                <md-button class=\"md-accent\" ng-click=\"$ctrl.generateReport($ctrl.currentWeek -1)\">Generate report\n                </md-button>\n            </h2>\n        </div>\n\n\n    </div>\n</md-content>\n");
$templateCache.put("app/components/statisticDetails/statisticDetails.html","<md-content flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <div flex>\n                <h1>{{$ctrl.statistics[0].project.name}} Statistics</h1>\n            </div>\n            <md-button class=\"md-raised md-accent\" ui-sref=\"projectDetails({id: $ctrl.statistics[0].project.id})\">\n                <md-icon>work</md-icon>\n                {{$ctrl.statistics[0].project.name}}\n            </md-button>\n        </div>\n\n        <br> <br> <br>\n        <div layout=\"row\" layout-align=\"center center\">\n            <span flex></span>\n            <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n                <div layout=\"row\" layout-xs=\"column\">\n                    <md-input-container class=\"small-input-column\" layout=\"row\" layout-align=\"center center\">\n                        <label>Started after</label>\n                        <input type=\"datetime-local\" flex ng-model=\"$ctrl.startDate\">\n                    </md-input-container>\n                    <md-input-container class=\"small-input-column\" layout=\"row\" layout-align=\"center center\">\n                        <label>Ended before</label>\n                        <input type=\"datetime-local\" flex ng-model=\"$ctrl.endDate\">\n                    </md-input-container>\n                </div>\n                <div layout=\"column\" layout-align=\"center center\">\n                    <md-button class=\"md-button\" aria-label=\"Filter\" ng-click=\"$ctrl.filter()\">\n                        <md-icon>filter_list</md-icon>\n                        <label>Filter</label>\n                    </md-button>\n                </div>\n            </div>\n        </div>\n        <br> <br>\n\n        <div ng-if=\"$ctrl.statistics[0].workingDuration\">\n            <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                <h2 flex>Team Total</h2>\n\n                <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                    <small>Duration</small>\n                    <div ng-if=\"$ctrl.statistics[0].workingDuration\">{{::($ctrl.statistics[0].workingDuration + \'\').toHhMmSSs()}}</div>\n                    <div ng-if=\"!$ctrl.statistics[0].workingDuration\">00:00</div>\n                </div>\n            </div>\n            <hr style=\"opacity:0.3\">\n            <project-statistic statistic=\"$ctrl.statistics[0]\"></project-statistic>\n        </div>\n    </div>\n</md-content>\n\n<div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n    <h3 flex>{{statistic.project.name}}</h3>\n\n    <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n        <small>Duration</small>\n        <div ng-if=\"statistic.workingDuration\">{{::(statistic.workingDuration + \'\').toHhMmSSs()}}</div>\n        <div ng-if=\"!statistic.workingDuration\">00:00</div>\n    </div>\n</div>\n");
$templateCache.put("app/components/statisticsList/statisticsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Statistics</h1>\n            <span flex></span>\n        </div>\n\n        <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Search project\" ng-model=\"$ctrl.searchProjects\">\n            <div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                <label>Start date</label>\n                <input type=\"date\" placeholder=\"Start date\" ng-model=\"$ctrl.startDate\" ng-change=\"$ctrl.updateStatistics()\">\n            </div>\n            <div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                <label>End date</label>\n                <input type=\"date\" placeholder=\"End date\" ng-model=\"$ctrl.endDate\" ng-change=\"$ctrl.updateStatistics()\">\n            </div>\n            <md-input-container layout=\"column\" layout-align=\"center center\">\n                <label>Group by</label>\n                <md-select ng-model=\"$ctrl.groupBy\" ng-change=\"$ctrl.updateStatistics()\">\n                    <md-option ng-repeat=\"group in $ctrl.groups\" value=\"{{group.id}}\">{{group.name}}</md-option>\n                </md-select>\n            </md-input-container>\n        </div>\n\n\n        <div layout=\"column\">\n            <div ng-if=\"$ctrl.groupBy==\'PROJECT\'\" ng-repeat=\"statistic in $ctrl.statistics | orderBy: \'project.name\' | fuzzyBy: \'project.name\' :$ctrl.searchProjects\" ng-if=\"statistic.workingDuration > 0\">\n                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                    <h3 flex>{{statistic.project.name}}</h3>\n\n                    <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n                        <small>Duration</small>\n                        <div ng-if=\"statistic.workingDuration\">{{::(statistic.workingDuration + \'\').toHhMmSSs()}}</div>\n                        <div ng-if=\"!statistic.workingDuration\">00:00</div>\n                    </div>\n                </div>\n                <project-statistic statistic=\"statistic\"></project-statistic>\n            </div>\n            <div ng-if=\"$ctrl.groupBy==\'USER\'\" ng-repeat=\"statistic in $ctrl.statistics | orderBy: \'user.name\'\" ng-if=\"statistic.workingDuration > 0\">\n                <user-statistic statistic=\"statistic\" search-content=\"$ctrl.searchProjects\"></user-statistic>\n            </div>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/taskHeadline/taskHeadline.html","<div layout=\"column\">\n    <div class=\"task-headline\" layout=\"row\" layout-align=\"start center\" layout-margin ng-class=\"{\'closed\': $ctrl.task.state == \'CLOSED\'}\">\n\n        <div contenteditable ng-model=\"$ctrl.task.name\" class=\"task-name single-line\" ng-change=\"$ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\"></div>\n\n        <div ng-if=\"$ctrl.task.description\" style=\"opacity: 0.3; width: 16px; margin: 0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has a description\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">description</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.commentsCount > 0\" style=\"opacity: 0.3; width: 16px; margin: 0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has comments\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">comment</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.deliverablesCount > 0\" style=\"opacity: 0.6; width: 16px; margin:0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has deliverables\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">link</md-icon>\n        </div>\n\n\n        <project-selector ng-model=\"$ctrl.task.project\" ng-change=\"$ctrl.task.project = $project; $ctrl.task.$save()\"></project-selector>\n\n\n        <md-button class=\"md-icon-button md-accent start-working-btn working-btn\" ng-click=\"$ctrl.startWorking()\" ng-if=\"$ctrl.task.user == $root.me.id && $ctrl.task.state != \'EXECUTING\'\">\n            <md-icon>play_circle_filled</md-icon>\n        </md-button>\n\n        <md-fab-speed-dial md-direction=\"down\" ng-init=\"isOpen = false\" md-open=\"isOpen\" class=\"md-scale stop-working-dial\" ng-if=\"$ctrl.task.state == \'EXECUTING\' && $ctrl.task.user == $root.me.id\" ng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\">\n            <md-fab-trigger>\n                <md-button class=\"md-icon-button stop-working-btn\" ng-class=\"{\'md-accent\': !isOpen}\" ng-click=\"$ctrl.stopWorking();\">\n                    <md-tooltip md-direction=\"right\" md-visible=\"isOpen\">Stop the task</md-tooltip>\n                    <md-icon ng-if=\"!isOpen\">pause_circle_filled</md-icon>\n                    <md-icon ng-if=\"isOpen\">pause</md-icon>\n                </md-button>\n            </md-fab-trigger>\n\n            <md-fab-actions>\n                <md-button aria-label=\"Stop and close\" class=\"md-fab md-mini md-raised md-primary\" ng-click=\"$ctrl.stopWorking(true)\">\n                    <md-tooltip md-direction=\"right\" md-visible=\"isOpen\">Stop and mark it as done</md-tooltip>\n                    <md-icon>stop</md-icon>\n                </md-button>\n            </md-fab-actions>\n        </md-fab-speed-dial>\n\n        <md-menu ng-if=\"$ctrl.task.state == \'EXECUTING\'\" class=\"working-time\" md-offset=\"0 50\">\n            <div ng-click=\"$mdMenu.open($event)\">\n                <timer interval=\"1000\" max-time-unit=\"\'hour\'\" start-time=\"$ctrl.task.workingSince.getTime()\">\n                    <span ng-hide=\"hours <= 0\">{{hours}}h</span> <span>{{mminutes}}m</span> <span ng-hide=\"hours > 0\">{{seconds}}s</span>\n                </timer>\n            </div>\n\n            <md-menu-content width=\"5\" style=\"min-height: 140px\">\n                <md-menu-item style=\"padding: 10px 0 20px 0\">\n                    <h3 class=\"text-center\">When did you start working?</h3>\n                </md-menu-item>\n                <md-menu-item>\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                        <mdp-date-picker mdp-placeholder=\"Start date\" ng-model=\"$ctrl.task.workingSince\" ng-change=\"$ctrl.task.$save()\">\n                        </mdp-date-picker>\n                        <mdp-time-picker mdp-placeholder=\"Start time\" ng-model=\"$ctrl.task.workingSince\" ng-change=\"$ctrl.task.$save()\">\n                        </mdp-time-picker>\n                    </div>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n\n\n        <span flex></span>\n\n\n        <md-button ng-if=\"$ctrl.task.state != \'CLOSED\'\" class=\"md-icon-button\" ng-click=\"$ctrl.closeTask()\">\n            <md-icon>check</md-icon>\n        </md-button>\n\n        <div style=\"margin-right: 10px\">\n            <span class=\"text-fade\" ng-if=\"!$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration + \'\').toHHMM()}}\n            </span>\n            <span class=\"text-fade\" ng-if=\"$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration + \'\').toHHMM()}} (Estimated {{::($ctrl.task.eta + \'\').toHHMM()}})\n            </span>\n        </div>\n\n        <div>\n            <span class=\"text-fade\" ng-if=\"$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration / $ctrl.task.eta * 100).toFixed(0)}}%\n            </span> <span class=\"text-fade\" ng-if=\"!$ctrl.task.eta\">\n                - - -\n            </span>\n            <md-icon class=\"text-fade\" hide show-gt-xs>timelapse</md-icon>\n        </div>\n\n\n        <a target=\"_blank\" ui-sref=\"taskView({id: $ctrl.task.id})\" class=\"md-button md-icon-button\">\n            <md-tooltip>Open task in a new window</md-tooltip>\n            <md-icon>open_in_new</md-icon>\n        </a>\n\n    </div>\n</div>\n");
$templateCache.put("app/components/taskPreview/taskPreview.html","<div layout=\"column\" ng-class=\"{\'open\': $ctrl.isOpen}\">\n    <div class=\"task-headline\" layout=\"row\" layout-align=\"start center\" layout-margin ng-class=\"{\'closed\': $ctrl.task.state == \'CLOSED\'}\">\n        <md-input-container ng-if=\"$ctrl.task.hasOwnProperty(\'$user\')\" class=\"task-user-select\">\n            <label>Team</label>\n            <md-select ng-model=\"$ctrl.task.user\" ng-change=\"$ctrl.task.$save()\">\n                <md-select-header>\n                    <input ng-model=\"searchTerm\" type=\"search\" class=\"md-text task-project-select-search\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 0, \'blur\': 0}, updateOnDefault: true}\">\n                </md-select-header>\n                <md-option ng-value=\"\'\'\"><span style=\"padding-left: 55px\">None</span></md-option>\n                <md-option ng-value=\"::user.id\" ng-repeat=\"user in $root.users track by user.id | fuzzyBy: \'name\' :searchTerm\">\n                    <user-badge class=\"task-user-select-user-badge\" user=\"::user\"></user-badge>\n                </md-option>\n            </md-select>\n        </md-input-container>\n        <div contenteditable ng-model=\"$ctrl.task.name\" class=\"task-name single-line\" ng-change=\"$ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\"></div>\n\n        <div ng-if=\"$ctrl.task.description && !$ctrl.displayMinimal\" ng-show=\"!$ctrl.isOpen\" style=\"opacity: 0.3; width: 16px; margin: 0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has a description\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">description</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.commentsCount == 1 && !$ctrl.displayMinimal\" ng-show=\"!$ctrl.isOpen\" style=\"opacity: 0.3; width: 16px; margin: 0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has a comment\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">comment</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.commentsCount > 1 && !$ctrl.displayMinimal\" ng-show=\"!$ctrl.isOpen\" style=\"opacity: 0.3; width: 16px; margin: 0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has comments\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">comment</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.deliverablesCount == 1 && !$ctrl.displayMinimal\" ng-show=\"!$ctrl.isOpen\" style=\"opacity: 0.6; width: 16px; margin:0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has a deliverable\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">link</md-icon>\n        </div>\n\n        <div ng-if=\"$ctrl.task.deliverablesCount > 1 && !$ctrl.displayMinimal\" ng-show=\"!$ctrl.isOpen\" style=\"opacity: 0.6; width: 16px; margin:0 auto\">\n            <md-tooltip md-direction=\"top\">\n                This task has deliverables\n            </md-tooltip>\n            <md-icon style=\"font-size: 16px; width: auto\">link</md-icon>\n        </div>\n\n\n        <project-selector ng-model=\"$ctrl.task.project\" ng-change=\"$ctrl.task.project = $project; $ctrl.task.$save()\"></project-selector>\n\n\n        <md-button class=\"md-icon-button md-accent start-working-btn working-btn\" ng-click=\"$ctrl.startWorking()\" ng-if=\"$ctrl.task.user == $root.me.id && $ctrl.task.state != \'EXECUTING\'\">\n            <md-icon>play_circle_filled</md-icon>\n        </md-button>\n\n        <md-fab-speed-dial md-direction=\"down\" ng-init=\"isOpen = false\" md-open=\"isOpen\" class=\"md-scale stop-working-dial\" ng-if=\"$ctrl.task.state == \'EXECUTING\' && $ctrl.task.user == $root.me.id\" ng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\">\n            <md-fab-trigger>\n                <md-button class=\"md-icon-button stop-working-btn\" ng-class=\"{\'md-accent\': !isOpen}\" ng-click=\"$ctrl.stopWorking();\">\n                    <md-tooltip md-direction=\"right\" md-visible=\"isOpen\">Stop the task</md-tooltip>\n                    <md-icon ng-if=\"!isOpen\">pause_circle_filled</md-icon>\n                    <md-icon ng-if=\"isOpen\">pause</md-icon>\n                </md-button>\n            </md-fab-trigger>\n\n            <md-fab-actions>\n                <md-button aria-label=\"Stop and close\" class=\"md-fab md-mini md-raised md-primary\" ng-click=\"$ctrl.stopWorking(true)\">\n                    <md-tooltip md-direction=\"right\" md-visible=\"isOpen\">Stop and mark it as done</md-tooltip>\n                    <md-icon>stop</md-icon>\n                </md-button>\n            </md-fab-actions>\n        </md-fab-speed-dial>\n\n        <md-menu ng-if=\"$ctrl.task.state == \'EXECUTING\'\" class=\"working-time\" md-offset=\"0 50\">\n            <div ng-click=\"$mdMenu.open($event)\">\n                <timer interval=\"1000\" max-time-unit=\"\'hour\'\" start-time=\"$ctrl.task.workingSince.getTime()\">\n                    <span ng-hide=\"hours <= 0\">{{hours}}h</span> <span>{{mminutes}}m</span> <span ng-hide=\"hours > 0\">{{seconds}}s</span>\n                </timer>\n            </div>\n\n            <md-menu-content width=\"5\" style=\"min-height: 140px\">\n                <md-menu-item style=\"padding: 10px 0 20px 0\">\n                    <h3 class=\"text-center\">When did you start working?</h3>\n                </md-menu-item>\n                <md-menu-item>\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                        <mdp-date-picker mdp-placeholder=\"Start date\" ng-model=\"$ctrl.task.workingSince\" ng-change=\"$ctrl.task.$save()\">\n                        </mdp-date-picker>\n                        <mdp-time-picker mdp-placeholder=\"Start time\" ng-model=\"$ctrl.task.workingSince\" ng-change=\"$ctrl.task.$save()\">\n                        </mdp-time-picker>\n                    </div>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n\n\n        <span flex></span>\n\n        <div ng-if=\"!$ctrl.displayMinimal && !$ctrl.isOpen && $ctrl.task.totalDuration\" style=\"margin-right: 10px\">\n            <span class=\"text-fade\" ng-if=\"!$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration + \'\').toHHMM()}}\n            </span>\n            <span class=\"text-fade\" ng-if=\"$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration + \'\').toHHMM()}} (Estimated {{::($ctrl.task.eta + \'\').toHHMM()}})\n            </span>\n        </div>\n\n        <div ng-if=\"!$ctrl.displayMinimal\">\n            <span class=\"text-fade\" ng-if=\"$ctrl.task.eta\">\n                {{::($ctrl.task.totalDuration / $ctrl.task.eta * 100).toFixed(0)}}%\n            </span> <span class=\"text-fade\" ng-if=\"!$ctrl.task.eta\">\n                - - -\n            </span>\n            <md-icon class=\"text-fade\" hide show-gt-xs>timelapse</md-icon>\n        </div>\n\n	<a target=\"_blank\" ui-sref=\"taskView({id: $ctrl.task.id})\" class=\"md-button md-icon-button\">\n            <md-tooltip>Open task in a new window</md-tooltip>\n            <md-icon>open_in_new</md-icon>\n        </a>\n\n        <div ng-if=\"!$ctrl.displayMinimal && $ctrl.isOpen\">\n            <div ng-if=\"!$ctrl.isWatcher()\">\n\n                <md-tooltip md-direction=\"bottom\">\n                    Watch this task\n                </md-tooltip>\n\n                <md-button class=\"md-icon-button\" ng-if=\"watcher.user !== $ctrl.$rootScope.me.id\" ng-click=\"$ctrl.task.$watchers.$create({user: $ctrl.$rootScope.me.id, task: $ctrl.task.id})\">\n\n                    <md-button class=\"md-button md-icon-button\" ng-if=\"watcher.user !== $ctrl.$rootScope.me.id\" ng-click=\"$ctrl.task.$watchers.$create({user: $ctrl.$rootScope.me.id, task: $ctrl.task.id})\">\n                        <md-icon>visibility</md-icon>\n                    </md-button>\n            </md-button></div>\n            <div ng-if=\"$ctrl.isWatcher()\">\n                <div ng-repeat=\"watcher in $ctrl.task.$watchers track by watcher.id\">\n                    <md-tooltip md-direction=\"bottom\">\n                        Stop watching this task\n                    </md-tooltip>\n                    <md-button class=\"md-icon-button\" ng-if=\"watcher.user == $ctrl.$rootScope.me.id\" ng-click=\"watcher.$destroy()\">\n                        <md-icon>visibility_off</md-icon>\n                        <md-button class=\"md-button md-icon-button\" ng-if=\"watcher.user == $ctrl.$rootScope.me.id\" ng-click=\"watcher.$destroy()\">\n                            <md-icon class=\"md-accent\">visibility_off</md-icon>\n                        </md-button>\n                </md-button></div>\n            </div>\n        </div>\n\n        <div ng-if=\"!$ctrl.displayMinimal && $ctrl.isOpen\" class=\"md-button md-icon-button\">\n            <div ng-if=\"$ctrl.task.order!=0\">\n                <md-tooltip>Pin this task</md-tooltip>\n                <img class=\"text-fade\" ng-src=\"assets/images/pin.png\" ng-click=\"$ctrl.pinTask()\">\n\n            </div>\n            <div ng-if=\"$ctrl.task.order==0\">\n                <md-tooltip>Unpin this task</md-tooltip>\n                <img class=\"\" ng-src=\"assets/images/unpin.png\" ng-click=\"$ctrl.unpinTask()\">\n            </div>\n        </div>\n\n        <a ng-if=\"!$ctrl.displayMinimal && $ctrl.isOpen\" target=\"_blank\" ui-sref=\"taskView({id: $ctrl.task.id})\" class=\"md-button md-icon-button\">\n            <md-tooltip>Open task in a new window</md-tooltip>\n            <md-icon>open_in_new</md-icon>\n        </a>\n\n        <div ng-if=\"!$ctrl.displayMinimal && $ctrl.isOpen\">\n            <md-button ng-click=\"$ctrl.isOpen = !$ctrl.isOpen\" class=\"md-button md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n    </div>\n    <div ng-if=\"$ctrl.isOpen\" ng-init=\"$ctrl.loadDetailedInfo()\" layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n        <div flex=\"50\" style=\"margin-left: 15px\">\n            <h3>Description</h3>\n            <md-input-container class=\"md-block\">\n                <label>Add a description...</label>\n                <textarea ng-model=\"$ctrl.task.description\" ng-change=\"$ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\"></textarea>\n            </md-input-container>\n\n            <h3>Comments</h3>\n            <ul class=\"comments-list\">\n                <li ng-repeat=\"comment in $ctrl.task.$comments track by comment.id\" cg-busy=\"comment.$promise\">\n                    <div ng-if=\"comment.objectId == $ctrl.task.id\">\n                        <div layout=\"row\" layout-align=\"start center\">\n                            <br><br><br>\n                            <div>\n                                <div style=\"float: left\">\n                                    <user-badge class=\"user-comments\" user=\"comment.$user\"></user-badge>\n                                </div>\n                                <span style=\"padding-left: 10px; float: right\" ng-dblclick=\"$event.stopPropagation();\"> <pre style=\"font-family: inherit; font: inherit\">{{comment.description}}</pre> </span>\n                            </div>\n                            <div layout=\"row\" layout-align=\"start center\">\n                                <md-button class=\"md-icon-button\" ng-if=\"$ctrl.task.user == $ctrl.$rootScope.me.id || comment.user == $ctrl.$rootScope.me.id\" ng-click=\"comment.$destroy().$then($ctrl.task.$save())\">\n                                    <md-icon>delete</md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <form ng-submit=\"$ctrl.task.$comments.$create({description: newComment, objectType: \'TASK\', objectId: $ctrl.task.id}).$load(\'user\'); newComment = \'\'; $ctrl.task.$save()\" layout=\"row\" layout-align=\"start center\">\n                <img ng-src=\"{{$ctrl.$rootScope.me.avatar | mediaUrl}}\" style=\"max-width: 40px; max-height: 40px\" class=\"avatar\">\n                <md-input-container flex>\n                    <label>Add a comment...</label>\n                    <textarea ng-model=\"newComment\" ng-dblclick=\"$event.stopPropagation();\"></textarea>\n                </md-input-container>\n                <md-button type=\"submit\" class=\"md-icon-button md-accent md-raised\">\n                    <md-icon>send</md-icon>\n                </md-button>\n            </form>\n\n\n            <h3>Deliverables</h3>\n            <ul class=\"deliverables-list\">\n                <li ng-repeat=\"deliverable in $ctrl.task.$deliverables track by deliverable.id\" cg-busy=\"deliverable.$promise\">\n                    <div layout=\"row\" layout-align=\"start center\">\n                        <md-button class=\"md-icon-button\" ng-click=\"deliverable.$destroy().$then($ctrl.task.$save())\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                        <a target=\"_blank\" href=\"{{::deliverable.link}}\"> {{::deliverable.link | truncate: 60:\n                            \'...\'}} </a>\n                    </div>\n                </li>\n            </ul>\n            <form ng-submit=\"$ctrl.task.$deliverables.$create({link: newDeliverable, task: $ctrl.task.id}); newDeliverable = \'\'; $ctrl.task.$save()\" layout=\"row\" layout-align=\"start center\">\n                <md-input-container flex>\n                    <label>Add a deliverable</label>\n                    <input type=\"text\" ng-model=\"newDeliverable\" ng-dblclick=\"$event.stopPropagation();\">\n                </md-input-container>\n                <md-button type=\"submit\" class=\"md-icon-button md-accent md-raised\">\n                    <md-icon>add</md-icon>\n                </md-button>\n            </form>\n        </div>\n        <div flex=\"50\" layout=\"column\" layout-align=\"start stretch\" class=\"task-executions\">\n\n            <div layout=\"row\" layout-align=\"space-around center\">\n\n                <div class=\"small-input-column\" layout=\"column\" layout-align=\"center center\">\n                    <small>Estimated</small>\n                    <input-duration ng-model=\"$ctrl.task.eta\" ng-change=\"$ctrl.task.eta = value; $ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\"></input-duration>\n                </div>\n\n                <div class=\"small-input-column\" layout=\"column\" layout-align=\"center center\">\n                    <small>Completed</small>\n                    <div>\n                        <span>{{::($ctrl.task.totalDuration + \'\').toHHMM()}}</span>\n                    </div>\n\n                    <md-tooltip ng-if=\"$ctrl.task.totalDuration && $ctrl.task.eta\">\n                        Completed {{::($ctrl.task.totalDuration / $ctrl.task.eta * 100).toFixed(0)}}%\n                    </md-tooltip>\n                </div>\n\n                <md-input-container class=\"small-input-column\" layout=\"row\" layout-align=\"center center\">\n                    <label>Due date</label>\n                    <input type=\"datetime-local\" ng-model=\"$ctrl.task.dueDate\" ng-change=\"$ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\">\n                </md-input-container>\n\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div class=\"small-input-column\" layout=\"column\" layout-align=\"center center\">\n                    <small>Billable Rate</small>\n                    <input type=\"number\" ng-model=\"$ctrl.task.billableRate\" ng-change=\"$ctrl.task.$save()\" ng-dblclick=\"$event.stopPropagation();\" style=\"width: 50px; text-align: center; border: 0; background-color: transparent\" placeholder=\"---\">\n                </div>\n            </div>\n\n            <!--<div flex=\"40\" layout=\"column\" layout-align=\"start stretch\" class=\"task-executions\">\n                    <md-input-container class=\"small-input-column\" layout=\"row\" layout-align=\"center center\">\n                        <label>Due date</label>\n                        <input type=\"datetime-local\" ng-model=\"$ctrl.task.dueDate\" ng-change=\"$ctrl.task.$save()\"\n                               ng-dblclick=\"$event.stopPropagation();\">\n                    </md-input-container>\n            </div>-->\n            <span flex></span>\n            <div class=\"task-details-executions\">\n                <md-list>\n                    <md-list-item ng-repeat=\"execution in $ctrl.task.$executions track by execution.id\" layout-align=\"center center\">\n                        <execution-preview execution=\"execution\" ng-dblclick=\"$event.stopPropagation();\" flex></execution-preview>\n                    </md-list-item>\n                </md-list>\n            </div>\n            <span flex></span>\n            <div layout=\"row\" layout-align=\"end\" class=\"bottom-options\">\n                <md-button ng-click=\"$ctrl.displayNewExecutionModal()\">\n                    <md-icon>add</md-icon>\n                    New Execution\n                </md-button>\n                <md-button ng-if=\"$ctrl.task.state != \'CLOSED\'\" ng-click=\"$ctrl.closeTask()\">\n                    <md-icon>check</md-icon>\n                    Mark as done\n                </md-button>\n                <md-button class=\"md-warn\" ng-click=\"$ctrl.task.$destroy();\">\n                    <md-icon>delete</md-icon>\n                    Delete Task\n                </md-button>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/taskView/taskView.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n        <task-preview task=\"$ctrl.task\" is-open=\"true\"></task-preview>\n    </div>\n</md-content>\n\n\n\n\n\n\n\n\n\n\n\n\n\n");
$templateCache.put("app/components/teamWorkingStatus/teamWorkingStatus.html","<div ng-repeat=\"user in $ctrl.team | orderBy: \'name\'\" layout=\"row\" ui-sref=\"userProfile({id: user.id})\" ui-sref-active=\"active\" layout-align=\"center center\" layout-margin ng-class=\"{\'working\': user.$lastTask.state == \'EXECUTING\', \'paused\': (user.$lastTask.state != \'EXECUTING\' && user.$lastTask.stoppedSinceDuration >= 0 && user.$lastTask.stoppedSinceDuration <= (15 * 60)), \'stopped\': user.$lastTask.stoppedSinceDuration > (15 * 60)}\" class=\"menu-item\">\n    <div class=\"avatar-status bg-cover\" style=\"background-image: url(\'{{user.avatar | mediaUrl}}\')\">\n    </div>\n    <div flex layout=\"column\">\n        <small ng-if=\"user.$lastTask && user.$lastTask.state == \'EXECUTING\'\" class=\"user-task\">{{user.$lastTask.name}}</small>\n        <small class=\"user-task\" ng-if=\"(user.$lastTask.state != \'EXECUTING\' && user.$lastTask.stoppedSinceDuration >= 0 && user.$lastTask.stoppedSinceDuration <= (15 * 60))\">\n            Taking a break since\n            <translate am-time-ago=\"user.$lastTask.stoppedSince\"></translate>\n        </small>\n        <small class=\"user-task\" ng-if=\"user.$lastTask.stoppedSinceDuration > (15 * 60)\">\n            Away since\n            <translate am-time-ago=\"user.$lastTask.stoppedSince\"></translate>\n        </small>\n        <b ng-if=\"user.$lastTask.state == \'EXECUTING\'\">{{user.$lastTask.$project.name}}</b>\n    </div>\n    <div class=\"user-time\">\n        <small ng-if=\"user.$lastTask.state == \'EXECUTING\'\">\n            <timer interval=\"1000\" max-time-unit=\"\'hour\'\" start-time=\"user.$lastTask.workingSince.getTime()\">\n                <span ng-hide=\"hours <= 0\">{{hours}}h</span>\n                <span>{{minutes}}m</span>\n                <span ng-hide=\"hours > 0\">{{sseconds}}s</span>\n            </timer>\n        </small>\n    </div>\n</div>\n\n");
$templateCache.put("app/components/userBadge/userBadge.html","<div layout=\"row\" layout-align=\"start center\">\n    <img ng-src=\"{{$ctrl.user.avatar | mediaUrl}}\" class=\"avatar\" ng-if=\"!$ctrl.imgSize\">\n    <img ng-src=\"{{$ctrl.user.avatar | mediaUrl}}\" class=\"avatar\" style=\"max-width: {{$ctrl.imgSize}}px; max-height: {{$ctrl.imgSize}}px\" ng-if=\"$ctrl.imgSize\">\n    <h1>{{$ctrl.user.name}}</h1>\n</div>\n");
$templateCache.put("app/components/userHistory/userHistory.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <user-badge user=\"::$ctrl.user\" imgsize=\"20\"></user-badge>\n            <span flex></span>\n\n            <md-button class=\"tab-btn\" ui-sref=\"userProfile({id: $ctrl.user.id})\" ui-sref-active=\"active\">\n                Tasks\n            </md-button>\n            <md-button class=\"tab-btn\" ui-sref=\"userHistory({id: $ctrl.user.id})\" ui-sref-active=\"active\">\n                History\n            </md-button>\n        </div>\n        <br>\n        <h2 class=\"text-fade\">History</h2>\n\n\n\n        <div ng-repeat=\"(day, executions) in $ctrl.user.$executions | orderBy: \'-start\' | groupBy: \'day\' track by day\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <h3 class=\"text-fade\">{{::day | amDateFormat: \'dddd, MMMM Do YYYY\'}}</h3>\n                <small class=\"text-fade\" style=\"margin-left: 20px\">\n                    ( {{((executions | map: \'duration\' | sum) + \'\').toHhMmSSs()}} )\n                </small>\n                <span flex></span>\n            </div>\n            <md-list>\n                <md-list-item ng-repeat=\"execution in executions track by execution.id\" layout=\"row\">\n                    <execution-preview execution=\"::execution\" flex></execution-preview>\n                </md-list-item>\n            </md-list>\n        </div>\n\n        <div layout=\"row\" layout-align=\"center center\" cg-busy=\"$ctrl.user.$executions.$promise\">\n            <md-button class=\"md-accent\" ng-if=\"$ctrl.user.$executions.length < $ctrl.user.$executions.$totalCount\" ng-click=\"$ctrl.nextPage();\">\n                Load more\n            </md-button>\n        </div>\n\n    </div>\n</md-content>\n\n<div cg-busy=\"$ctrl.newTask.$promise\">\n    <form layout=\"column\" layout-gt-xs=\"row\" style=\"width: 100%; padding-top: 15px\" ng-submit=\"$ctrl.createTask($ctrl.newTaskName, $ctrl.newTaskProject)\">\n        <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\" ng-init=\"$ctrl.newTaskProject = null\">\n            <input type=\"text\" ng-model=\"$ctrl.newTaskName\" flex placeholder=\"Task name\">\n            <project-selector ng-model=\"$ctrl.newTaskProject\"></project-selector>\n        </div>\n        <input type=\"submit\" hide>\n    </form>\n</div>\n\n");
$templateCache.put("app/components/userProfile/userProfile.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <user-badge user=\"::$ctrl.user\" imgsize=\"20\"></user-badge>\n            <span flex></span>\n\n            <md-button class=\"tab-btn\" ui-sref=\"userProfile({id: $ctrl.user.id})\" ui-sref-active=\"active\">\n                Tasks\n            </md-button>\n            <md-button class=\"tab-btn\" ui-sref=\"userHistory({id: $ctrl.user.id})\" ui-sref-active=\"active\">\n                History\n            </md-button>\n        </div>\n        <br>\n        <h2 class=\"text-fade\">Upcoming</h2>\n\n\n        <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Filter tasks\" ng-model=\"searchTasks\">\n            <md-select ng-model=\"searchProject\" placeholder=\"Filter by project\">\n                <md-option value=\"*\"><i class=\"text-fade\">Qualquer</i></md-option>\n                <md-option ng-repeat=\"project in $root.activeProjects\" ng-value=\"{{::project.id}}\">{{::project.name}}\n                </md-option>\n            </md-select>\n        </div>\n\n        <md-list ng-model=\"$ctrl.user.$openTasks\" cg-busy=\"$ctrl.user.$openTasks.$promise\" class=\"tasks-list\">\n\n            <md-list-item ng-repeat=\"task in $ctrl.user.$openTasks | filter: {name: searchTasks} | project: searchProject track by task.id\" id=\"task-preview-{{::task.id}}\" layout=\"row\">\n                <div layout=\"row\" style=\"width: 100%\">\n                    <task-headline task=\"task\" flex>\n                    </task-headline>\n                </div>\n            </md-list-item>\n        </md-list>\n\n    </div>\n</md-content>\n\n<div cg-busy=\"$ctrl.newTask.$promise\">\n    <form layout=\"column\" layout-gt-xs=\"row\" style=\"width: 100%; padding-top: 15px\" ng-submit=\"$ctrl.createTask($ctrl.newTaskName, $ctrl.newTaskProject)\">\n        <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\" ng-init=\"$ctrl.newTaskProject = null\">\n            <input type=\"text\" ng-model=\"$ctrl.newTaskName\" flex placeholder=\"Task name\">\n            <project-selector ng-model=\"$ctrl.newTaskProject\"></project-selector>\n        </div>\n        <input type=\"submit\" hide>\n    </form>\n</div>\n");
$templateCache.put("app/components/userStatistic/userStatistic.html","<div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n    <user-badge user=\"$ctrl.statistic.user\" flex></user-badge>\n\n    <div layout=\"column\" layout-align=\"center center\" class=\"small-input-column\">\n        <small>Duration</small>\n        <div ng-if=\"$ctrl.statistic.workingDuration\">{{::($ctrl.statistic.workingDuration + \'\').toHhMmSSs()}}</div>\n        <div ng-if=\"!$ctrl.statistic.workingDuration\">00:00</div>\n    </div>\n</div>\n<div style=\"padding: 0 30px; border-bottom: solid 1px #eee\" layout=\"column\">\n    <div ng-repeat=\"working in $ctrl.statistic.workingByProject | fuzzyBy: \'project.name\' :$ctrl.searchContent\" layout=\"row\" layout-align=\"start center\" ng-if=\"working.duration\">\n        <div class=\"working-project\" layout=\"column\" flex=\"30\"><h1>{{working.project.name}}</h1></div>\n        <span layout=\"column\" class=\"text-fade\">{{(working.duration + \'\').toHhMmSSs()}}</span>\n\n    </div>\n</div>\n");
$templateCache.put("app/shared/html/cgbusy/cgbusy.template.html","<div class=\"cg-busy-processing-wrapper\" layout=\"row\" layout-align=\"center center\">\n    <span>{{$message}}</span>\n    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div>\n\n\n<style>\n    .cg-busy-processing-wrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n</style>\n");
$templateCache.put("app/shared/html/deliveryInput/deliveryInput.html","<div layout=\"row\" layout-align=\"center center\" class=\"delivery smaller-text\" ng-click=\"$ctrl.setFocus()\">\n    <label>Entrega </label>\n    <input type=\"number\" ng-model=\"$ctrl.ngModel\" ng-change=\"$ctrl.changed()\" aria-label=\"Delivery\" class=\"smaller-text\" step=\"1\" min=\"1\">\n</div>\n");
$templateCache.put("app/shared/html/menuBtn/menuBtn.html","<md-button class=\"md-icon-button\" ng-click=\"$ctrl.openMenu()\">\n    <md-icon>menu</md-icon>\n</md-button>\n");
$templateCache.put("app/components/auth/views/auth.forgot.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recover password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n        <md-card>\n            <md-card-content class=\"auth-wrapper\">\n                <md-input-container class=\"general-login-error\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <p class=\"text-fade\">\n                    <small>Enter your email and we\'ll send you instructions to recover your password.</small>\n                </p>\n                <form ng-submit=\"vm.requestChange();\" cg-busy=\"vm.requestStatus\" ng-hide=\"vm.requestStatus.$$state.value.status==200\">\n                    <md-input-container class=\"md-block\" flex-gt-sm>\n                        <label>Email</label> <input ng-model=\"vm.email\" type=\"email\">\n                        <div ng-messages>\n                            <div ng-if=\"vm.requestStatus.$$state.value.data.detail\">\n                                {{vm.requestStatus.$$state.value.data.detail}}\n                            </div>\n                            <div ng-repeat=\"message in vm.requestStatus.$$state.value.data.email\" ng-if=\"vm.requestStatus.$$state.value.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\" layout-align=\"end center\">\n                        <md-button class=\"no-margin md-raised md-accent\" type=\"submit\" ng-disabled=\"!vm.email\"><span>Recover password</span>\n                        </md-button>\n                    </div>\n                    <p class=\"text-justify text-xs text-second text-fade\">\n                        <small>\n                            If you don\'t receive an email within the next 2 minutes, please check the spam.\n                        </small>\n                    </p>\n\n                </form>\n\n                <div ng-if=\"vm.requestStatus.$$state.value.status==200\" layout=\"column\" layout-padding=\"\" layout-align=\"center center\" style=\"border: solid rgba(150, 255, 150, 0.6) 2px; background-color: rgba(150, 255, 150, 0.2)\">\n                    <md-icon>email_outline</md-icon>\n                    <p style=\"text-align: center\">\n                        A link has been sent to your email to change your password <br>\n                    </p>\n                </div>\n            </md-card-content>\n        </md-card>\n\n    </md-content>\n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n</div>\n");
$templateCache.put("app/components/auth/views/auth.login.view.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n    <h1 style=\"font-size: 70px; font-weight: 300; opacity: 0.7; letter-spacing: 1px; text-transform: uppercase\">Taskatone</h1>\n\n    <md-card>\n        <md-card-content class=\"auth-wrapper\">\n            <br>\n            <form ng-submit=\"vm.login();\" style=\"min-width: 400px\">\n                <md-input-container class=\"general-login-error no-margin\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages class=\"text-center\">\n                        <small ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </small>\n                    </div>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Email</label>\n                    <input type=\"email\" ng-model=\"vm.email\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.email\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Password</label>\n                    <input type=\"password\" ng-model=\"vm.password\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.password\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <div layout=\"column\" layout-align=\"center center\">\n                    <input type=\"submit\" value=\"Log in\" class=\"md-button md-raised md-accent\">\n                    <a ui-sref=\"forgot\"><small>Forgot your password?</small></a>\n                </div>\n            </form>\n        </md-card-content>\n    </md-card>\n\n    <div style=\"font-size: 11px\" class=\"text-center\">\n        <span>Need an account?</span>&nbsp<a ui-sref=\"register\">Sign up.</a>\n    </div>\n\n</md-content>\n\n");
$templateCache.put("app/components/auth/views/auth.register.view.html","<div layout=\"column\" flex>\n    <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                    <md-icon>arrow_back</md-icon>\n                </md-button>\n                <span>Create account</span>\n            </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n        <md-card>\n            <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                <h1 align=\"center\">Create account</h1>\n                <br>\n                <div ng-if=\"vm.registering\">\n                    <form ng-submit=\"vm.register();\">\n                        <md-input-container class=\"general-login-error\" ng-if=\"vm.user.$response.data.non_field_errors\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.data.non_field_errors\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Name</label>\n                            <input type=\"text\" ng-model=\"vm.user.name\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Email</label>\n                            <input ng-model=\"vm.user.email\" type=\"email\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"vm.user.password\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.user.confirmPassword\">\n                        </md-input-container>\n\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <md-button type=\"submit\" class=\"md-button md-raised md-accent\"><span>Create account</span></md-button>\n                        </div>\n\n                    </form>\n                </div>\n                <div ng-if=\"!vm.registering\" cg-busy=\"vm.resendStatus.promise\">\n                    <br>\n                    <p class=\"text-sm\">\n                        <span ng-if=\"!vm.resent\">We sent an email</span>\n                        <span ng-if=\"vm.resent\">We resend the email</span>\n                        <span>to <b>{{vm.user.email}}</b>, with instructions to activate your account.</span>\n                    </p>\n\n                    <p class=\"text-sm\" ng-if=\"!vm.resent\">\n                        This check protects your account.\n                    </p>\n\n                    <p class=\"text-sm\">\n                        If you don\'t receive an email within the next two minutes, please check your spam.\n                    </p>\n\n                    <div layout=\"row\" layout-align=\"end\" ng-if=\"!vm.resent\">\n                        <md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.resend();\">\n                            <span>Resend email</span>\n                        </md-button>\n                    </div>\n                </div>\n            </md-card-content>\n        </md-card>\n    </md-content>\n</div>\n\n\n");
$templateCache.put("app/components/auth/views/auth.set.password.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recover password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n        <md-card>\n            <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                <h1 align=\"center\">Recover password</h1>\n                <br>\n                    <form ng-submit=\"vm.setPassword();\" cg-busy=\"vm.requestStatus\">\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>New password</label> <input type=\"password\" ng-model=\"vm.password\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.confirmPassword\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <div layout=\"row\" layout-align=\"end end\">\n                            <md-tooltip ng-if=\"vm.password != vm.confirmPassword\">\n                                <span>Please check that both passwords matches</span>\n                            </md-tooltip>\n                            <md-button class=\"no-margin\" type=\"submit\" ng-disabled=\"(vm.password != vm.confirmPassword) || !vm.password\">\n                                <span class=\"md-button md-raised md-accent\">Change password</span>\n                            </md-button>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </md-content></div>\n    \n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n\n");
$templateCache.put("app/components/users/editProfile/editProfile.html","<md-content>\n    <div class=\"\" layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n\n\n        <md-card flex=\"50\">\n            <md-card-content cg-busy=\"$ctrl.user.$promise\">\n                <form ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n                    <h1 class=\"text-center text-fade\">Personal information</h1>\n                    <br> <br>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div id=\"change-avatar-area\" layout=\"row\" layout-align=\"center center\" style=\"background-image: url(\'{{$ctrl.user.avatar | mediaUrl}}\')\">\n                            <div class=\"change-avatar-btn\" layout=\"row\" layout-align=\"center center\" ngf-select media-auto-upload ng-model=\"$ctrl.user.avatar\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-resize=\"{ratio: \'1:1\', centerCrop: true}\" ngf-max-size=\"2MB\" accept=\"image/*\">\n                                <span>Change avatar</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Name</label>\n                        <input type=\"text\" ng-model=\"$ctrl.user.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.name\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Email</label> <input type=\"email\" ng-model=\"$ctrl.user.email\" disabled=\"disabled\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                </form>\n            </md-card-content>\n        </md-card>\n        <br> <br>\n        <div flex=\"50\">\n            <md-card>\n                <md-card-content>\n                    <form ng-submit=\"$ctrl.changePass()\">\n                        <h1 class=\"text-center text-fade\">Change password</h1>\n                        <br> <br>\n                        <md-input-container class=\"md-block\">\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.password\" minlength=\"3\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.confirm_password\">\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"center\">\n                            <input type=\"submit\" class=\"md-button md-raised md-accent\" value=\"Change\">\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/users/usersList/usersList.html","<md-content>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Team</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\">\n                <md-icon>add</md-icon>\n                Add someone to the team\n            </md-button>\n        </div>\n        <md-card>\n            <table class=\"multi-table editable\">\n                <tr>\n                    <th>&nbsp;</th>\n                    <th align=\"left\">Nome</th>\n                    <th align=\"left\">Email</th>\n                    <th>&nbsp;</th>\n                    <th>&nbsp;</th>\n                </tr>\n                <tr ng-repeat=\"member in $ctrl.members\" cg-busy=\"member.$promise\">\n                    <!-- Member saved -->\n                    <td ng-if-start=\"member.id\" class=\"minimun\" align=\"center\"><b>{{$index + 1}}</b></td>\n                    <td><b>{{member.name}}</b></td>\n                    <td>{{member.email}}</td>\n                    <td>Criado {{member.created | amCalendar}}</td>\n                    <td class=\"minimun\" ng-if-end>\n                        <md-button class=\"md-icon-button\" ng-click=\"member.$destroy()\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                    </td>\n\n                    <!-- Brand new member -->\n                    <td ng-if-start=\"!member.id\">\n                        <md-tooltip>Utilizador não salvo. Preencha as informações necessárias</md-tooltip>\n                        <md-icon class=\"md-warn\">warning</md-icon>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.name}\">\n                        <input type=\"text\" ng-model=\"member.name\" placeholder=\"Nome\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.name\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.email}\">\n                        <input type=\"email\" ng-model=\"member.email\" placeholder=\"Email\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.email\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.password}\">\n                        <input type=\"password\" ng-model=\"member.password\" placeholder=\"Password\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.password\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td class=\"minimun\" ng-if-end>\n                        <md-button class=\"md-icon-button md-accent\" ng-disabled=\"!member.name || !member.email\" ng-click=\"member.$save()\">\n                            <md-icon>save</md-icon>\n                        </md-button>\n                    </td>\n                </tr>\n            </table>\n        </md-card>\n    </div>\n</md-content>\n");}]);
'use strict';

var cov_11jt39av3r = function () {
    var path = '/home/lobo/repos/taskatone-app/src/routes.js',
        hash = '3a01ebc7480b51f865706eb8525f4345027884b5',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/routes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 26
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 4
                },
                end: {
                    line: 8,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 4
                },
                end: {
                    line: 154,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 27,
                    column: 50
                },
                end: {
                    line: 27,
                    column: 115
                }
            },
            '5': {
                start: {
                    line: 27,
                    column: 101
                },
                end: {
                    line: 27,
                    column: 105
                }
            },
            '6': {
                start: {
                    line: 58,
                    column: 41
                },
                end: {
                    line: 60,
                    column: 55
                }
            },
            '7': {
                start: {
                    line: 60,
                    column: 38
                },
                end: {
                    line: 60,
                    column: 45
                }
            },
            '8': {
                start: {
                    line: 61,
                    column: 45
                },
                end: {
                    line: 63,
                    column: 63
                }
            },
            '9': {
                start: {
                    line: 63,
                    column: 42
                },
                end: {
                    line: 63,
                    column: 53
                }
            },
            '10': {
                start: {
                    line: 70,
                    column: 45
                },
                end: {
                    line: 70,
                    column: 107
                }
            },
            '11': {
                start: {
                    line: 70,
                    column: 89
                },
                end: {
                    line: 70,
                    column: 97
                }
            },
            '12': {
                start: {
                    line: 77,
                    column: 58
                },
                end: {
                    line: 77,
                    column: 131
                }
            },
            '13': {
                start: {
                    line: 77,
                    column: 114
                },
                end: {
                    line: 77,
                    column: 121
                }
            },
            '14': {
                start: {
                    line: 84,
                    column: 46
                },
                end: {
                    line: 84,
                    column: 111
                }
            },
            '15': {
                start: {
                    line: 84,
                    column: 91
                },
                end: {
                    line: 84,
                    column: 101
                }
            },
            '16': {
                start: {
                    line: 91,
                    column: 61
                },
                end: {
                    line: 91,
                    column: 137
                }
            },
            '17': {
                start: {
                    line: 91,
                    column: 118
                },
                end: {
                    line: 91,
                    column: 127
                }
            },
            '18': {
                start: {
                    line: 99,
                    column: 49
                },
                end: {
                    line: 99,
                    column: 117
                }
            },
            '19': {
                start: {
                    line: 99,
                    column: 97
                },
                end: {
                    line: 99,
                    column: 107
                }
            },
            '20': {
                start: {
                    line: 106,
                    column: 63
                },
                end: {
                    line: 106,
                    column: 164
                }
            },
            '21': {
                start: {
                    line: 106,
                    column: 144
                },
                end: {
                    line: 106,
                    column: 154
                }
            },
            '22': {
                start: {
                    line: 119,
                    column: 52
                },
                end: {
                    line: 119,
                    column: 116
                }
            },
            '23': {
                start: {
                    line: 119,
                    column: 102
                },
                end: {
                    line: 119,
                    column: 106
                }
            },
            '24': {
                start: {
                    line: 126,
                    column: 52
                },
                end: {
                    line: 126,
                    column: 116
                }
            },
            '25': {
                start: {
                    line: 126,
                    column: 102
                },
                end: {
                    line: 126,
                    column: 106
                }
            },
            '26': {
                start: {
                    line: 133,
                    column: 40
                },
                end: {
                    line: 133,
                    column: 86
                }
            },
            '27': {
                start: {
                    line: 134,
                    column: 49
                },
                end: {
                    line: 137,
                    column: 55
                }
            },
            '28': {
                start: {
                    line: 137,
                    column: 38
                },
                end: {
                    line: 137,
                    column: 45
                }
            },
            '29': {
                start: {
                    line: 144,
                    column: 52
                },
                end: {
                    line: 144,
                    column: 116
                }
            },
            '30': {
                start: {
                    line: 144,
                    column: 102
                },
                end: {
                    line: 144,
                    column: 106
                }
            },
            '31': {
                start: {
                    line: 151,
                    column: 58
                },
                end: {
                    line: 151,
                    column: 131
                }
            },
            '32': {
                start: {
                    line: 151,
                    column: 114
                },
                end: {
                    line: 151,
                    column: 121
                }
            },
            '33': {
                start: {
                    line: 152,
                    column: 60
                },
                end: {
                    line: 152,
                    column: 142
                }
            },
            '34': {
                start: {
                    line: 152,
                    column: 124
                },
                end: {
                    line: 152,
                    column: 132
                }
            }
        },
        fnMap: {
            '0': {
                name: 'routesConfig',
                decl: {
                    start: {
                        line: 6,
                        column: 9
                    },
                    end: {
                        line: 6,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 77
                    },
                    end: {
                        line: 157,
                        column: 1
                    }
                },
                line: 6
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 27,
                        column: 22
                    },
                    end: {
                        line: 27,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 50
                    },
                    end: {
                        line: 27,
                        column: 115
                    }
                },
                line: 27
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 27,
                        column: 91
                    },
                    end: {
                        line: 27,
                        column: 92
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 101
                    },
                    end: {
                        line: 27,
                        column: 105
                    }
                },
                line: 27
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 58,
                        column: 25
                    },
                    end: {
                        line: 58,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 41
                    },
                    end: {
                        line: 60,
                        column: 55
                    }
                },
                line: 58
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 60,
                        column: 25
                    },
                    end: {
                        line: 60,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 38
                    },
                    end: {
                        line: 60,
                        column: 45
                    }
                },
                line: 60
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 61,
                        column: 29
                    },
                    end: {
                        line: 61,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 45
                    },
                    end: {
                        line: 63,
                        column: 63
                    }
                },
                line: 61
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 63,
                        column: 25
                    },
                    end: {
                        line: 63,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 42
                    },
                    end: {
                        line: 63,
                        column: 53
                    }
                },
                line: 63
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 70,
                        column: 26
                    },
                    end: {
                        line: 70,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 45
                    },
                    end: {
                        line: 70,
                        column: 107
                    }
                },
                line: 70
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 70,
                        column: 75
                    },
                    end: {
                        line: 70,
                        column: 76
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 89
                    },
                    end: {
                        line: 70,
                        column: 97
                    }
                },
                line: 70
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 77,
                        column: 25
                    },
                    end: {
                        line: 77,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 58
                    },
                    end: {
                        line: 77,
                        column: 131
                    }
                },
                line: 77
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 77,
                        column: 101
                    },
                    end: {
                        line: 77,
                        column: 102
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 114
                    },
                    end: {
                        line: 77,
                        column: 121
                    }
                },
                line: 77
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 84,
                        column: 28
                    },
                    end: {
                        line: 84,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 84,
                        column: 46
                    },
                    end: {
                        line: 84,
                        column: 111
                    }
                },
                line: 84
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 84,
                        column: 77
                    },
                    end: {
                        line: 84,
                        column: 78
                    }
                },
                loc: {
                    start: {
                        line: 84,
                        column: 91
                    },
                    end: {
                        line: 84,
                        column: 101
                    }
                },
                line: 84
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 91,
                        column: 27
                    },
                    end: {
                        line: 91,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 91,
                        column: 61
                    },
                    end: {
                        line: 91,
                        column: 137
                    }
                },
                line: 91
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 91,
                        column: 105
                    },
                    end: {
                        line: 91,
                        column: 106
                    }
                },
                loc: {
                    start: {
                        line: 91,
                        column: 118
                    },
                    end: {
                        line: 91,
                        column: 127
                    }
                },
                line: 91
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 99,
                        column: 28
                    },
                    end: {
                        line: 99,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 99,
                        column: 49
                    },
                    end: {
                        line: 99,
                        column: 117
                    }
                },
                line: 99
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 99,
                        column: 81
                    },
                    end: {
                        line: 99,
                        column: 82
                    }
                },
                loc: {
                    start: {
                        line: 99,
                        column: 97
                    },
                    end: {
                        line: 99,
                        column: 107
                    }
                },
                line: 99
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 106,
                        column: 28
                    },
                    end: {
                        line: 106,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 106,
                        column: 63
                    },
                    end: {
                        line: 106,
                        column: 164
                    }
                },
                line: 106
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 106,
                        column: 128
                    },
                    end: {
                        line: 106,
                        column: 129
                    }
                },
                loc: {
                    start: {
                        line: 106,
                        column: 144
                    },
                    end: {
                        line: 106,
                        column: 154
                    }
                },
                line: 106
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 119,
                        column: 22
                    },
                    end: {
                        line: 119,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 119,
                        column: 52
                    },
                    end: {
                        line: 119,
                        column: 116
                    }
                },
                line: 119
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 119,
                        column: 92
                    },
                    end: {
                        line: 119,
                        column: 93
                    }
                },
                loc: {
                    start: {
                        line: 119,
                        column: 102
                    },
                    end: {
                        line: 119,
                        column: 106
                    }
                },
                line: 119
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 126,
                        column: 22
                    },
                    end: {
                        line: 126,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 52
                    },
                    end: {
                        line: 126,
                        column: 116
                    }
                },
                line: 126
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 126,
                        column: 92
                    },
                    end: {
                        line: 126,
                        column: 93
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 102
                    },
                    end: {
                        line: 126,
                        column: 106
                    }
                },
                line: 126
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 133,
                        column: 22
                    },
                    end: {
                        line: 133,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 133,
                        column: 40
                    },
                    end: {
                        line: 133,
                        column: 86
                    }
                },
                line: 133
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 134,
                        column: 25
                    },
                    end: {
                        line: 134,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 134,
                        column: 49
                    },
                    end: {
                        line: 137,
                        column: 55
                    }
                },
                line: 134
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 137,
                        column: 25
                    },
                    end: {
                        line: 137,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 137,
                        column: 38
                    },
                    end: {
                        line: 137,
                        column: 45
                    }
                },
                line: 137
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 144,
                        column: 22
                    },
                    end: {
                        line: 144,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 52
                    },
                    end: {
                        line: 144,
                        column: 116
                    }
                },
                line: 144
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 144,
                        column: 92
                    },
                    end: {
                        line: 144,
                        column: 93
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 102
                    },
                    end: {
                        line: 144,
                        column: 106
                    }
                },
                line: 144
            },
            '28': {
                name: '(anonymous_28)',
                decl: {
                    start: {
                        line: 151,
                        column: 25
                    },
                    end: {
                        line: 151,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 58
                    },
                    end: {
                        line: 151,
                        column: 131
                    }
                },
                line: 151
            },
            '29': {
                name: '(anonymous_29)',
                decl: {
                    start: {
                        line: 151,
                        column: 101
                    },
                    end: {
                        line: 151,
                        column: 102
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 114
                    },
                    end: {
                        line: 151,
                        column: 121
                    }
                },
                line: 151
            },
            '30': {
                name: '(anonymous_30)',
                decl: {
                    start: {
                        line: 152,
                        column: 26
                    },
                    end: {
                        line: 152,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 152,
                        column: 60
                    },
                    end: {
                        line: 152,
                        column: 142
                    }
                },
                line: 152
            },
            '31': {
                name: '(anonymous_31)',
                decl: {
                    start: {
                        line: 152,
                        column: 110
                    },
                    end: {
                        line: 152,
                        column: 111
                    }
                },
                loc: {
                    start: {
                        line: 152,
                        column: 124
                    },
                    end: {
                        line: 152,
                        column: 132
                    }
                },
                line: 152
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 133,
                        column: 40
                    },
                    end: {
                        line: 133,
                        column: 86
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 133,
                        column: 62
                    },
                    end: {
                        line: 133,
                        column: 79
                    }
                }, {
                    start: {
                        line: 133,
                        column: 82
                    },
                    end: {
                        line: 133,
                        column: 86
                    }
                }],
                line: 133
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_11jt39av3r.s[0]++;
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    cov_11jt39av3r.f[0]++;
    cov_11jt39av3r.s[1]++;

    $locationProvider.html5Mode(true).hashPrefix('!');
    cov_11jt39av3r.s[2]++;
    $urlRouterProvider.otherwise('/');

    cov_11jt39av3r.s[3]++;
    $stateProvider.state('login', {
        url: '/login',
        templateUrl: 'app/components/auth/views/auth.login.view.html',
        controller: 'AuthLoginController',
        controllerAs: 'vm'
    }).state('logout', {
        url: '/logout',
        template: '<div></div>',
        controller: 'AuthLogoutController',
        controllerAs: 'vm'
    }).state('profile', {
        url: '/perfil',
        template: '<edit-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["$rootScope", "UsersTable", function user($rootScope, UsersTable) {
                cov_11jt39av3r.f[1]++;
                cov_11jt39av3r.s[4]++;
                return UsersTable.$find($rootScope.me.id).$then(function (user) {
                    cov_11jt39av3r.f[2]++;
                    cov_11jt39av3r.s[5]++;
                    return user;
                }).$promise;
            }]
        }
    }).state('forgot', {
        url: '/recuperar_password',
        templateUrl: 'app/components/auth/views/auth.forgot.html',
        controller: 'AuthForgotController',
        controllerAs: 'vm'
    }).state('set_password', {
        url: '/reset_password?token=&email=',
        templateUrl: 'app/components/auth/views/auth.set.password.html',
        controller: 'AuthSetPasswordController',
        controllerAs: 'vm'
    }).state('register', {
        url: '/criar_conta',
        templateUrl: 'app/components/auth/views/auth.register.view.html',
        controller: 'AuthRegisterController',
        controllerAs: 'vm'
    }).state('activate', {
        url: '/activate?token=',
        template: '<div></div>',
        controller: 'AuthActivateController',
        controllerAs: 'vm'
    }).state('usersList', {
        url: '/utilizadores',
        template: '<users-list members="$resolve.members" accountants="$resolve.accountants" flex layout="column"/>',
        resolve: {
            members: ["UsersTable", function members(UsersTable) {
                cov_11jt39av3r.f[3]++;
                cov_11jt39av3r.s[6]++;
                return UsersTable.$search({
                    type: 'MEMBER'
                }).$then(function (members) {
                    cov_11jt39av3r.f[4]++;
                    cov_11jt39av3r.s[7]++;
                    return members;
                }).$promise;
            }],
            accountants: ["UsersTable", function accountants(UsersTable) {
                cov_11jt39av3r.f[5]++;
                cov_11jt39av3r.s[8]++;
                return UsersTable.$search({
                    type: 'ACCOUNTANT'
                }).$then(function (accountants) {
                    cov_11jt39av3r.f[6]++;
                    cov_11jt39av3r.s[9]++;
                    return accountants;
                }).$promise;
            }]
        }
    }).state('projectsList', {
        url: '/projects',
        template: '<projects-list projects="$resolve.projects" flex layout="column"/>',
        resolve: {
            projects: ["ProjectsTable", function projects(ProjectsTable) {
                cov_11jt39av3r.f[7]++;
                cov_11jt39av3r.s[10]++;
                return ProjectsTable.$search().$then(function (projects) {
                    cov_11jt39av3r.f[8]++;
                    cov_11jt39av3r.s[11]++;
                    return projects;
                }).$promise;
            }]
        }
    }).state('projectDetails', {
        url: '/project/:id',
        template: '<project-details project="$resolve.project" flex layout="column"/>',
        resolve: {
            project: ["ProjectsTable", "$stateParams", function project(ProjectsTable, $stateParams) {
                cov_11jt39av3r.f[9]++;
                cov_11jt39av3r.s[12]++;
                return ProjectsTable.$find($stateParams.id).$then(function (project) {
                    cov_11jt39av3r.f[10]++;
                    cov_11jt39av3r.s[13]++;
                    return project;
                }).$promise;
            }]
        }
    }).state('recurrentList', {
        url: '/recurrent',
        template: '<recurrent-list recurrents="$resolve.recurrents" flex layout="column"/>',
        resolve: {
            recurrents: ["RecurrentTable", function recurrents(RecurrentTable) {
                cov_11jt39av3r.f[11]++;
                cov_11jt39av3r.s[14]++;
                return RecurrentTable.$search().$then(function (recurrents) {
                    cov_11jt39av3r.f[12]++;
                    cov_11jt39av3r.s[15]++;
                    return recurrents;
                }).$promise;
            }]
        }
    }).state('recurrentDetails', {
        url: '/recurrent/:id',
        template: '<recurrent-details recurrent="$resolve.recurrent" flex layout="column"/>',
        resolve: {
            recurrent: ["RecurrentTable", "$stateParams", function recurrent(RecurrentTable, $stateParams) {
                cov_11jt39av3r.f[13]++;
                cov_11jt39av3r.s[16]++;
                return RecurrentTable.$find($stateParams.id).$then(function (recurrent) {
                    cov_11jt39av3r.f[14]++;
                    cov_11jt39av3r.s[17]++;
                    return recurrent;
                }).$promise;
            }]
        }
    }).state('statisticsList', {
        url: '/statistics',
        template: '<statistics-list statistics="$resolve.statistics" flex layout="column"/>',
        resolve: {
            statistics: ["StatisticsTable", function statistics(StatisticsTable) {
                cov_11jt39av3r.f[15]++;
                cov_11jt39av3r.s[18]++;
                return StatisticsTable.$search().$then(function (statistics) {
                    cov_11jt39av3r.f[16]++;
                    cov_11jt39av3r.s[19]++;
                    return statistics;
                }).$promise;
            }]
        }
    }).state('statisticDetails', {
        url: '/statistic/:project',
        template: '<statistic-details statistics="$resolve.statistics" flex layout="column"/>',
        resolve: {
            statistics: ["StatisticsTable", "$stateParams", function statistics(StatisticsTable, $stateParams) {
                cov_11jt39av3r.f[17]++;
                cov_11jt39av3r.s[20]++;
                return StatisticsTable.$search({ 'project': $stateParams.project }).$then(function (statistics) {
                    cov_11jt39av3r.f[18]++;
                    cov_11jt39av3r.s[21]++;
                    return statistics;
                }).$promise;
            }]
        }
    }).state('dashboard', {
        url: '/',
        controller: 'DashboardController',
        controllerAs: 'vm',
        template: '<div></div>'
    }).state('userProfile', {
        url: '/user/:id',
        template: '<user-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["UsersTable", "$stateParams", function user(UsersTable, $stateParams) {
                cov_11jt39av3r.f[19]++;
                cov_11jt39av3r.s[22]++;
                return UsersTable.$find($stateParams.id).$then(function (user) {
                    cov_11jt39av3r.f[20]++;
                    cov_11jt39av3r.s[23]++;
                    return user;
                }).$promise;
            }]
        }
    }).state('userHistory', {
        url: '/user/history/:id',
        template: '<user-history user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["UsersTable", "$stateParams", function user(UsersTable, $stateParams) {
                cov_11jt39av3r.f[21]++;
                cov_11jt39av3r.s[24]++;
                return UsersTable.$find($stateParams.id).$then(function (user) {
                    cov_11jt39av3r.f[22]++;
                    cov_11jt39av3r.s[25]++;
                    return user;
                }).$promise;
            }]
        }
    }).state('reports', {
        url: '/reports/:year',
        template: '<reports-view reports="$resolve.reports" year="$resolve.year"/>',
        resolve: {
            year: ["$stateParams", function year($stateParams) {
                cov_11jt39av3r.f[23]++;
                cov_11jt39av3r.s[26]++;
                return $stateParams.year ? (cov_11jt39av3r.b[0][0]++, $stateParams.year) : (cov_11jt39av3r.b[0][1]++, 2020);
            }],
            reports: ["ReportsTable", "year", function reports(ReportsTable, year) {
                cov_11jt39av3r.f[24]++;
                cov_11jt39av3r.s[27]++;
                return ReportsTable.$search({
                    'is_deleted': '0',
                    year: year
                }).$then(function (reports) {
                    cov_11jt39av3r.f[25]++;
                    cov_11jt39av3r.s[28]++;
                    return reports;
                }).$promise;
            }]
        }
    }).state('taskView', {
        url: '/task/:id',
        template: '<task-view task="$resolve.task"/>',
        resolve: {
            task: ["TasksTable", "$stateParams", function task(TasksTable, $stateParams) {
                cov_11jt39av3r.f[26]++;
                cov_11jt39av3r.s[29]++;
                return TasksTable.$find($stateParams.id).$then(function (task) {
                    cov_11jt39av3r.f[27]++;
                    cov_11jt39av3r.s[30]++;
                    return task;
                }).$promise;
            }]
        }
    }).state('projectStories', {
        url: '/project/:id/:proposal',
        template: '<project-stories project="$resolve.project" proposal="$resolve.proposal" flex layout="column"/>',
        resolve: {
            project: ["ProjectsTable", "$stateParams", function project(ProjectsTable, $stateParams) {
                cov_11jt39av3r.f[28]++;
                cov_11jt39av3r.s[31]++;
                return ProjectsTable.$find($stateParams.id).$then(function (project) {
                    cov_11jt39av3r.f[29]++;
                    cov_11jt39av3r.s[32]++;
                    return project;
                }).$promise;
            }],
            proposal: ["ProposalsTable", "$stateParams", function proposal(ProposalsTable, $stateParams) {
                cov_11jt39av3r.f[30]++;
                cov_11jt39av3r.s[33]++;
                return ProposalsTable.$find($stateParams.proposal).$then(function (proposal) {
                    cov_11jt39av3r.f[31]++;
                    cov_11jt39av3r.s[34]++;
                    return proposal;
                }).$promise;
            }]
        }
    });
}